webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/**
  * EventBus
  * ========
  * Global event bus for transmitting messages application wide.
  *
  * Usage
  * -----
  * import { EventBus } from '@/EventBus.js';
  *
  * EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.'  );
  */


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/**
  * Dispatch an error Event
  *
  * @param message { string } The error message
  * @param options { array } An array of option objects
  */
EventBus.dispatchErrorEvent = function (message, options) {
  EventBus.$emit('errorEvent', message, options);
};

/**
  * Dispatch a dialog event
  *
  * @param message { string } The message
  * @param options { array } An array of option objects
  */
EventBus.dispatchDialogEvent = function (message, options) {
  EventBus.$emit('dialogEvent', message, options);
};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__ = __webpack_require__(15);




var restModel = 'retailers';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filters, filterMode, limit, sort) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  createOne: function createOne(fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel, fields, httpConfig());
  },
  replace: function replace(id, fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },
  deleteById: function deleteById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  addTeamMembers: function addTeamMembers(id, userIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/addteammembers', userIdArray, httpConfig());
  },
  removeTeamMembers: function removeTeamMembers(id, userIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/removeteammembers', userIdArray, httpConfig());
  },
  addWashrooms: function addWashrooms(id, washroomIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/addwashrooms', washroomIdArray, httpConfig());
  },
  removeWashrooms: function removeWashrooms(id, washroomIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/removewashrooms', washroomIdArray, httpConfig());
  },
  addIssues: function addIssues(id, issueIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/addissues', issueIdArray, httpConfig());
  },
  removeIssues: function removeIssues(id, issueIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/removeissues', issueIdArray, httpConfig());
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__ = __webpack_require__(15);




var restModel = 'servicerelationships';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filters, filterMode, limit, sort) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  createOne: function createOne(fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel, fields, httpConfig());
  },
  replace: function replace(id, fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },
  deleteById: function deleteById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },


  serviceAreas: [{ 'name': 'accessibility', 'description': 'Accessibility', 'imageOn': '/static/img/area__accessibility--on.svg', 'imageOff': '/static/img/area__accessibility--off.svg' }, { 'name': 'baby', 'description': 'Baby Changing', 'imageOn': '/static/img/area__baby--on.svg', 'imageOff': '/static/img/area__baby--off.svg' }, { 'name': 'bins', 'description': 'Bins', 'imageOn': '/static/img/area__bin--on.svg', 'imageOff': '/static/img/area__bin--off.svg' }, { 'name': 'doors', 'description': 'Doors', 'imageOn': '/static/img/area__door--on.svg', 'imageOff': '/static/img/area__door--off.svg' }, { 'name': 'driers', 'description': 'Hand Dryers', 'imageOn': '/static/img/area__drier--on.svg', 'imageOff': '/static/img/area__drier--off.svg' }, { 'name': 'heating', 'description': 'Heating', 'imageOn': '/static/img/area__heating--on.svg', 'imageOff': '/static/img/area__heating--off.svg' }, { 'name': 'lighting', 'description': 'Lighting', 'imageOn': '/static/img/area__light--on.svg', 'imageOff': '/static/img/area__light--off.svg' }, { 'name': 'mirror', 'description': 'Mirror', 'imageOn': '/static/img/area__mirror--on.svg', 'imageOff': '/static/img/area__mirror--off.svg' }, { 'name': 'paint', 'description': 'Paint', 'imageOn': '/static/img/area__paint--on.svg', 'imageOff': '/static/img/area__paint--off.svg' }, { 'name': 'toiletpaper', 'description': 'Toilet Paper', 'imageOn': '/static/img/area__paper--on.svg', 'imageOff': '/static/img/area__paper--off.svg' }, { 'name': 'sanitarybins', 'description': 'Sanitary Bins', 'imageOn': '/static/img/area__sanitary--on.svg', 'imageOff': '/static/img/area__sanitary--off.svg' }, { 'name': 'sinks', 'description': 'Sinks', 'imageOn': '/static/img/area__sink--on.svg', 'imageOff': '/static/img/area__sink--off.svg' }, { 'name': 'smell', 'description': 'Smell', 'imageOn': '/static/img/area__smell--on.svg', 'imageOff': '/static/img/area__smell--off.svg' }, { 'name': 'soap', 'description': 'Soap Dispensers', 'imageOn': '/static/img/area__soap--on.svg', 'imageOff': '/static/img/area__soap--off.svg' }, { 'name': 'suggestions', 'description': 'Suggestions', 'imageOn': '/static/img/area__suggestion--on.svg', 'imageOff': '/static/img/area__suggestion--off.svg' }, { 'name': 'toilet', 'description': 'Toilet', 'imageOn': '/static/img/area__toilet--on.svg', 'imageOff': '/static/img/area__toilet--off.svg' }, { 'name': 'towels', 'description': 'Towels', 'imageOn': '/static/img/area__towel--on.svg', 'imageOff': '/static/img/area__towel--off.svg' }, { 'name': 'urinals', 'description': 'Urinals', 'imageOn': '/static/img/area__urinal--on.svg', 'imageOff': '/static/img/area__urinal--off.svg' }, { 'name': 'vending', 'description': 'Vending Machines', 'imageOn': '/static/img/area__vending--on.svg', 'imageOff': '/static/img/area__vending--off.svg' }, { 'name': 'walls', 'description': 'Walls', 'imageOn': '/static/img/area__wall--on.svg', 'imageOff': '/static/img/area__wall--off.svg' }]
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

function generateFilters(filter, filterMode) {
  var filterString = null;

  if (filterMode && filterMode == 'or') {
    filterString = 'filteror=';

    for (var i in filter) {
      var filterObject = filter[i];

      for (var j in filterObject) {
        var currentFilter = 1;

        filterString += j + ':' + filterObject[j];

        if (currentFilter < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filterObject).length) {
          filterString += ',';
        }

        currentFilter++;
      }

      if (i < filter.length - 1) {
        filterString += ',';
      }
    }
  } else {
    filterString = 'filter=';
    var _currentFilter = 1;

    for (var _i in filter) {
      if (filter[_i].constructor === Array) {
        var filterArray = filter[_i];

        filterString += _i + ':';

        for (var _j in filterArray) {
          filterString += '' + filterArray[_j];

          if (_j < filterArray.length - 1) {
            filterString += '|';
          }
        }
      } else {
        filterString += _i + ':' + filter[_i];
      }

      if (_currentFilter < __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(filter).length) {
        filterString += ',';
      }

      _currentFilter++;
    }
  }

  return filterString;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  generateQueryString: function generateQueryString(filters, filterMode, limit, sort) {
    var queryString = '';

    if (filters || limit || sort) {
      queryString += '?';

      if (filters) {
        queryString += generateFilters(filters, filterMode);
      }

      if (limit) {
        if (queryString.length > 1) {
          queryString += '&';
        }

        queryString += 'limit=' + limit;
      }

      if (sort) {
        if (queryString.length > 1) {
          queryString += '&';
        }

        queryString += 'sort=' + sort;
      }
    }

    return queryString;
  }
});

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(555),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-77cb7fd3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(397)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(527),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04ba6aff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__ = __webpack_require__(15);




var restModel = 'multisites';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filters, filterMode, limit, sort) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  createOne: function createOne(fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel, fields, httpConfig());
  },
  replace: function replace(id, fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },
  deleteById: function deleteById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  addTeamMembers: function addTeamMembers(id, userIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/addteammembers', userIdArray, httpConfig());
  },
  removeTeamMembers: function removeTeamMembers(id, userIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/removeteammembers', userIdArray, httpConfig());
  },
  addRetailers: function addRetailers(id, retailersIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/addretailers', retailersIdArray, httpConfig());
  },
  removeRetailers: function removeRetailers(id, retailersIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/removeretailers', retailersIdArray, httpConfig());
  },
  getWashrooms: function getWashrooms(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id + '/washrooms', httpConfig());
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__ = __webpack_require__(15);




var restModel = 'serviceproviders';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filters, filterMode, limit, sort) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  createOne: function createOne(fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel, fields, httpConfig());
  },
  replace: function replace(id, fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },
  deleteById: function deleteById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  getAllByMultisite: function getAllByMultisite(multisiteId) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/multisite/' + multisiteId, httpConfig());
  },
  addTeamMembers: function addTeamMembers(id, userIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/addteammembers', userIdArray, httpConfig());
  },
  removeTeamMembers: function removeTeamMembers(id, userIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/removeteammembers', userIdArray, httpConfig());
  }
});

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(404)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(535),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13780882",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(414)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(546),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4838a882",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__ = __webpack_require__(15);




var restModel = 'issues';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filters, filterMode, limit, sort) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  createOne: function createOne(fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel, fields, httpConfig());
  },
  replace: function replace(id, fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },
  deleteById: function deleteById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__ = __webpack_require__(15);




var restModel = 'reviews';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filters, filterMode, limit, sort) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  createOne: function createOne(fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel, fields, httpConfig());
  },
  replace: function replace(id, fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },
  deleteById: function deleteById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  addIssues: function addIssues(id, issueIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/addissues', issueIdArray, httpConfig());
  },
  removeIssues: function removeIssues(id, issueIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/removeissues', issueIdArray, httpConfig());
  },
  getPerDay: function getPerDay(days, filters, filterMode) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/perday/' + days + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode), httpConfig());
  },
  getAverageRatingPerDay: function getAverageRatingPerDay(days, filters, filterMode) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/averageratingperday/' + days + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode), httpConfig());
  }
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__ = __webpack_require__(15);




var restModel = 'washrooms';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filters, filterMode, limit, sort) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  createOne: function createOne(fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel, fields, httpConfig());
  },
  replace: function replace(id, fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },
  deleteById: function deleteById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  getByMultisiteId: function getByMultisiteId(id, filters, filterMode) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/multisite/' + id, httpConfig());
  },
  getReviewStats: function getReviewStats(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id + '/reviewstats', httpConfig());
  },
  addIssues: function addIssues(id, issueIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/addissues', issueIdArray, httpConfig());
  },
  removeIssues: function removeIssues(id, issueIdArray) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/' + id + '/removeissues', issueIdArray, httpConfig());
  }
});

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(267),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";

/* harmony default export */ __webpack_exports__["a"] = ({
  resetPassword: function resetPassword(emailAddress) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/resetpassword', { emailAddress: emailAddress });
  },
  checkToken: function checkToken(resetToken) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/resetpassword/checktoken', { token: resetToken });
  },
  saveNewPassword: function saveNewPassword(resetToken, password) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/resetpassword/savenewpassword', { token: resetToken, password: password });
  }
});

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(553),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e37c9df",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(415)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(285),
  /* template */
  __webpack_require__(547),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b5c6f02",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";

/* harmony default export */ __webpack_exports__["a"] = ({
  authenticate: function authenticate(username, password) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/authenticate', { username: username, password: password });
  },
  checkToken: function checkToken(accessToken) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/checktoken', { accessToken: accessToken }).then(function (res) {
      if (res.data.valid && res.data.valid == true) {
        return true;
      } else {
        return false;
      }
    }).catch(function (err) {
      return false;
    });
  },
  logout: function logout(router) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/logout', { accessToken: localStorage.getItem('accessToken') }).then(function (res) {
      logoutClientSide();
    }).catch(function (err) {
      // Still logout client side even if the server failed to remove the access token
      logoutClientSide();
    });

    function logoutClientSide() {
      // Reset the route token checking
      window.initialRouteChecked = false;

      // Remove the access token from local storage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('homeRoute');
      localStorage.removeItem('parentId');
      localStorage.removeItem('userGroup');
      localStorage.removeItem('userId');
      localStorage.removeItem('userObject');

      // Redirect to the login page
      document.location.href = "/";
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__ = __webpack_require__(15);




var restModel = 'users';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filters, filterMode, limit, sort) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  createOne: function createOne(user) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel, user, httpConfig());
  },
  replace: function replace(id, fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },
  deleteById: function deleteById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  }
});

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(554),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-722bf7cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__ = __webpack_require__(15);




var restModel = 'subscriptions';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getAll: function getAll(filters, filterMode, limit, sort) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + __WEBPACK_IMPORTED_MODULE_2__services_ServiceUtilities_js__["a" /* default */].generateQueryString(filters, filterMode, limit, sort), httpConfig());
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },
  createOne: function createOne(fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel, fields, httpConfig());
  },
  replace: function replace(id, fields) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(baseUrl + '/' + restModel + '/' + id, fields, httpConfig());
  },
  deleteById: function deleteById(id) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(baseUrl + '/' + restModel + '/' + id, httpConfig());
  },


  packages: {
    bronze: {
      maxWashrooms: 5,
      accountType: 'retailer'
    },
    silver: {
      maxWashrooms: 20,
      accountType: 'retailer'
    },
    gold: {
      maxWashrooms: 100,
      accountType: 'retailer'
    },
    corporate: {
      maxWashrooms: 999999999,
      accountType: 'retailer'
    },
    basic: {
      maxWashrooms: 10000,
      accountType: 'serviceprovider'
    },
    intermediate: {
      maxWashrooms: 80000,
      accountType: 'serviceprovider'
    },
    advanced: {
      maxWashrooms: 99999999,
      accountType: 'serviceprovider'
    }
  }
});

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(407)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(539),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-278b38ff",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(307),
  /* template */
  __webpack_require__(536),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-148d5656",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(398)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(528),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-05424b5f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Login_Login_vue__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Login_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_pages_Login_Login_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Dashboard_Dashboard_vue__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Dashboard_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_pages_Dashboard_Dashboard_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Retailers_Retailers_vue__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Retailers_Retailers_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_pages_Retailers_Retailers_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_RetailersDetail_RetailersDetail_vue__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_RetailersDetail_RetailersDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_pages_RetailersDetail_RetailersDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_RetailersMulti_RetailersMulti_vue__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_RetailersMulti_RetailersMulti_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_pages_RetailersMulti_RetailersMulti_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_ServiceProviders_ServiceProviders_vue__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_ServiceProviders_ServiceProviders_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pages_ServiceProviders_ServiceProviders_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_ServiceProviderDetail_ServiceProviderDetail_vue__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_ServiceProviderDetail_ServiceProviderDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_ServiceProviderDetail_ServiceProviderDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_ServiceRelationships_ServiceRelationships_vue__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_ServiceRelationships_ServiceRelationships_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_pages_ServiceRelationships_ServiceRelationships_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Washrooms_Washrooms_vue__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_Washrooms_Washrooms_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_pages_Washrooms_Washrooms_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_Reviews_Reviews_vue__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_Reviews_Reviews_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_pages_Reviews_Reviews_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_ReviewsDetail_ReviewsDetail_vue__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_ReviewsDetail_ReviewsDetail_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_pages_ReviewsDetail_ReviewsDetail_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_Account_Account_vue__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_Account_Account_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_pages_Account_Account_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_Admin_Admin_vue__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_Admin_Admin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_pages_Admin_Admin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_ResetPassword_ResetPassword_vue__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_ResetPassword_ResetPassword_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_pages_ResetPassword_ResetPassword_vue__);




// Route Dependencies















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Login_Login_vue___default.a
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Dashboard_Dashboard_vue___default.a
  }, {
    path: '/retailers',
    name: 'Retailers',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Retailers_Retailers_vue___default.a
  }, {
    path: '/retailers/:id',
    name: 'Retailers Detail',
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_RetailersDetail_RetailersDetail_vue___default.a
  }, {
    path: '/retailers/multisite/:multisiteId',
    name: 'RetailersForMultisite',
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_Retailers_Retailers_vue___default.a
  }, {
    path: '/retailers-multi',
    name: 'Retailers Multi',
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_RetailersMulti_RetailersMulti_vue___default.a
  }, {
    path: '/service-providers',
    name: 'ServiceProviders',
    component: __WEBPACK_IMPORTED_MODULE_8__components_pages_ServiceProviders_ServiceProviders_vue___default.a
  }, {
    path: '/service-providers/:id',
    name: 'ServiceProviderDetail',
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_ServiceProviderDetail_ServiceProviderDetail_vue___default.a
  }, {
    path: '/service-relationships',
    name: 'ServiceRelationships',
    component: __WEBPACK_IMPORTED_MODULE_10__components_pages_ServiceRelationships_ServiceRelationships_vue___default.a
  }, {
    path: '/service-relationships/:id',
    name: 'ServiceRelationshipsWithId',
    component: __WEBPACK_IMPORTED_MODULE_10__components_pages_ServiceRelationships_ServiceRelationships_vue___default.a
  }, {
    path: '/washrooms',
    name: 'Washrooms',
    component: __WEBPACK_IMPORTED_MODULE_11__components_pages_Washrooms_Washrooms_vue___default.a
  }, {
    path: '/washrooms/retailer/:retailerId',
    name: 'WashroomsForRetailer',
    component: __WEBPACK_IMPORTED_MODULE_11__components_pages_Washrooms_Washrooms_vue___default.a
  }, {
    path: '/washrooms/multisite/:multisiteId',
    name: 'WashroomsForMultisite',
    component: __WEBPACK_IMPORTED_MODULE_11__components_pages_Washrooms_Washrooms_vue___default.a
  }, {
    path: '/reviews',
    name: 'Reviews',
    component: __WEBPACK_IMPORTED_MODULE_12__components_pages_Reviews_Reviews_vue___default.a
  }, {
    path: '/reviews/:id',
    name: 'ReviewsDetail',
    component: __WEBPACK_IMPORTED_MODULE_13__components_pages_ReviewsDetail_ReviewsDetail_vue___default.a
  }, {
    path: '/reviews/retailer/:retailerId',
    name: 'ReviewsForRetailer',
    component: __WEBPACK_IMPORTED_MODULE_12__components_pages_Reviews_Reviews_vue___default.a
  }, {
    path: '/reviews/washroom/:washroomId',
    name: 'ReviewsForWashroom',
    component: __WEBPACK_IMPORTED_MODULE_12__components_pages_Reviews_Reviews_vue___default.a
  }, {
    path: '/reviews/multisite/:multisiteId',
    name: 'ReviewsForMultisite',
    component: __WEBPACK_IMPORTED_MODULE_12__components_pages_Reviews_Reviews_vue___default.a
  }, {
    path: '/account',
    name: 'Account',
    component: __WEBPACK_IMPORTED_MODULE_14__components_pages_Account_Account_vue___default.a
  }, {
    path: '/admin',
    name: 'Admin',
    component: __WEBPACK_IMPORTED_MODULE_15__components_pages_Admin_Admin_vue___default.a
  }, {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: __WEBPACK_IMPORTED_MODULE_16__components_pages_ResetPassword_ResetPassword_vue___default.a
  }]
});

router.beforeEach(function (to, from, next) {
  var publicPageNames = ['Login', 'ActivateAccount', 'ResetPassword'];

  // Check if page is not allowed public access
  if (publicPageNames.indexOf(to.name) == -1) {
    if (!window.initialRouteChecked) {
      if (localStorage.getItem('accessToken')) {

        __WEBPACK_IMPORTED_MODULE_2__services_AuthenticationService__["a" /* default */].checkToken(localStorage.getItem('accessToken')).then(function (result) {
          if (result == false) {
            router.push('/?referrerurl=' + encodeURIComponent(to.fullPath));
          }

          window.initialRouteChecked = true;
          next();
        });
      } else {
        router.push('/?referrerurl=' + encodeURIComponent(to.fullPath));

        window.initialRouteChecked = true;

        next();
      }
    } else {
      next();
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(412)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(291),
  /* template */
  __webpack_require__(544),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_velocity_animate__);

// Vendor


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'staggerEntranceTransition',

  data: function data() {
    return {};
  },

  created: function created() {},

  mounted: function mounted() {},

  methods: {
    // Transitions
    // ---------------------------------------------------
    beforeEnter: function beforeEnter(el) {
      el.style.opacity = 0;
    },

    enter: function enter(el, done) {
      var delay = el.dataset.index * 22;

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(el, { opacity: 1 }, { complete: done });
      }, delay);
    },

    leave: function leave(el, done) {
      var delay = el.dataset.index * 0;

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(el, { opacity: 0 }, { complete: done });
      }, delay);
    }
  }
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'change-stat',

  props: ['heading', 'value', 'direction'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {}
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'change-stat',

  props: ['heading', 'value', 'direction', 'comment'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {}
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_IssuesService_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus_js__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'issue-badge',

  props: ['issue'],

  data: function data() {
    return {
      issueSelectorOpen: false,
      userGroup: null,
      showOverlay: false
    };
  },

  created: function created() {
    if (localStorage.getItem('userGroup')) {
      this.userGroup = localStorage.getItem('userGroup');
    }

    this.bindEvents();
  },

  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].$off('statusUpdateYesClicked' + this.issue.id);
  },

  methods: {
    bindEvents: function bindEvents() {
      var _this = this;

      // Listen for File Delete Events
      __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].$on('statusUpdateYesClicked' + this.issue.id, function (data) {
        var issueStatus = data.issueStatus;

        __WEBPACK_IMPORTED_MODULE_0__services_IssuesService_js__["a" /* default */].replace(_this.issue.id, { status: issueStatus }).then(function (res) {
          _this.issue.status = issueStatus;
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
      });
    },

    openIssueSelector: function openIssueSelector() {
      if (this.userGroup != 'multi-site-retailers') {
        this.issueSelectorOpen = true;
      }
    },

    setIssueStatus: function setIssueStatus(issueStatus) {
      var message = 'Are you sure you want to update the status of this issue to \'' + issueStatus.replace(/-/g, " ") + '\'?';

      var options = [{
        optionText: 'Yes',
        optionEvent: 'statusUpdateYesClicked' + this.issue.id,
        optionData: {
          issueStatus: issueStatus
        }
      }, {
        optionText: 'No',
        optionEvent: 'statusUpdateNoClicked',
        optionData: null
      }];

      __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].dispatchDialogEvent(message, options);

      this.issueSelectorOpen = false;
    },

    getType: function getType(issueType) {
      var typeMatrix = {
        smells1: 'No Air Fesheners',
        smells2: 'General Foul Odour',
        smells3: 'Poor Quality Air Fresheners',
        smells4: 'No Open Windows / Poor Ventilation',
        smells5: 'Sanitary / Nappy Units Emitting Foul Odours',
        disability1: 'No Disabled Washroom',
        disability2: 'Washroom Door Too Narrow for Wheelchair Access',
        disability3: 'Hand Dryer at Incorrect Height For Disabled Access',
        disability4: 'Sink / Hand Washing Facilities at Incorrect Height For Disabled Access',
        disability5: 'No Emergency Pull Cord to Alert Assistance',
        lighting1: 'Very Poor Lighting In Cubicle',
        lighting2: 'Very Poor Lighting in Main Washroom',
        heating1: 'No Hot Water',
        heating2: 'Washroom Very Cold',
        babychanging1: 'No Baby Changing Facility At All',
        babychanging2: 'No Baby Changing Facility In Gents Washroom',
        babychanging3: 'No Nappy Changing Table',
        babychanging4: 'Baby Changing Facilities Dirty and Unhygienic',
        babychanging5: 'No Nappy Disposal Unit',
        babychanging6: 'Nappy Disposal Unit Dirty and Smells',
        babychanging7: 'Nappy Disposal Unit Overflowing',
        babychanging8: 'Nappy Disposal Unit Broken',
        babychanging9: 'Nappy Disposal Unit Appears Unhygienic and I Don\'t Want To Touch It',
        cubicles1: 'Cubicle Dirty and/or Smelly',
        cubicles2: 'Faulty Lock',
        cubicles3: 'Cubicle Not Private',
        cubicles4: 'Graffiti in Cubicle',
        cubicles5: 'Cubicle Damaged / Vandalised',
        mirrors1: 'No Mirror',
        mirrors2: 'Broken Mirror',
        mirrors3: 'Mirror Too Small To Be Useful',
        mirrors4: 'Dirty Mirror',
        mirrors5: 'Mirror Sited In Awkward Place',
        decor1: 'Decor Looks Dated',
        decor2: 'Decor Looks Tired and Gives Impression Of Dirty Washroom',
        decor3: 'Pealing Paint / Wallpaper Gives Impression Washroom Is Not Important',
        decor4: 'Sealant Missing Around Sinks and Floor Edge',
        decor5: 'Poor Choice of Colours or Quality Of Overall Finish',
        wallsfloors1: 'Walls / Floors Appear Dirty And Harbour Smells',
        wallsfloors2: 'Floor Wet and Slippery',
        wallsfloors3: 'Condensation / Mould on Walls',
        wallsfloors4: 'Rubbish / Refuse on Floor',
        sanitary1: 'No Sanitary Bin Available',
        sanitary2: 'Sanitary Bin Very Dirty and Smells',
        sanitary3: 'Sanitary Bin Full and Overflowing',
        sanitary4: 'Sanitary Bin Broken',
        sanitary5: 'Sanitary Bin  Appears Unhygienic and I Don\'t Want To Touch It',
        toilet1: 'Toilet Very Dirty and Smells',
        toilet2: 'Toilet Blocked',
        toilet3: 'No Toilet Roll',
        toilet4: 'Toilet Flush Broken',
        toilet5: 'Broken Toilet Seat',
        toilet6: 'No Toilet Roll Dispenser',
        toilet7: 'Toilet / WC has Water Constantly Flowing Into Bowl',
        toilet8: 'No Dual / Reduced Flush Option on Toilet / WC',
        urinals1: 'Urinals Very Dirty and Smell',
        urinals2: 'Urinal(s) Blocked / Overflowing',
        urinals3: 'Urinials Flushing Too Frequently and Wasting Water',
        urinals4: 'Urinals Cracked / Damaged',
        urinals5: 'Urine on Floor Around Urinals',
        bins1: 'No Waste Bins',
        bins2: 'Waste Bins Overflowing',
        bins3: 'Waste Bins Appear Dirty and Harbour Smells',
        bins4: 'Waste Bin Cracked / Damaged',
        handwashing1: 'No Soap Dispensers',
        handwashing2: 'Soap Dispensers Empty',
        handwashing3: 'Soap Dispensers Broken',
        handwashing4: 'Soap Dispensers Dirty and Old',
        handwashing5: 'Bars of Soap Placed on Sink Which I Find Unhygienic',
        sink1: 'No Running Water',
        sink2: 'Sink Blocked',
        sink3: 'Tap Constantly Flowing and Wasting Water',
        sink4: 'Tap(s) Dripping',
        sink5: 'Sink Very Dirty and Smells',
        sink6: 'I Have to Hold Down Tap to Wash Hands At Same Time',
        papertowels1: 'No Paper Towels For Use',
        papertowels2: 'Paper Towel Dispenser Empty',
        papertowels3: 'Paper Towel Dispenser Broken',
        papertowels4: 'Paper Towel Dispenser Dirty and Old',
        papertowels5: 'Poor Quality Paper Towels',
        handdrying1: 'No Hand Dryers',
        handdrying2: 'Hand Dryers Not Working',
        handdrying3: 'Hand Dryers Take Too Long To Dry Hands',
        handdrying4: 'Hand Dryers Dirty and Unhygienic',
        toiletroll1: 'No Toilet Roll',
        toiletroll2: 'No Toilet Roll on Dispenser',
        toiletroll3: 'Toilet Roll Left on Cistern / Floor / Sanitary Bin and Unhygienic',
        toiletroll4: 'Toilet Roll is Poor Quality',
        toiletroll5: 'Toilet Roll in Dispenser but Cannot be Accessed',
        vendingmachines1: 'No Vending Machines',
        vendingmachines2: 'Vending Machine Broken / Jammed',
        vendingmachines3: 'Vending Machine Empty',
        vendingmachines4: 'Vending Machine Doesn\t Offer A Variety of Products',
        vendingmachines5: 'Vending Machine Does Not Accept New Types of Coins',
        suggestions1: 'I\'d Like To See A Changing Places Room',
        suggestions2: 'I\'d Like To See An Odour Control Product in the Urinal',
        suggestions3: 'I\'d Like To See Hand Sanitiser Dispenser in the Washroom',
        suggestions4: 'I\'d Like To See Toilet Seat Sanitisers in the Cubicles',
        suggestions5: 'I\'d Like To See Odour Neutralising Unit Tto Eliminate Odours and Harmful Bacteria',
        suggestions6: 'I\'d Like To See Non-Slip Matting',
        suggestions7: 'I\'d Like To See High Scented Urinal Mats',
        suggestions8: 'I\'d Like To See More Ventilation In Washroom',
        suggestions9: 'I\'d Like To See Anti-Bacterial Door Handles to Eliminate the Spread of Germs',
        customsuggestion: 'I\'d Like To See Something Else'
      };

      return typeMatrix[issueType];
    },

    getIcon: function getIcon(issueType) {
      var iconMatrix = {
        smells: '/static/img/area__smell--off.svg',
        disability: '/static/img/area__accessibility--off.svg',
        lighting: '/static/img/area__light--off.svg',
        heating: '/static/img/area__heating--off.svg',
        babychanging: '/static/img/area__baby--off.svg',
        cubicles: '/static/img/area__door--off.svg',
        mirrors: '/static/img/area__mirror--off.svg',
        decor: '/static/img/area__paint--off.svg',
        wallsfloors: '/static/img/area__wall--off.svg',
        sanitary: '/static/img/area__sanitary--off.svg',
        toilet: '/static/img/area__toilet--off.svg',
        urinals: '/static/img/area__urinal--off.svg',
        airfresheners: '/static/img/area__smell--off.svg',
        handwashing: '/static/img/area__soap--off.svg',
        sink: '/static/img/area__sink--off.svg',
        papertowels: '/static/img/area__towel--off.svg',
        handdrying: '/static/img/area__drier--off.svg',
        toiletroll: '/static/img/area__paper--off.svg',
        vendingmachines: '/static/img/area__vending--off.svg',
        suggestions: '/static/img/area__suggestion--off.svg',
        customsuggestion: '/static/img/area__suggestion--off.svg'
      };

      return iconMatrix[issueType.replace(/\d+/g, '')];
    },

    preventBubble: function preventBubble(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },

  computed: {
    image: function image() {
      return "https://s3.amazonaws.com/cleen-data" + '/img/issues/' + this.issue.s3ImageUrl;
    }
  }
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'issue-count',

  props: ['issues'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {
    issueCount: function issueCount() {
      return this.issues.length || 0;
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'issue-status-icons',

  props: ['issues'],

  data: function data() {
    return {
      currentPopover: null
    };
  },

  created: function created() {},

  methods: {
    formatStatus: function formatStatus(status) {
      status = status.replace(/-/g, " ");
      return status;
    },

    getIcon: function getIcon(issueType) {
      var iconMatrix = {
        smells: '/static/img/area__smell--off.svg',
        disability: '/static/img/area__accessibility--off.svg',
        lighting: '/static/img/area__light--off.svg',
        heating: '/static/img/area__heating--off.svg',
        babychanging: '/static/img/area__baby--off.svg',
        cubicles: '/static/img/area__door--off.svg',
        mirrors: '/static/img/area__mirror--off.svg',
        decor: '/static/img/area__paint--off.svg',
        wallsfloors: '/static/img/area__wall--off.svg',
        sanitary: '/static/img/area__sanitary--off.svg',
        toilet: '/static/img/area__toilet--off.svg',
        urinals: '/static/img/area__urinal--off.svg',
        airfresheners: '/static/img/area__smell--off.svg',
        handwashing: '/static/img/area__soap--off.svg',
        sink: '/static/img/area__sink--off.svg',
        papertowels: '/static/img/area__towel--off.svg',
        handdrying: '/static/img/area__drier--off.svg',
        toiletroll: '/static/img/area__paper--off.svg',
        vendingmachines: '/static/img/area__vending--off.svg',
        suggestions: '/static/img/area__suggestion--off.svg',
        customsuggestion: '/static/img/area__suggestion--off.svg'
      };

      return iconMatrix[issueType.replace(/\d+/g, '')];
    }
  },

  computed: {}
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_RadialProgressBar_RadialProgressBar_vue__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_RadialProgressBar_RadialProgressBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_RadialProgressBar_RadialProgressBar_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'percentage-card-contents',

  props: ['percentage', 'heading', 'count'],

  components: {
    RadialProgressBar: __WEBPACK_IMPORTED_MODULE_0__components_ui_RadialProgressBar_RadialProgressBar_vue___default.a
  },

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {}
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'review-mood',

  props: ['mood'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {}
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'review-stars',

  props: ['stars', 'active', 'large'],

  data: function data() {
    return {};
  },

  created: function created() {},

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {
    starsToShow: function starsToShow() {
      if (this.stars) {
        return this.stars;
      }

      return 5;
    }
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'scroller',

  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ServiceRelationshipsService_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'service-icons',

  props: ['serviceRelationship'],

  data: function data() {
    return {
      serviceAreas: __WEBPACK_IMPORTED_MODULE_0__services_ServiceRelationshipsService_js__["a" /* default */].serviceAreas
    };
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {}
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site-count',

  props: ['count'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {}
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'splitter',

  props: [],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {}
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'subscription-level',

  props: ['subscriptions'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {
    active: function active() {
      if (this.subscriptions && this.subscriptions.length > 0) {
        for (var i in this.subscriptions) {
          console.log('this.subscriptions[i].subscriptionTermMonths', this.subscriptions[i].subscriptionTermMonths);
          var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.subscriptions[i].createdAt);
          var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.subscriptions[i].createdAt).add(this.subscriptions[i].subscriptionTermMonths, 'months');

          console.log('startDate', startDate.format());
          console.log('endDate', endDate.format());

          if (endDate.isSameOrAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()())) {
            return true;
          }
        }
      }

      return false;
    }
  }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-icon',

  props: ['fullname'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {
    initials: function initials() {
      if (this.fullname != null) {
        var names = this.fullname.split(' ');

        // Remove empty string positions from array
        names = names.filter(function (name) {
          return name.length > 0;
        });

        var firstLetters = '';

        // If name consists of a single word
        if (names.length == 1) {
          firstLetters = names[0].substring(0, 2);
        }
        // If name consists of more than one word
        else {
            while (names.length > 0 && firstLetters.length <= 2) {
              firstLetters += names.shift()[0];
            }
          }

        return firstLetters;
      }

      return '--';
    }
  }
});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_UsersService_js__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-level-selector',

  props: ['user', 'save'],

  data: function data() {
    return {
      dropdownOpen: false
    };
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {
    toggleDropdown: function toggleDropdown() {
      if (this.dropdownOpen === true) {
        this.dropdownOpen = false;
      } else {
        this.dropdownOpen = true;
      }
    },

    saveUserLevel: function saveUserLevel(level) {
      var _this = this;

      if (this.save != false) {
        __WEBPACK_IMPORTED_MODULE_0__services_UsersService_js__["a" /* default */].replace(this.user.id, { permissionsGroup: level }).then(function (res) {
          _this.user.permissionsGroup = level;

          _this.dropdownOpen = false;
        }).catch(function (err) {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
      } else {
        this.user.permissionsGroup = level;

        this.dropdownOpen = false;
      }
    }
  },

  computed: {
    userLevel: function userLevel() {
      if (this.user.permissionsGroup == 'admin') {
        return 'Administrator';
      } else if (this.user.permissionsGroup == 'standard') {
        return 'Standard User';
      }

      return 'Select user role';
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'washroom-count-single',

  props: ['count'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {}
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'washroom-icon',

  props: ['washroom', 'washroom-type', 'large'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {},

  computed: {}
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'washrooms-count',

  props: ['washrooms', 'large'],

  data: function data() {
    return {};
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {
    countWashrooms: function countWashrooms(facilityType) {
      var washroomsFiltered = this.washrooms.filter(function (item) {
        return item.facilityType == facilityType;
      });
      return washroomsFiltered.length;
    }
  },

  computed: {}
});

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_DialogPanel_DialogPanel_vue__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_DialogPanel_DialogPanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_DialogPanel_DialogPanel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_Navigation_Navigation_vue__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_Navigation_Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_Navigation_Navigation_vue__);
// UI Components



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  components: {
    DialogPanel: __WEBPACK_IMPORTED_MODULE_0__components_ui_DialogPanel_DialogPanel_vue___default.a,
    Navigation: __WEBPACK_IMPORTED_MODULE_1__components_ui_Navigation_Navigation_vue___default.a
  },

  mounted: function mounted() {
    // App starting up on login page? If so hide navigation
    if (this.$route.name != 'Login' && this.$route.name != 'ResetPassword') {
      this.showNavigation = true;
    }
  },

  data: function data() {
    return {
      transitionName: null,
      showNavigation: false
    };
  },

  methods: {},

  watch: {
    // Watch for route changes
    '$route': function $route(to, from) {

      this.transitionName = 'fade';
      this.showNavigation = true;

      // To Login from anywhere
      if (to.name == 'Login' || to.name == 'ResetPassword') {
        this.showNavigation = false;
      }
    }
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_Scroller_Scroller_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_Scroller_Scroller_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_Scroller_Scroller_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_UserIcon_UserIcon_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_UserIcon_UserIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_UserIcon_UserIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_UserLevelSelector_UserLevelSelector_vue__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_UserLevelSelector_UserLevelSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_UserLevelSelector_UserLevelSelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_UsersService_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_RetailersService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_MultiSitesService_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ResetPasswordService_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_ServiceProvidersService_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EventBus_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_validator__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);

// Components - UI




// Services






// EventBus


// Vendor



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'account',

  components: {
    Scroller: __WEBPACK_IMPORTED_MODULE_1__components_ui_Scroller_Scroller_vue___default.a,
    UserIcon: __WEBPACK_IMPORTED_MODULE_2__components_ui_UserIcon_UserIcon_vue___default.a,
    UserLevelSelector: __WEBPACK_IMPORTED_MODULE_3__components_ui_UserLevelSelector_UserLevelSelector_vue___default.a
  },

  data: function data() {
    return {
      retailer: null,
      multisiteRetailer: null,
      serviceProvider: null,

      // Edit company info mode
      editCompanyModeActive: false,
      editCompanyRecord: null,

      // Add user mode
      addUserModeActive: false,
      addUserRecord: null,

      // Edit user mode
      editUserModeActive: false,
      editUserRecord: null
    };
  },

  created: function created() {
    this.bindEvents();
    this.init();
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  computed: {
    getActiveSubscriptionRetailer: function getActiveSubscriptionRetailer() {
      var activeSubscriptions = this.retailer.subscriptions.filter(function (s) {
        var subStartDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(s.createdAt);
        var subEndDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(s.createdAt).add(12, 'months');

        if (subEndDate.isAfter(__WEBPACK_IMPORTED_MODULE_11_moment___default()())) {
          return true;
        }
      });

      if (activeSubscriptions.length > 0) {
        return activeSubscriptions[0];
      }

      return null;
    },

    getActiveSubscriptionServiceProvider: function getActiveSubscriptionServiceProvider() {
      var activeSubscriptions = this.serviceProvider.subscriptions.filter(function (s) {
        var subStartDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(s.createdAt);
        var subEndDate = __WEBPACK_IMPORTED_MODULE_11_moment___default()(s.createdAt).add(12, 'months');

        if (subEndDate.isAfter(__WEBPACK_IMPORTED_MODULE_11_moment___default()())) {
          return true;
        }
      });

      if (activeSubscriptions.length > 0) {
        return activeSubscriptions[0];
      }

      return null;
    }
  },

  methods: {
    bindEvents: function bindEvents() {
      var _this = this;

      // Listen for User Delete Events
      __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].$on('userDeleteYesClicked', function (data) {
        __WEBPACK_IMPORTED_MODULE_4__services_UsersService_js__["a" /* default */].deleteById(data.userId).then(function (res) {
          _this.init();
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchDialogEvent('Success! The user was deleted successfully.');
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong whilst deleting the user, please try again.');
        });
      });
    },

    init: function init() {
      var _this2 = this;

      var id = localStorage.getItem('parentId'); // Is the id of the associated entity of the logged in user (retailer, multi-site-retailer, service-provider)

      if (localStorage.getItem('userGroup') == 'retailers') {
        __WEBPACK_IMPORTED_MODULE_5__services_RetailersService_js__["a" /* default */].getById(id).then(function (res) {
          res.data.team = res.data.team.sort(function (a, b) {
            if (a.fullName < b.fullName) {
              return -1;
            } else if (a.fullName > b.fullName) {
              return 1;
            }

            return 0;
          });

          _this2.retailer = res.data;
        }).catch(function (err) {});
      } else if (localStorage.getItem('userGroup') == 'multi-site-retailers') {
        __WEBPACK_IMPORTED_MODULE_6__services_MultiSitesService_js__["a" /* default */].getById(id).then(function (res) {
          res.data.team = res.data.team.sort(function (a, b) {
            if (a.fullName < b.fullName) {
              return -1;
            } else if (a.fullName > b.fullName) {
              return 1;
            }

            return 0;
          });

          _this2.multisiteRetailer = res.data;
        }).catch(function (err) {});
      } else if (localStorage.getItem('userGroup') == 'service-providers') {
        __WEBPACK_IMPORTED_MODULE_8__services_ServiceProvidersService_js__["a" /* default */].getById(id).then(function (res) {
          res.data.team = res.data.team.sort(function (a, b) {
            if (a.fullName < b.fullName) {
              return -1;
            } else if (a.fullName > b.fullName) {
              return 1;
            }

            return 0;
          });

          _this2.serviceProvider = res.data;
        }).catch(function (err) {});
      }
    },

    activateEditCompanyMode: function activateEditCompanyMode() {
      if (localStorage.getItem('userGroup') == 'retailers') {
        this.editCompanyRecord = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.retailer)); // Cheat to clone object
      } else if (localStorage.getItem('userGroup') == 'multi-site-retailers') {
        this.editCompanyRecord = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.multisiteRetailer)); // Cheat to clone object
      } else if (localStorage.getItem('userGroup') == 'service-providers') {
        this.editCompanyRecord = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.serviceProvider)); // Cheat to clone object
      }

      this.editCompanyModeActive = true;
    },

    cancelEditCompanyMode: function cancelEditCompanyMode() {
      this.editCompanyModeActive = false;
    },

    saveEditCompanyMode: function saveEditCompanyMode() {
      var _this3 = this;

      if (localStorage.getItem('userGroup') == 'retailers') {
        var updateData = {
          name: this.editCompanyRecord.name,
          contactName: this.editCompanyRecord.contactName,
          contactTelephone: this.editCompanyRecord.contactTelephone,
          contactEmail: this.editCompanyRecord.contactEmail,
          address: this.editCompanyRecord.address,
          city: this.editCompanyRecord.city,
          postcode: this.editCompanyRecord.postcode
        };

        __WEBPACK_IMPORTED_MODULE_5__services_RetailersService_js__["a" /* default */].replace(this.editCompanyRecord.id, updateData).then(function (res) {
          _this3.retailer = _this3.editCompanyRecord;
          _this3.editCompanyModeActive = false;
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchDialogEvent('Success! The company information was updated successfully.');
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong whilst saving the company information, please try again.');
        });
      } else if (localStorage.getItem('userGroup') == 'multi-site-retailers') {
        var _updateData = {
          name: this.editCompanyRecord.name,
          contactName: this.editCompanyRecord.contactName,
          contactTelephone: this.editCompanyRecord.contactTelephone,
          contactEmail: this.editCompanyRecord.contactEmail,
          contactAddress: this.editCompanyRecord.contactAddress,
          contactCity: this.editCompanyRecord.contactCity,
          contactPostcode: this.editCompanyRecord.contactPostcode
        };

        __WEBPACK_IMPORTED_MODULE_6__services_MultiSitesService_js__["a" /* default */].replace(this.editCompanyRecord.id, _updateData).then(function (res) {
          _this3.multisiteRetailer = _this3.editCompanyRecord;
          _this3.editCompanyModeActive = false;
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchDialogEvent('Success! The company information was updated successfully.');
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong whilst saving the company information, please try again.');
        });
      } else if (localStorage.getItem('userGroup') == 'service-providers') {
        var _updateData2 = {
          name: this.editCompanyRecord.name,
          contactName: this.editCompanyRecord.contactName,
          adminContactTelephone: this.editCompanyRecord.adminContactTelephone,
          adminContactEmail: this.editCompanyRecord.adminContactEmail,
          adminAddress: this.editCompanyRecord.adminAddress,
          adminCity: this.editCompanyRecord.adminCity,
          adminPostcode: this.editCompanyRecord.adminPostcode
        };

        __WEBPACK_IMPORTED_MODULE_8__services_ServiceProvidersService_js__["a" /* default */].replace(this.editCompanyRecord.id, _updateData2).then(function (res) {
          _this3.serviceProvider = _this3.editCompanyRecord;
          _this3.editCompanyModeActive = false;
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchDialogEvent('Success! The company information was updated successfully.');
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong whilst saving the company information, please try again.');
        });
      }
    },

    // Add User mode
    // ------------------------------
    activateAddUserMode: function activateAddUserMode() {
      this.addUserRecord = {
        fullName: null,
        emailAddress: null,
        permissionsGroup: null
      };

      this.addUserModeActive = true;
    },

    cancelAddUserMode: function cancelAddUserMode() {
      this.addUserModeActive = false;
    },

    saveAddUserMode: function saveAddUserMode() {
      var _this4 = this;

      if (this.validateUserRow(this.addUserRecord)) {
        if (__WEBPACK_IMPORTED_MODULE_10_validator___default.a.isEmail(this.addUserRecord.emailAddress)) {
          if (localStorage.getItem('userGroup') == 'retailers') {
            this.addUserRecord.retailer = localStorage.getItem('parentId');
          } else if (localStorage.getItem('userGroup') == 'multi-site-retailers') {
            this.addUserRecord.multiSite = localStorage.getItem('parentId');
          } else if (localStorage.getItem('userGroup') == 'service-providers') {
            this.addUserRecord.serviceProvider = localStorage.getItem('parentId');
          }

          __WEBPACK_IMPORTED_MODULE_4__services_UsersService_js__["a" /* default */].createOne(this.addUserRecord).then(function (res) {
            __WEBPACK_IMPORTED_MODULE_7__services_ResetPasswordService_js__["a" /* default */].resetPassword(_this4.addUserRecord.emailAddress).then(function (res) {
              _this4.addUserModeActive = false;
              _this4.init();
              __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchDialogEvent('Success! The user was created successfully. They will recieve an email allowing them to set their password.');
            }).catch(function (err) {
              __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong whilst creating the user, please try again.');
            });
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong whilst creating the user, please try again.');
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Sorry, the email address provided was not valid. Please check and try again.');
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Please ensure that all user fields are completed correctly before saving.');
      }
    },

    // Edit User mode
    // -------------------------
    activateEditUserMode: function activateEditUserMode(user) {
      this.editUserRecord = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user)); // Cheat deep clone object
      this.editUserModeActive = true;
    },

    cancelEditUserMode: function cancelEditUserMode() {
      this.editUserRecord = null;
      this.editUserModeActive = false;
    },

    saveEditUserMode: function saveEditUserMode() {
      var _this5 = this;

      if (this.validateUserRow(this.editUserRecord)) {
        if (__WEBPACK_IMPORTED_MODULE_10_validator___default.a.isEmail(this.editUserRecord.emailAddress)) {
          __WEBPACK_IMPORTED_MODULE_4__services_UsersService_js__["a" /* default */].replace(this.editUserRecord.id, this.editUserRecord).then(function (res) {
            _this5.editUserRecord = null;
            _this5.editUserModeActive = false;
            _this5.init();

            __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchDialogEvent('Success! The user was updated successfully. They will recieve an email allowing them to set their password.');
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong whilst creating the user, please try again.');
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Sorry, the email address provided was not valid. Please check and try again.');
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Please ensure that all user fields are completed correctly before saving.');
      }
    },

    deleteExistingUser: function deleteExistingUser(userId) {
      var message = 'Are you sure you want to delete this user?';

      var options = [{
        optionText: 'Yes',
        optionEvent: 'userDeleteYesClicked',
        optionData: {
          userId: userId
        }
      }, {
        optionText: 'No',
        optionEvent: 'userDeleteNoClicked',
        optionData: null
      }];

      __WEBPACK_IMPORTED_MODULE_9__EventBus_js__["a" /* EventBus */].dispatchDialogEvent(message, options);
    },

    // Shared Between Add and Edit Modes
    validateUserRow: function validateUserRow(userRow) {
      if (userRow.fullName == null || userRow.emailAddress == null || userRow.permissionsGroup == null) {
        return false;
      }

      if (userRow.fullName.length == 0 || userRow.emailAddress.length == 0) {
        return false;
      }

      return true;
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_Scroller_Scroller_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_Scroller_Scroller_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_Scroller_Scroller_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_UsersService__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_RetailersService__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_MultiSitesService__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_GooglePlacesService__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_SubscriptionsService__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ResetPasswordService__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_ServiceProvidersService__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_place_parser__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__EventBus_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_validator__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);

// Components - UI


// Services








// Modules


// EventBus


// Vendor




/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({

  name: 'admin',

  components: {
    Scroller: __WEBPACK_IMPORTED_MODULE_1__components_ui_Scroller_Scroller_vue___default.a
  },

  data: function data() {
    return {
      // Page
      viewMode: null,
      accountType: null,
      saving: false,

      // Shared
      user: {},

      // Service Provider
      serviceProvider: {},

      // Multisite
      searchStringRetailers: '',
      multisite: {
        retailers: []
      },
      retailerResults: [],

      // Retailer
      searchString: null,
      textSearchDebounce: null,
      placeResults: []
    };
  },

  created: function created() {
    // Retailers - Search google places
    this.textSearchDebounce = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.debounce(function (scope) {
      scope.places = null;

      __WEBPACK_IMPORTED_MODULE_5__services_GooglePlacesService__["a" /* default */].textSearch(scope.searchString).then(function (res) {
        scope.placeResults = res.data;
      });
    }, 750);
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  computed: {},

  methods: {
    openCreateAccount: function openCreateAccount(accountType) {
      this.viewMode = 'createAccount';
      this.accountType = accountType;

      if (accountType == 'multisite') {
        this.getRetailers();
      }
    },

    resetComponent: function resetComponent() {
      // Page
      this.viewMode = null;
      this.accountType = null;
      this.saving = false;

      // Shared
      this.user = {};

      // Service Provider
      this.serviceProvider = {};

      // Multisite
      this.multisite = {
        retailers: []
      };
      this.searchStringRetailers = null;
      this.retailerResults = [];

      // Retailer
      this.searchString = null;
      this.placeResults = [];
    },

    // Retailer methods
    // ----------------
    search: function search() {
      if (!this.searchString || this.searchString && this.searchString.trim().length == 0) {
        this.textSearchDebounce.cancel();
        return;
      }

      this.textSearchDebounce(this);
    },

    doCreateRetailer: function doCreateRetailer(place) {
      var _this = this;

      if (!this.user.fullName || this.user.fullName && this.user.fullName.trim().length == 0) {
        __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! You must provide a full name.');
      } else {
        if (!this.user.emailAddress || this.user.emailAddress && this.user.emailAddress.trim().length == 0 || !__WEBPACK_IMPORTED_MODULE_11_validator___default.a.isEmail(this.user.emailAddress)) {
          __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! You must provide a valid email address.');
        } else {
          this.saving = true;

          __WEBPACK_IMPORTED_MODULE_2__services_UsersService__["a" /* default */].getAll({ emailAddress: encodeURIComponent(this.user.emailAddress) }).then(function (res) {
            if (res.data.length > 0) {
              __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! A user already exists with the provided email address.');
              _this.saving = false;
            } else {
              // Create Retailer if not already exists (lookup place id)
              __WEBPACK_IMPORTED_MODULE_3__services_RetailersService__["a" /* default */].getAll({ googlePlaceId: place.place_id }).then(function (res) {
                console.log('res', res);
                if (res.data.length == 0) {
                  // Get place information from GoogleMapsService
                  __WEBPACK_IMPORTED_MODULE_5__services_GooglePlacesService__["a" /* default */].getPlaceDetails(place.place_id).then(function (res) {
                    var place = res.data;
                    var parsedPlace = __WEBPACK_IMPORTED_MODULE_9__modules_place_parser__["a" /* default */].parsePlace(res.data);

                    var retailerToCreate = {
                      googlePlaceId: place.place_id,
                      name: place.name,
                      address: parsedPlace.address,
                      city: parsedPlace.city || parsedPlace.county,
                      postcode: parsedPlace.zip_code,
                      lat: place.geometry.location.lat,
                      lng: place.geometry.location.lng
                    };

                    // Create retailer
                    __WEBPACK_IMPORTED_MODULE_3__services_RetailersService__["a" /* default */].createOne(retailerToCreate).then(function (res) {
                      var subscriptionData = {
                        type: 'retailer',
                        package: 'corporate',
                        retailer: res.data.id,
                        subscriptionTermMonths: 12
                      };

                      _this.createSubscription(subscriptionData);
                    });
                  });
                }
                // Retailer with this Place ID already exists
                else {
                    var subscriptionData = {
                      type: 'retailer',
                      package: 'corporate',
                      retailer: res.data[0].id,
                      subscriptionTermMonths: 12
                    };

                    _this.createSubscription(subscriptionData);
                  }
              });
            }
          }).catch(function (err) {
            _this.saving = false;
            __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please check your information and try again.');
          });
        }
      }
    },

    // Multisite Retailer methods
    // --------------------------
    getRetailers: function getRetailers() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__services_RetailersService__["a" /* default */].getAll(null, null, null, 'name ASC').then(function (res) {
        _this2.retailerResults = res.data;
      });
    },

    addRetailerToMultisite: function addRetailerToMultisite(retailer) {
      console.log('add retailer running...');
      var matches = this.multisite.retailers.find(function (item) {
        return item.id == retailer.id;
      });

      if (!matches) {
        this.multisite.retailers.push(retailer);
      }
    },

    removeRetailerFromMultisite: function removeRetailerFromMultisite(index) {
      this.multisite.retailers.splice(index, 1);
    },

    doCreateMultisite: function doCreateMultisite() {
      var _this3 = this;

      if (!this.user.fullName || this.user.fullName && this.user.fullName.trim().length == 0) {
        __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! You must provide a full name.');
      } else {
        if (!this.user.emailAddress || this.user.emailAddress && this.user.emailAddress.trim().length == 0 || !__WEBPACK_IMPORTED_MODULE_11_validator___default.a.isEmail(this.user.emailAddress)) {
          __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! You must provide a valid email address.');
        } else {
          this.saving = true;

          __WEBPACK_IMPORTED_MODULE_2__services_UsersService__["a" /* default */].getAll({ emailAddress: encodeURIComponent(this.user.emailAddress) }).then(function (res) {
            if (res.data.length > 0) {
              __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! A user already exists with the provided email address.');
              _this3.saving = false;
            } else if (!_this3.multisite.name || _this3.multisite.name && _this3.multisite.name.trim().length == 0) {
              __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! You must provide a name to create a service provider.');
              _this3.saving = false;
            } else {
              var multisiteToCreate = {
                name: _this3.multisite.name
              };

              // Create retailer
              __WEBPACK_IMPORTED_MODULE_4__services_MultiSitesService__["a" /* default */].createOne(multisiteToCreate).then(function (res) {
                console.log('Create Multisite complete');

                _this3.doSetMultisiteForRetailers(res.data.id);
                _this3.createUser({ type: 'multisite', multisite: res.data.id });
              });
            }
          }).catch(function (err) {
            _this3.saving = false;
            __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please check your information and try again.');
          });
        }
      }
    },

    doSetMultisiteForRetailers: function doSetMultisiteForRetailers(multisiteId) {
      for (var r in this.multisite.retailers) {
        __WEBPACK_IMPORTED_MODULE_3__services_RetailersService__["a" /* default */].replace(this.multisite.retailers[r].id, { multiSite: multisiteId }).then(function (res) {
          console.log('updated retailer to multisite', res.data.id);
        });
      }
    },

    // Service Provider methods
    // ------------------------
    doCreateServiceProvider: function doCreateServiceProvider() {
      var _this4 = this;

      if (!this.user.fullName || this.user.fullName && this.user.fullName.trim().length == 0) {
        __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! You must provide a full name.');
      } else {
        if (!this.user.emailAddress || this.user.emailAddress && this.user.emailAddress.trim().length == 0 || !__WEBPACK_IMPORTED_MODULE_11_validator___default.a.isEmail(this.user.emailAddress)) {
          __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! You must provide a valid email address.');
        } else {
          this.saving = true;

          __WEBPACK_IMPORTED_MODULE_2__services_UsersService__["a" /* default */].getAll({ emailAddress: encodeURIComponent(this.user.emailAddress) }).then(function (res) {
            if (res.data.length > 0) {
              __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! A user already exists with the provided email address.');
              _this4.saving = false;
            } else if (!_this4.serviceProvider.name || _this4.serviceProvider.name && _this4.serviceProvider.name.trim().length == 0) {
              __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Error! You must provide a name to create a service provider.');
              _this4.saving = false;
            } else {
              var serviceProviderToCreate = {
                name: _this4.serviceProvider.name
              };

              // Create retailer
              __WEBPACK_IMPORTED_MODULE_8__services_ServiceProvidersService__["a" /* default */].createOne(serviceProviderToCreate).then(function (res) {
                console.log('Create Service Provider complete');

                var subscriptionData = {
                  type: 'serviceProvider',
                  package: 'advanced',
                  serviceProvider: res.data.id,
                  subscriptionTermMonths: 12
                };

                _this4.createSubscription(subscriptionData);
              });
            }
          }).catch(function (err) {
            _this4.saving = false;
            __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please check your information and try again.');
          });
        }
      }
    },

    // Shared methods
    // --------------
    createSubscription: function createSubscription(subscriptionData) {
      var _this5 = this;

      console.log('creating subscription...');

      __WEBPACK_IMPORTED_MODULE_6__services_SubscriptionsService__["a" /* default */].createOne(subscriptionData).then(function (res) {
        _this5.createUser(subscriptionData);
      });
    },

    createUser: function createUser(userData) {
      var _this6 = this;

      console.log('creating user...');

      var newUser = {
        emailAddress: this.user.emailAddress,
        fullName: this.user.fullName,
        permissionsGroup: 'admin'
      };

      if (userData.type == 'retailer') {
        newUser.retailer = userData.retailer;
      } else if (userData.type == 'serviceProvider') {
        newUser.serviceProvider = userData.serviceProvider;
      } else if (userData.type == 'multisite') {
        newUser.multiSite = userData.multisite;
      }

      __WEBPACK_IMPORTED_MODULE_2__services_UsersService__["a" /* default */].createOne(newUser).then(function (res) {
        __WEBPACK_IMPORTED_MODULE_7__services_ResetPasswordService__["a" /* default */].resetPassword(newUser.emailAddress).then(function (res) {
          __WEBPACK_IMPORTED_MODULE_10__EventBus_js__["a" /* EventBus */].dispatchDialogEvent('Success! The account was created successfully.');
          _this6.resetComponent();
        });
      });
    }
  }

}, 'computed', {
  retailerResultsFiltered: function retailerResultsFiltered() {
    var _this7 = this;

    if (!this.searchStringRetailers || this.searchStringRetailers && this.searchStringRetailers.trim().length == 0) {
      return this.retailerResults;
    } else {
      return this.retailerResults.filter(function (item) {
        if (item.name.toLowerCase().indexOf(_this7.searchStringRetailers.toLowerCase()) > -1) {
          console.log(item.name, ' has ', _this7.searchStringRetailers);
          return true;
        }

        return false;
      });
    }
  }
}));

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_UserIcon_UserIcon_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_UserIcon_UserIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_UserIcon_UserIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_ChangeStat_ChangeStat_vue__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_ChangeStat_ChangeStat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_ChangeStat_ChangeStat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_ChangeStatLarge_ChangeStatLarge_vue__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_ChangeStatLarge_ChangeStatLarge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ui_ChangeStatLarge_ChangeStatLarge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_LineChart_LineChart_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_LineChart_LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_LineChart_LineChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_PercentageCardContents_PercentageCardContents_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_PercentageCardContents_PercentageCardContents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ui_PercentageCardContents_PercentageCardContents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_MultiSitesService_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_ServiceProvidersService_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_ServiceRelationshipsService_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_IssuesService_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__EventBus_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);


var _name$components$crea;

// UI Components



// UI Components (Widgets)





// Services







// EventBus


// Vendor


/* harmony default export */ __webpack_exports__["default"] = (_name$components$crea = {

  name: 'Dashboard',

  components: {
    ChangeStat: __WEBPACK_IMPORTED_MODULE_3__components_ui_ChangeStat_ChangeStat_vue___default.a,
    ChangeStatLarge: __WEBPACK_IMPORTED_MODULE_4__components_ui_ChangeStatLarge_ChangeStatLarge_vue___default.a,
    ReviewStars: __WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_5__components_ui_LineChart_LineChart_vue___default.a,
    UserIcon: __WEBPACK_IMPORTED_MODULE_2__components_ui_UserIcon_UserIcon_vue___default.a,
    PercentageCardContents: __WEBPACK_IMPORTED_MODULE_6__components_ui_PercentageCardContents_PercentageCardContents_vue___default.a
  },

  created: function created() {},

  beforeDestroy: function beforeDestroy() {}

}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$crea, 'created', function created() {
  if (this.userGroup == 'retailers') {
    this.initRetailer();
  } else if (this.userGroup == 'multi-site-retailers') {
    this.initMultisite();
  } else if (this.userGroup == 'service-providers') {
    this.initServiceProvider();
  } else if (this.userGroup == 'hsg-admins') {
    this.initHsgAdmin();
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$crea, 'mounted', function mounted() {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$crea, 'data', function data() {
  return {
    // Parse LocalStorage
    userGroup: localStorage.getItem('userGroup'),
    parentId: localStorage.getItem('parentId'),

    // Retailer data
    retailer: {
      // State
      activeChart: 1,

      // Widgets
      totalReviews: null,
      recentReviews: null,
      recentReviewsData: null,
      totalIssues: null,
      recentIssues: null,
      totalOpenIssues: null,
      totalClosedIssues: null,

      // Charts
      recentReviewsPerDay: null,
      recentAverageRatingPerDay: null
    },

    // Multisite data
    multisite: {
      // State
      activeChart: 1,

      // Widgets
      totalRetailers: null,
      newRetailers: null,
      totalReviews: null,
      recentReviews: null,
      recentReviewsData: null,
      totalIssues: null,
      recentIssues: null,
      totalOpenIssues: null,
      totalClosedIssues: null,

      // Charts
      recentReviewsPerDay: null,
      recentAverageRatingPerDay: null
    },

    // ServiceProvider data
    serviceProvider: {
      // State
      activeChart: 1,

      // Widgets
      totalRetailers: null,
      recentRetailers: null,
      totalMultisiteRetailers: null,
      recentMultisiteRetailers: null,
      totalReviews: null,
      recentReviews: null,
      recentReviewsData: null,
      totalIssues: null,
      totalOpenIssues: null,
      totalClosedIssues: null,

      // Charts
      recentReviewsPerDay: null,
      recentAverageRatingPerDay: null
    },

    // HSG Admin data
    hsgadmin: {
      // State
      activeChart: 1,

      // Widgets
      totalRetailers: null,
      newRetailers: null,
      totalMultisiteRetailers: null,
      newMultisiteRetailers: null,
      totalServiceProviders: null,
      newServiceProviders: null,
      totalReviews: null,
      totalIssues: null,

      // Charts
      recentReviewsPerDay: null,
      recentAverageRatingPerDay: null
    }
  };
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$crea, 'computed', {
  retailerTotalOpenIssuesPercentage: function retailerTotalOpenIssuesPercentage() {
    return this.retailer.totalOpenIssues / this.retailer.totalIssues * 100;
  },

  retailerTotalClosedIssuesPercentage: function retailerTotalClosedIssuesPercentage() {
    return this.retailer.totalClosedIssues / this.retailer.totalIssues * 100;
  },

  multisiteTotalOpenIssuesPercentage: function multisiteTotalOpenIssuesPercentage() {
    return this.multisite.totalOpenIssues / this.multisite.totalIssues * 100;
  },

  multisiteTotalClosedIssuesPercentage: function multisiteTotalClosedIssuesPercentage() {
    return this.multisite.totalClosedIssues / this.multisite.totalIssues * 100;
  },

  serviceProviderTotalOpenIssuesPercentage: function serviceProviderTotalOpenIssuesPercentage() {
    return this.serviceProvider.totalOpenIssues / this.serviceProvider.totalIssues * 100;
  },

  serviceProviderTotalClosedIssuesPercentage: function serviceProviderTotalClosedIssuesPercentage() {
    return this.serviceProvider.totalClosedIssues / this.serviceProvider.totalIssues * 100;
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_name$components$crea, 'methods', {
  initRetailer: function initRetailer() {
    var _this = this;

    var startDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()().subtract(1, 'weeks').unix() * 1000;

    // Total Reviews
    // -------------
    __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__["a" /* default */].getAll({ retailer: this.parentId }, null, null, 'createdAt DESC').then(function (res) {
      _this.retailer.totalReviews = res.data.length;

      // Recent Reviews
      // ---------------------
      var reviewsLast7Days = res.data.filter(function (r) {
        if (r.createdAt > startDate) {
          return true;
        }
      });

      _this.retailer.recentReviews = reviewsLast7Days.length;

      // Recent Reviews (Data) for List
      // ------------------------------
      _this.retailer.recentReviewsData = res.data.slice(0, 4);
    });

    // Reviews Per Day (Chart Data)
    // ----------------------------
    __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__["a" /* default */].getPerDay(7, { retailer: this.parentId }, null, null, 'createdAt ASC').then(function (res) {
      _this.retailer.recentReviewsPerDay = res.data;
    });

    // Average Rating Per Day (Chart Data)
    // -----------------------------------
    __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__["a" /* default */].getAverageRatingPerDay(7, { retailer: this.parentId }, null, null, 'createdAt ASC').then(function (res) {
      _this.retailer.recentAverageRatingPerDay = res.data;
    });

    // Total Issues
    // ------------
    __WEBPACK_IMPORTED_MODULE_12__services_IssuesService_js__["a" /* default */].getAll({ retailer: this.parentId }, null, null, 'createdAt ASC').then(function (res) {
      _this.retailer.totalIssues = res.data.length;

      // Recent Issues
      // ---------------------
      var issuesLast7Days = res.data.filter(function (i) {
        if (i.createdAt > startDate) {
          return true;
        }
      });

      _this.retailer.recentIssues = issuesLast7Days.length;

      var openIssueStatuses = ['unread', 'resolved-by-retailer', 'confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];

      var closedIssueStatuses = ['denied', 'resolution-accepted'];

      // Open Issues
      // -----------
      var totalOpenIssues = res.data.filter(function (i) {
        if (openIssueStatuses.indexOf(i.status) > -1) {
          return true;
        }

        return false;
      });

      _this.retailer.totalOpenIssues = totalOpenIssues.length;

      // Closed Issues
      // -------------
      var totalClosedIssues = res.data.filter(function (i) {
        if (closedIssueStatuses.indexOf(i.status) > -1) {
          return true;
        }

        return false;
      });

      _this.retailer.totalClosedIssues = totalClosedIssues.length;
    });
  },

  initMultisite: function initMultisite() {
    var _this2 = this;

    var startDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()().subtract(1, 'weeks').unix() * 1000;

    __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__["a" /* default */].getAll({ multiSite: this.parentId }).then(function (res) {
      // Total Retailers
      // ---------------
      _this2.multisite.totalRetailers = res.data.length;

      // New Retailers (last 7 days)
      // ---------------------------
      var retailersLast7Days = res.data.filter(function (r) {
        if (r.createdAt > startDate) {
          return true;
        }
      });

      _this2.multisite.newRetailers = retailersLast7Days.length;

      // Filter for Reviews and Issues
      var reviewFilters = [];

      for (var r in res.data) {
        reviewFilters.push({ retailer: res.data[r].id });
      }

      // Total Reviews
      // -------------
      __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__["a" /* default */].getAll(reviewFilters, 'or', null, 'createdAt DESC').then(function (res) {
        _this2.multisite.totalReviews = res.data.length;

        // Recent Reviews
        // ---------------------
        var reviewsLast7Days = res.data.filter(function (r) {
          if (r.createdAt > startDate) {
            return true;
          }
        });

        _this2.multisite.recentReviews = reviewsLast7Days.length;

        // Recent Reviews (Data) for List
        // ------------------------------
        _this2.multisite.recentReviewsData = res.data.slice(0, 4);
      });

      // Reviews Per Day (Chart Data)
      // ----------------------------
      __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__["a" /* default */].getPerDay(7, reviewFilters, 'or', null, 'createdAt ASC').then(function (res) {
        _this2.multisite.recentReviewsPerDay = res.data;
      });

      // Average Rating Per Day (Chart Data)
      // -----------------------------------
      __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__["a" /* default */].getAverageRatingPerDay(7, reviewFilters, 'or', null, 'createdAt ASC').then(function (res) {
        _this2.multisite.recentAverageRatingPerDay = res.data;
      });

      // Total Issues
      // ------------
      __WEBPACK_IMPORTED_MODULE_12__services_IssuesService_js__["a" /* default */].getAll(reviewFilters, 'or', null, 'createdAt ASC').then(function (res) {
        _this2.multisite.totalIssues = res.data.length;

        // Recent Issues
        // ---------------------
        var issuesLast7Days = res.data.filter(function (i) {
          if (i.createdAt > startDate) {
            return true;
          }
        });

        _this2.multisite.recentIssues = issuesLast7Days.length;

        var openIssueStatuses = ['unread', 'resolved-by-retailer', 'confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];

        var closedIssueStatuses = ['denied', 'resolution-accepted'];

        // Open Issues
        // -----------
        var totalOpenIssues = res.data.filter(function (i) {
          if (openIssueStatuses.indexOf(i.status) > -1) {
            return true;
          }

          return false;
        });

        _this2.multisite.totalOpenIssues = totalOpenIssues.length;

        // Closed Issues
        // -------------
        var totalClosedIssues = res.data.filter(function (i) {
          if (closedIssueStatuses.indexOf(i.status) > -1) {
            return true;
          }

          return false;
        });

        _this2.multisite.totalClosedIssues = totalClosedIssues.length;
      });
    }).catch(function (err) {});
  },

  initServiceProvider: function initServiceProvider() {
    var _this3 = this;

    var startDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()().subtract(1, 'weeks').unix() * 1000;

    __WEBPACK_IMPORTED_MODULE_10__services_ServiceRelationshipsService_js__["a" /* default */].getAll({ serviceProvider: this.parentId, status: 'approved' }).then(function (res) {
      var retailersFilter = [];

      for (var i in res.data) {
        retailersFilter.push({ id: res.data[i].retailer.id });
      }

      __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__["a" /* default */].getAll(retailersFilter, 'or').then(function (res) {
        // Total Retailers
        // ---------------
        _this3.serviceProvider.totalRetailers = res.data.length;

        // New Retailers (last 7 days)
        // ---------------------------
        var retailersLast7Days = res.data.filter(function (r) {
          if (r.createdAt > startDate) {
            return true;
          }
        });

        _this3.serviceProvider.recentRetailers = retailersLast7Days.length;

        // Multisite and Review Filters
        // ----------------------------
        var retailerIds = [];
        var multisiteFilters = [];
        var reviewFilters = [];

        // Get DISTINCT ids of retailers that this SP services
        for (var _i in res.data) {
          reviewFilters.push({ retailer: res.data[_i].id });

          // If we have a multisite ID
          if (res.data[_i].retailer && res.data[_i].multiSite) {
            if (retailerIds.indexOf(res.data[_i].retailer.multiSite) == -1) {
              retailerIds.push(res.data[_i].retailer.multiSite);

              multisiteFilters.push({ id: res.data[_i].retailer.multiSite });
            }
          }
        }

        // Total Multisites
        // ----------------
        if (multisiteFilters.length > 0) {
          __WEBPACK_IMPORTED_MODULE_8__services_MultiSitesService_js__["a" /* default */].getAll(multisiteFilters, 'or', null, 'name ASC').then(function (res) {
            _this3.serviceProvider.totalMultisiteRetailers = res.data.length;

            // New Multisite Retailers (last 7 days)
            // -------------------------------------
            var multisiteRetailersLast7Days = res.data.filter(function (r) {
              if (r.createdAt > startDate) {
                return true;
              }
            });

            _this3.serviceProvider.recentMultisiteRetailers = multisiteRetailersLast7Days.length;
          });
        } else {
          _this3.serviceProvider.totalMultisiteRetailers = 0;
          _this3.serviceProvider.recentMultisiteRetailers = 0;
        }

        // Total Reviews
        // -------------
        if (reviewFilters.length > 0) {
          __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__["a" /* default */].getAll(reviewFilters, 'or', null, 'createdAt DESC').then(function (res) {
            var issueStatuses = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];

            var matchingReviews = res.data.filter(function (item) {
              for (var _i2 in item.issues) {
                if (item.issues[_i2].serviceProvider == _this3.parentId && issueStatuses.indexOf(item.issues[_i2].status) > -1) {
                  return true;
                }
              }

              return false;
            });

            _this3.serviceProvider.totalReviews = matchingReviews.length;

            // New Reviews (last 7 days)
            // -------------------------
            var reviewsLast7Days = matchingReviews.filter(function (r) {
              if (r.createdAt > startDate) {
                return true;
              }
            });

            _this3.serviceProvider.recentReviews = reviewsLast7Days.length;

            // Recent Reviews (Table Data)
            // ---------------------------
            _this3.serviceProvider.recentReviewsData = matchingReviews.sort(function (a, b) {
              if (a.createdAt > b.createdAt) {
                return -1;
              }
              if (a.createdAt < b.createdAt) {
                return 1;
              }

              return 0;
            });

            // Reviews Over Time (Chart Data)
            // ------------------------------
            var a = __WEBPACK_IMPORTED_MODULE_14_moment___default()().subtract(6, 'days').hours(0).minutes(0).seconds(0);
            var b = __WEBPACK_IMPORTED_MODULE_14_moment___default()().add(1, 'days').hours(0).minutes(0).seconds(0);

            var results = [];

            // Iterate over each day until now

            var _loop = function _loop(m) {
              var reviewsForDay = {
                date: m.format('D.M.Y'),
                timestamp: m.valueOf()
              };

              reviewsForDay.reviews = matchingReviews.filter(function (r) {
                var reviewDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()(r.createdAt).hours(0).minutes(0).seconds(0);

                if (reviewDate.isSame(m, 'day')) {
                  return true;
                }

                return false;
              });

              results.push(reviewsForDay);
            };

            for (var m = __WEBPACK_IMPORTED_MODULE_14_moment___default()(a); m.isBefore(b); m.add(1, 'days')) {
              _loop(m);
            }

            _this3.serviceProvider.recentReviewsPerDay = results;

            // Average Rating Over Time (Chart Data)
            // -------------------------------------
            var avgA = __WEBPACK_IMPORTED_MODULE_14_moment___default()().subtract(6, 'days').hours(0).minutes(0).seconds(0);
            var avgB = __WEBPACK_IMPORTED_MODULE_14_moment___default()().add(1, 'days').hours(0).minutes(0).seconds(0);

            var avgResults = [];

            // Iterate over each day until now

            var _loop2 = function _loop2(m) {
              var totalScore = 0;

              var reviewsForDay = matchingReviews.filter(function (r) {
                var reviewDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()(r.createdAt).hours(0).minutes(0).seconds(0);

                if (reviewDate.isSameOrBefore(m, 'day')) {
                  return true;
                }

                return false;
              });

              for (var _i6 in reviewsForDay) {
                totalScore += reviewsForDay[_i6].overallRating;
              }

              var averageRating = totalScore / reviewsForDay.length || 0;

              // Push result for day onto response data
              avgResults.push({
                date: m.format('D.M.Y'),
                timestamp: m.valueOf(),
                averageRating: Math.round(averageRating * 10) / 10
              });
            };

            for (var m = __WEBPACK_IMPORTED_MODULE_14_moment___default()(avgA); m.isBefore(avgB); m.add(1, 'days')) {
              _loop2(m);
            }

            _this3.serviceProvider.recentAverageRatingPerDay = avgResults;

            // Total Issues
            // ------------
            var issueCount = 0;
            for (var _i3 in res.data) {
              var matchingIssues = res.data[_i3].issues.filter(function (item) {
                if (item.serviceProvider == _this3.parentId && item.status != 'unread' && item.status != 'denied') {
                  return true;
                }

                return false;
              });
              issueCount += matchingIssues.length;
            }
            _this3.serviceProvider.totalIssues = issueCount;

            // Open Issues
            // ------------
            var openIssueCount = 0;
            for (var _i4 in res.data) {
              var matchingOpenIssues = res.data[_i4].issues.filter(function (item) {
                if (item.serviceProvider == _this3.parentId && issueStatuses.indexOf(item.status) > -1) {
                  return true;
                }

                return false;
              });

              openIssueCount += matchingOpenIssues.length;
            }
            _this3.serviceProvider.totalOpenIssues = openIssueCount;

            // Closed Issues
            // -------------
            var closedIssueCount = 0;
            for (var _i5 in res.data) {
              var matchingClosedIssues = res.data[_i5].issues.filter(function (item) {
                if (item.serviceProvider == _this3.parentId && item.status == 'resolution-accepted') {
                  return true;
                }

                return false;
              });

              closedIssueCount += matchingClosedIssues.length;
            }
            _this3.serviceProvider.totalClosedIssues = closedIssueCount;
          });
        } else {
          _this3.serviceProvider.totalReviews = 0;
          _this3.serviceProvider.recentReviews = 0;
        }
      });
    });
  },

  initHsgAdmin: function initHsgAdmin() {
    var _this4 = this;

    var startDate = __WEBPACK_IMPORTED_MODULE_14_moment___default()().subtract(1, 'weeks').unix() * 1000;

    // Reviews Per Day (Chart Data)
    // ----------------------------
    __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__["a" /* default */].getPerDay(7, null, null, null, 'createdAt DESC').then(function (res) {
      _this4.hsgadmin.recentReviewsPerDay = res.data;
    });

    __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__["a" /* default */].getAll().then(function (res) {
      // Total Retailers
      // ---------------
      _this4.hsgadmin.totalRetailers = res.data.length;

      // New Retailers (last 7 days)
      // ---------------------------
      var retailersLast7Days = res.data.filter(function (r) {
        if (r.createdAt > startDate) {
          return true;
        }
      });

      _this4.hsgadmin.newRetailers = retailersLast7Days.length;
    });

    __WEBPACK_IMPORTED_MODULE_8__services_MultiSitesService_js__["a" /* default */].getAll().then(function (res) {
      // Total Multisites
      // ---------------
      _this4.hsgadmin.totalMultisiteRetailers = res.data.length;

      // New Multisites (last 7 days)
      // ---------------------------
      var retailersLast7Days = res.data.filter(function (r) {
        if (r.createdAt > startDate) {
          return true;
        }
      });

      _this4.hsgadmin.newMultisiteRetailers = retailersLast7Days.length;
    });

    __WEBPACK_IMPORTED_MODULE_9__services_ServiceProvidersService_js__["a" /* default */].getAll().then(function (res) {
      // Total Service Provders
      // ----------------------
      _this4.hsgadmin.totalServiceProviders = res.data.length;

      // New Service Provders (last 7 days)
      // ----------------------------------
      var retailersLast7Days = res.data.filter(function (r) {
        if (r.createdAt > startDate) {
          return true;
        }
      });

      _this4.hsgadmin.newServiceProviders = retailersLast7Days.length;
    });

    // Total Reviews
    // -------------
    __WEBPACK_IMPORTED_MODULE_11__services_ReviewsService_js__["a" /* default */].getAll(null, null, null, 'createdAt DESC').then(function (res) {
      _this4.hsgadmin.totalReviews = res.data.length;
    });

    // Total Issues
    // ------------
    __WEBPACK_IMPORTED_MODULE_12__services_IssuesService_js__["a" /* default */].getAll(null, null, null, 'createdAt ASC').then(function (res) {
      _this4.hsgadmin.totalIssues = res.data.length;
    });
  },

  // Utility methods
  timestampToDateShort: function timestampToDateShort(timestamp) {
    return __WEBPACK_IMPORTED_MODULE_14_moment___default()(timestamp).format('D.M.Y');
  },

  reviewsPerDayLabels: function reviewsPerDayLabels(data) {
    if (data !== null) {
      var labels = [];

      for (var i in data) {
        labels.push(__WEBPACK_IMPORTED_MODULE_14_moment___default()(data[i].timestamp).format('ddd'));
      }

      return labels;
    }

    return null;
  },

  reviewsPerDayPlots: function reviewsPerDayPlots(data) {
    if (data !== null) {
      var plots = [];

      for (var i in data) {
        plots.push(data[i].reviews.length);
      }

      return plots;
    }

    return null;
  },

  averageRatingPerDayLabels: function averageRatingPerDayLabels(data) {
    if (data !== null) {
      var labels = [];

      for (var i in data) {
        labels.push(__WEBPACK_IMPORTED_MODULE_14_moment___default()(data[i].timestamp).format('ddd'));
      }

      return labels;
    }

    return null;
  },

  averageRatingPerDayPlots: function averageRatingPerDayPlots(data) {
    if (data !== null) {
      var plots = [];

      for (var i in data) {
        plots.push(data[i].averageRating);
      }

      return plots;
    }

    return null;
  }
}), _name$components$crea);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_AuthenticationService__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ResetPasswordService__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EventBus_js__ = __webpack_require__(3);

/**
  * Login page
  * ==========
  *
  */

// Services



// Event Bus


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'login',

  components: {},

  data: function data() {
    return {
      mode: 'login',

      // Login Mode
      email: null,
      password: null,
      loginActive: false,

      // Reset Password Mode
      emailReset: null,
      passwordResetSent: false
    };
  },

  mounted: function mounted() {
    this.$refs.inputEmail.focus();
  },

  methods: {

    /**
      * Log the user in
      */
    doLogin: function doLogin() {
      var _this = this;

      // Currently processing login (used to display the loading animation)
      this.loginActive = true;
      // Authenticate
      __WEBPACK_IMPORTED_MODULE_1__services_AuthenticationService__["a" /* default */].authenticate(this.email, this.password).then(function (res) {
        if (res && res.status == 200) {
          // Login was successful
          localStorage.setItem('accessToken', res.data.token);
          localStorage.setItem('userId', res.data.user.userId);
          localStorage.setItem('userGroup', res.data.user.group);
          localStorage.setItem('userObject', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.data.user));

          var route = null;
          var id = null;

          switch (res.data.user.group) {
            case 'retailers':
              // route = 'retailers';
              route = 'dashboard';
              id = res.data.user.retailer;
              break;

            case 'multi-site-retailers':
              // route = 'retailers-multi';
              // id = res.data.user.multiSite;
              route = 'dashboard';
              id = res.data.user.multiSite;
              break;

            case 'service-providers':
              route = 'dashboard';
              id = res.data.user.serviceProvider;
              break;

            case 'hsg-admins':
              route = 'dashboard';
              break;

            default:

              break;
          }

          if (id) {
            if (route != 'dashboard') {
              route = route + '/' + id;
            }

            localStorage.setItem('parentId', id);
          }

          localStorage.setItem('homeRoute', route);

          if (res.data.user.group) {
            // if we have a referrer url go there
            if (_this.$route.query.referrerurl) {
              var url = decodeURIComponent(_this.$route.query.referrerurl);
              if (url && url.length > 0) {
                _this.$router.push(url);
              } else {
                _this.$router.push(route);
              }
            } else {
              _this.$router.push(route);
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! This login is not part of any groups, please contact support.');
          }
        } else {
          // Something went wrong
          __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        }
      }).catch(function (err) {
        if (err && err.response && err.response.status == 404) {
          // Incorrect credentials
          __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('The username or password was incorrect');
        } else {
          // Something went wrong
          __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        }

        _this.loginActive = false;
      });
    },

    doResetPassword: function doResetPassword() {
      var _this2 = this;

      if (this.emailReset && this.emailReset.trim() != '') {
        __WEBPACK_IMPORTED_MODULE_2__services_ResetPasswordService__["a" /* default */].resetPassword(this.emailReset).then(function (res) {
          _this2.passwordResetSent = true;
        }).catch(function (err) {
          if (err.response.status && err.response.status == 404) {
            __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('The email address provided was not found');
          } else {
            __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('You must provide an email address');
      }
    }
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_ResetPasswordService__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus_js__ = __webpack_require__(3);
// Services


// Event Bus


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'resetPassword',

  components: {},

  data: function data() {
    return {
      newPassword: null,
      tokenValid: false,
      passwordSaved: false,
      token: null
    };
  },

  mounted: function mounted() {
    var _this = this;

    if (this.$route.params.token) {
      __WEBPACK_IMPORTED_MODULE_0__services_ResetPasswordService__["a" /* default */].checkToken(this.$route.params.token).then(function (res) {
        _this.tokenValid = true;
      }).catch(function (err) {
        if (err.response.status == 404) {
          __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! This reset link is not valid, please try to reset your password again.');
        } else {
          __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        }
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! This reset link is not valid, please try to reset your password again.');
    }
  },

  methods: {
    doSavePassword: function doSavePassword() {
      var _this2 = this;

      if (this.newPassword && this.newPassword.trim().length > 0) {
        __WEBPACK_IMPORTED_MODULE_0__services_ResetPasswordService__["a" /* default */].saveNewPassword(this.$route.params.token, this.newPassword).then(function (res) {
          _this2.passwordSaved = true;
        }).catch(function (err) {
          if (err.response.status == 404) {
            __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! This reset link is not valid, please try to reset your password again.');
          } else {
            __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_1__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Password may not be empty.');
      }
    }
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_IssueCount_IssueCount_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_IssueCount_IssueCount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_IssueCount_IssueCount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewStars_ReviewStars_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewStars_ReviewStars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewStars_ReviewStars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_SubscriptionLevel_SubscriptionLevel_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_SubscriptionLevel_SubscriptionLevel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ui_SubscriptionLevel_SubscriptionLevel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_PercentageCardContents_PercentageCardContents_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_PercentageCardContents_PercentageCardContents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_PercentageCardContents_PercentageCardContents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_ListViewMap_ListViewMap_vue__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_ListViewMap_ListViewMap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ui_ListViewMap_ListViewMap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ServiceRelationshipsService_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_MultiSitesService_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_RetailersService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_IssuesService_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EventBus_js__ = __webpack_require__(3);
// Components - UI








// Services





// Mixins


// EventBus


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Dashboard',

  mixins: [__WEBPACK_IMPORTED_MODULE_11__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default.a],

  components: {
    UserIcon: __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue___default.a,
    IssueCount: __WEBPACK_IMPORTED_MODULE_1__components_ui_IssueCount_IssueCount_vue___default.a,
    ReviewStars: __WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewStars_ReviewStars_vue___default.a,
    WashroomsCount: __WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue___default.a,
    SubscriptionLevel: __WEBPACK_IMPORTED_MODULE_4__components_ui_SubscriptionLevel_SubscriptionLevel_vue___default.a,
    PercentageCardContents: __WEBPACK_IMPORTED_MODULE_5__components_ui_PercentageCardContents_PercentageCardContents_vue___default.a,
    ListViewMap: __WEBPACK_IMPORTED_MODULE_6__components_ui_ListViewMap_ListViewMap_vue___default.a
  },

  data: function data() {
    return {
      pageTitle: null,
      retailers: [],
      mode: 'list',
      searchTerm: null,
      showSearch: false
    };
  },

  created: function created() {
    this.init();
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {
    init: function init() {
      var _this = this;

      this.retailers = [];
      this.mode = 'list';
      this.searchTerm = null;
      this.showSearch = false;

      if (localStorage.getItem('userGroup') == 'multi-site-retailers') {
        var filter = {
          multiSite: localStorage.getItem('parentId')
        };

        this.loadRetailers(filter);
      } else if (this.$route.params.multisiteId) {
        var _filter = {
          multiSite: this.$route.params.multisiteId
        };

        __WEBPACK_IMPORTED_MODULE_8__services_MultiSitesService_js__["a" /* default */].getById(this.$route.params.multisiteId).then(function (res) {
          _this.pageTitle = res.data.name;
        }).catch(function (err) {});

        this.loadRetailers(_filter);
      } else if (localStorage.getItem('userGroup') == 'service-providers') {
        // If we are logged in as a service provider
        __WEBPACK_IMPORTED_MODULE_7__services_ServiceRelationshipsService_js__["a" /* default */].getAll({ serviceProvider: localStorage.getItem('parentId') }).then(function (res) {
          var retailerIds = [];
          var filter = [];
          var filterMode = 'or';

          // Get DISTINCT ids of retailers that this SP services
          for (var i in res.data) {
            if (res.data[i].retailer && res.data[i].retailer.id) {
              if (retailerIds.indexOf(res.data[i].retailer.id) == -1) {
                retailerIds.push(res.data[i].retailer.id);
                filter.push({ id: res.data[i].retailer.id });
              }
            }
          }

          if (filter.length > 0) {
            _this.loadRetailers(filter, filterMode);
          }
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_12__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
      } else {
        this.loadRetailers();
      }
    },

    loadRetailers: function loadRetailers(filter, filterMode) {
      var _this2 = this;

      var serviceProviderId = null;
      if (localStorage.getItem('userGroup') == 'service-providers') {
        serviceProviderId = localStorage.getItem('parentId');
      }

      __WEBPACK_IMPORTED_MODULE_9__services_RetailersService_js__["a" /* default */].getAll(filter, filterMode, null, 'name ASC').then(function (res) {
        if (serviceProviderId != null) {
          for (var i in res.data) {
            res.data[i].issues.filter(function (item) {
              if (item.serviceProvider == serviceProviderId && (item.status == 'confirmed' || item.status == 'resolution-in-progress' || item.status == 'resolution-awaiting-approval' || item.status == 'resolution-denied')) {
                return true;
              }

              return false;
            });
          }
        }

        // for (let i in res.data) {
        //   let r = res.data[i];
        //
        //   let issuesFilter = {retailer: r.id};
        //
        //   if(serviceProviderId != null) {
        //     issuesFilter.serviceProvider = serviceProviderId;
        //
        //     issuesFilter.status = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];
        //   }
        //
        //   IssuesService.getAll(issuesFilter)
        //     .then((res) => {
        //       r.issues = res.data;
        //       this.retailers.push(r);
        //     });
        // }

        _this2.retailers = res.data;
      });
    },

    goToRetailersDetail: function goToRetailersDetail(id) {
      this.$router.push('/retailers/' + id);
    },

    viewMap: function viewMap() {
      this.mode = 'map';
      this.$gmapDefaultResizeBus.$emit('resize');
    },

    viewList: function viewList() {
      this.mode = 'list';
    },

    openSearch: function openSearch() {
      var _this3 = this;

      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(function () {
        _this3.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function closeSearch() {
      this.searchTerm = null;
      this.showSearch = false;
    }
  },

  computed: {
    search: function search() {
      var _this4 = this;

      if (this.searchTerm && this.searchTerm.trim().length > 0) {
        return this.retailers.filter(function (r) {
          if (r.name.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || r.address.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || r.city.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || r.postcode.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1) {
            return true;
          }

          return false;
        });
      } else {
        return this.retailers;
      }
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.init();
    }
  }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_Scroller_Scroller_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_Scroller_Scroller_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_Scroller_Scroller_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_UserIcon_UserIcon_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_UserIcon_UserIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_UserIcon_UserIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_LineChart_LineChart_vue__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_LineChart_LineChart_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_LineChart_LineChart_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_ReviewStars_ReviewStars_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_ReviewStars_ReviewStars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_ReviewStars_ReviewStars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_WashroomIcon_WashroomIcon_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_WashroomIcon_WashroomIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ui_WashroomIcon_WashroomIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_ServiceIcons_ServiceIcons_vue__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_ServiceIcons_ServiceIcons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_ServiceIcons_ServiceIcons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_WashroomsCount_WashroomsCount_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_WashroomsCount_WashroomsCount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ui_WashroomsCount_WashroomsCount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_WashroomsService_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_ReviewsService_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_ServiceRelationshipsService_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EventBus_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
// Components - UI








// Services





// EventBus


// Vendor


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'retailers-detail',

  components: {
    Scroller: __WEBPACK_IMPORTED_MODULE_0__components_ui_Scroller_Scroller_vue___default.a,
    UserIcon: __WEBPACK_IMPORTED_MODULE_1__components_ui_UserIcon_UserIcon_vue___default.a,
    LineChart: __WEBPACK_IMPORTED_MODULE_2__components_ui_LineChart_LineChart_vue___default.a,
    ReviewStars: __WEBPACK_IMPORTED_MODULE_3__components_ui_ReviewStars_ReviewStars_vue___default.a,
    WashroomIcon: __WEBPACK_IMPORTED_MODULE_4__components_ui_WashroomIcon_WashroomIcon_vue___default.a,
    ServiceIcons: __WEBPACK_IMPORTED_MODULE_5__components_ui_ServiceIcons_ServiceIcons_vue___default.a,
    WashroomsCount: __WEBPACK_IMPORTED_MODULE_6__components_ui_WashroomsCount_WashroomsCount_vue___default.a
  },

  data: function data() {
    return {
      retailer: null,
      washrooms: null,
      reviews: null,
      serviceRelationships: null,
      userMode: 'normal',
      userGroup: null,

      // Chart State
      activeChart: 1,

      // Chart Data
      recentReviewsPerDay: null,
      recentAverageRatingPerDay: null
    };
  },

  created: function created() {
    var _this = this;

    var retailerId = this.$route.params.id;

    var serviceRelationshipFilter = null;

    this.userGroup = localStorage.getItem('userGroup');

    // Check the logged in user type and adjust the view if neccesary
    if (localStorage.getItem('userGroup') == 'service-providers') {
      this.userMode = 'service-providers';
      serviceRelationshipFilter = {
        retailer: retailerId,
        serviceProvider: localStorage.getItem('parentId') // In this case `parentId` is the logged in service user's id
      };
    } else {
      serviceRelationshipFilter = {
        retailer: retailerId
      };
    }

    // Populate page data
    // ------------------
    // Reviews Per Day (Chart Data)
    __WEBPACK_IMPORTED_MODULE_9__services_ReviewsService_js__["a" /* default */].getPerDay(7, { retailer: retailerId }, null, null, 'createdAt ASC').then(function (res) {
      _this.recentReviewsPerDay = res.data;
    });

    // Average Rating Per Day (Chart Data)
    __WEBPACK_IMPORTED_MODULE_9__services_ReviewsService_js__["a" /* default */].getAverageRatingPerDay(7, { retailer: retailerId }, null, null, 'createdAt ASC').then(function (res) {
      _this.recentAverageRatingPerDay = res.data;
    });

    __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__["a" /* default */].getById(retailerId).then(function (res) {
      _this.retailer = res.data;
    }).catch(function (err) {
      console.error('RetailersService(err)', err);
    });

    __WEBPACK_IMPORTED_MODULE_8__services_WashroomsService_js__["a" /* default */].getAll({ retailer: retailerId }).then(function (res) {
      _this.washrooms = res.data;
    }).catch(function (err) {
      console.error();'WashroomsService(err)', err;
    });

    __WEBPACK_IMPORTED_MODULE_9__services_ReviewsService_js__["a" /* default */].getAll({ retailer: retailerId }, null, null, 'createdAt DESC').then(function (res) {
      _this.reviews = res.data;
    }).catch(function (err) {
      console.error('ReviewsService(err)', err);
    });

    __WEBPACK_IMPORTED_MODULE_10__services_ServiceRelationshipsService_js__["a" /* default */].getAll(serviceRelationshipFilter).then(function (res) {
      _this.serviceRelationships = res.data;
    }).catch(function (err) {
      console.error('ServiceRelationshipsService(err)', err);
    });
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {
    filterWashrooms: function filterWashrooms(washroom) {
      return this.washrooms.find(function (item) {
        return item.id == washroom.id;
      });
    },

    reviewsPerDayLabels: function reviewsPerDayLabels(data) {
      if (data !== null) {
        var labels = [];

        for (var i in data) {
          labels.push(__WEBPACK_IMPORTED_MODULE_12_moment___default()(data[i].timestamp).format('ddd'));
        }

        return labels;
      }

      return null;
    },

    reviewsPerDayPlots: function reviewsPerDayPlots(data) {
      if (data !== null) {
        var plots = [];

        for (var i in data) {
          plots.push(data[i].reviews.length);
        }

        return plots;
      }

      return null;
    },

    averageRatingPerDayLabels: function averageRatingPerDayLabels(data) {
      if (data !== null) {
        var labels = [];

        for (var i in data) {
          labels.push(__WEBPACK_IMPORTED_MODULE_12_moment___default()(data[i].timestamp).format('ddd'));
        }

        return labels;
      }

      return null;
    },

    averageRatingPerDayPlots: function averageRatingPerDayPlots(data) {
      if (data !== null) {
        var plots = [];

        for (var i in data) {
          plots.push(data[i].averageRating);
        }

        return plots;
      }

      return null;
    }
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_SiteCount_SiteCount_vue__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_SiteCount_SiteCount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_SiteCount_SiteCount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewStars_ReviewStars_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewStars_ReviewStars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewStars_ReviewStars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_SubscriptionLevel_SubscriptionLevel_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_SubscriptionLevel_SubscriptionLevel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ui_SubscriptionLevel_SubscriptionLevel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_WashroomCountSingle_WashroomCountSingle_vue__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_WashroomCountSingle_WashroomCountSingle_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_WashroomCountSingle_WashroomCountSingle_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_PercentageCardContents_PercentageCardContents_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ui_PercentageCardContents_PercentageCardContents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ui_PercentageCardContents_PercentageCardContents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_WashroomsService_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_MultiSitesService_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_ServiceRelationshipsService_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EventBus_js__ = __webpack_require__(3);
// Components - UI








// Services




// Mixins


// EventBus


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'retailers-multi',

  mixins: [__WEBPACK_IMPORTED_MODULE_10__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default.a],

  components: {
    UserIcon: __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue___default.a,
    SiteCount: __WEBPACK_IMPORTED_MODULE_1__components_ui_SiteCount_SiteCount_vue___default.a,
    ReviewStars: __WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewStars_ReviewStars_vue___default.a,
    WashroomsCount: __WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue___default.a,
    SubscriptionLevel: __WEBPACK_IMPORTED_MODULE_4__components_ui_SubscriptionLevel_SubscriptionLevel_vue___default.a,
    WashroomCountSingle: __WEBPACK_IMPORTED_MODULE_5__components_ui_WashroomCountSingle_WashroomCountSingle_vue___default.a
  },

  data: function data() {
    return {
      retailers: [],
      searchTerm: null,
      showSearch: false
    };
  },

  created: function created() {
    var _this = this;

    // If we are logged in as a service provider
    if (localStorage.getItem('userGroup') == 'service-providers') {
      __WEBPACK_IMPORTED_MODULE_9__services_ServiceRelationshipsService_js__["a" /* default */].getAll({ serviceProvider: localStorage.getItem('parentId') }).then(function (res) {
        var retailerIds = [];
        var filters = [];

        // Get DISTINCT ids of retailers that this SP services
        for (var i in res.data) {
          if (res.data[i].retailer && res.data[i].retailer.multiSite) {
            if (retailerIds.indexOf(res.data[i].retailer.multiSite) == -1) {
              retailerIds.push(res.data[i].retailer.multiSite);

              filters.push({ id: res.data[i].retailer.multiSite });
            }
          }
        }

        if (filters.length > 0) {
          __WEBPACK_IMPORTED_MODULE_8__services_MultiSitesService_js__["a" /* default */].getAll(filters, 'or', null, 'name ASC').then(function (res) {
            _this.retailers = res.data;

            var _loop = function _loop(_i) {
              __WEBPACK_IMPORTED_MODULE_7__services_WashroomsService_js__["a" /* default */].getByMultisiteId(_this.retailers[_i].id).then(function (res) {
                _this.$set(_this.retailers[_i], 'washrooms', res.data);
              }).catch(function (err) {
                __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, not all data may have been loaded correctly, please try again.');
              });
            };

            for (var _i in _this.retailers) {
              _loop(_i);
            }
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          });
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_8__services_MultiSitesService_js__["a" /* default */].getAll(null, null, null, 'name ASC').then(function (res) {
        _this.retailers = res.data;

        var _loop2 = function _loop2(i) {
          __WEBPACK_IMPORTED_MODULE_7__services_WashroomsService_js__["a" /* default */].getByMultisiteId(_this.retailers[i].id).then(function (res) {
            _this.$set(_this.retailers[i], 'washrooms', res.data);
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, not all data may have been loaded correctly, please try again.');
          });
        };

        for (var i in _this.retailers) {
          _loop2(i);
        }
      });
    }
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {
    openSearch: function openSearch() {
      var _this2 = this;

      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(function () {
        _this2.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function closeSearch() {
      this.searchTerm = null;
      this.showSearch = false;
    }
  },

  computed: {
    search: function search() {
      var _this3 = this;

      if (this.searchTerm && this.searchTerm.trim().length > 0) {
        return this.retailers.filter(function (r) {
          if (r.name.toLowerCase().trim().indexOf(_this3.searchTerm.toLowerCase().trim()) > -1 || r.contactEmail.toLowerCase().trim().indexOf(_this3.searchTerm.toLowerCase().trim()) > -1 || r.contactTelephone.toLowerCase().trim().indexOf(_this3.searchTerm.toLowerCase().trim()) > -1) {
            return true;
          }

          return false;
        });
      } else {
        return this.retailers;
      }
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_ReviewMood_ReviewMood_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_ReviewMood_ReviewMood_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_ReviewMood_ReviewMood_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_WashroomIcon_WashroomIcon_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_WashroomIcon_WashroomIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_WashroomIcon_WashroomIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_IssueStatusIcons_IssueStatusIcons_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_IssueStatusIcons_IssueStatusIcons_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ui_IssueStatusIcons_IssueStatusIcons_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_SubscriptionLevel_SubscriptionLevel_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_SubscriptionLevel_SubscriptionLevel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_SubscriptionLevel_SubscriptionLevel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_IssuesService_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ReviewsService_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_WashroomsService_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_RetailersService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_ServiceRelationshipsService_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__EventBus_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
// Components - UI







// Services






// Mixins


// EventBus


// Vendor


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'reviews',

  mixins: [__WEBPACK_IMPORTED_MODULE_11__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default.a],

  components: {
    ReviewMood: __WEBPACK_IMPORTED_MODULE_0__components_ui_ReviewMood_ReviewMood_vue___default.a,
    ReviewStars: __WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue___default.a,
    WashroomIcon: __WEBPACK_IMPORTED_MODULE_2__components_ui_WashroomIcon_WashroomIcon_vue___default.a,
    WashroomsCount: __WEBPACK_IMPORTED_MODULE_3__components_ui_WashroomsCount_WashroomsCount_vue___default.a,
    IssueStatusIcons: __WEBPACK_IMPORTED_MODULE_4__components_ui_IssueStatusIcons_IssueStatusIcons_vue___default.a,
    SubscriptionLevel: __WEBPACK_IMPORTED_MODULE_5__components_ui_SubscriptionLevel_SubscriptionLevel_vue___default.a
  },

  data: function data() {
    return {
      pageTitle: null,
      reviews: [],
      retailer: null,
      searchTerm: null,
      showSearch: false,
      onlyOpen: false,
      userGroup: localStorage.getItem('userGroup')
    };
  },

  created: function created() {
    if (localStorage.getItem('userGroup') == 'service-providers') {
      this.onlyOpen = true;
    }

    this.init();
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {
    init: function init() {
      var _this = this;

      // Reset component data
      this.reviews = [];
      this.retailer = null;

      var filter = null;

      // If we have a route parameter with a retailer ID
      if (this.$route.params.retailerId) {
        __WEBPACK_IMPORTED_MODULE_9__services_RetailersService_js__["a" /* default */].getById(this.$route.params.retailerId).then(function (res) {
          _this.pageTitle = res.data.name;
        }).catch(function (err) {});

        filter = {
          retailer: this.$route.params.retailerId
        };

        this.getReviews(filter);
      }
      // If we have a route parameter with a washroom ID
      else if (this.$route.params.washroomId) {
          __WEBPACK_IMPORTED_MODULE_8__services_WashroomsService_js__["a" /* default */].getById(this.$route.params.washroomId).then(function (res) {
            _this.pageTitle = res.data.name;
          }).catch(function (err) {});

          filter = {
            washroom: this.$route.params.washroomId
          };

          this.getReviews(filter);
        }
        // If we have a route parameter with a multisite ID
        else if (this.$route.params.multisiteId) {
            MultisitesService.getById(this.$route.params.multisiteId).then(function (res) {
              _this.pageTitle = res.data.name;
            }).catch(function (err) {});

            __WEBPACK_IMPORTED_MODULE_9__services_RetailersService_js__["a" /* default */].getAll({ multiSite: this.$route.params.multisiteId }).then(function (res) {
              filter = [];

              for (var i in res.data) {
                filter.push({ retailer: res.data[i].id });
              }

              _this.getReviews(filter, 'or');
            }).catch(function (err) {
              __WEBPACK_IMPORTED_MODULE_12__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
            });
          }
          // If we are logged in as a retailer
          else if (localStorage.getItem('userGroup') == 'retailers') {
              filter = {
                retailer: localStorage.getItem('parentId') // In this case 'parentID' is the logged in retailer's id
              };

              this.getReviews(filter);
            }
            // If we are logged in as a multi-site retailer
            else if (localStorage.getItem('userGroup') == 'multi-site-retailers') {
                __WEBPACK_IMPORTED_MODULE_9__services_RetailersService_js__["a" /* default */].getAll({ multiSite: localStorage.getItem('parentId') }) // In this case 'parentID' is the logged in multi-site-retailer's id
                .then(function (res) {
                  filter = [];

                  for (var i in res.data) {
                    filter.push({ retailer: res.data[i].id });
                  }

                  if (filter.length > 0) {
                    _this.getReviews(filter, 'or');
                  }
                }).catch(function (err) {
                  __WEBPACK_IMPORTED_MODULE_12__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
                });
              }
              // If we are logged in as a service provider
              else if (localStorage.getItem('userGroup') == 'service-providers') {
                  // If we are logged in as a service provider
                  __WEBPACK_IMPORTED_MODULE_10__services_ServiceRelationshipsService_js__["a" /* default */].getAll({ serviceProvider: localStorage.getItem('parentId'), status: 'approved' }).then(function (res) {
                    var retailerIds = [];
                    var filter = [];
                    var filterMode = 'or';

                    // Get DISTINCT ids of retailers that this SP services
                    for (var i in res.data) {
                      if (res.data[i].retailer && res.data[i].retailer.id) {
                        if (retailerIds.indexOf(res.data[i].retailer.id) == -1) {
                          retailerIds.push(res.data[i].retailer.id);
                          filter.push({ retailer: res.data[i].retailer.id });
                        }
                      }
                    }

                    if (filter.length > 0) {
                      _this.getReviews(filter, filterMode);
                    }
                  }).catch(function (err) {
                    __WEBPACK_IMPORTED_MODULE_12__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
                  });
                }
                // Not logged in a filterable user type
                else {
                    this.getReviews();
                  }

      if (filter && filter.retailer) {
        __WEBPACK_IMPORTED_MODULE_9__services_RetailersService_js__["a" /* default */].getById(filter.retailer).then(function (res) {
          _this.retailer = res.data;
        });
      }
    },

    getReviews: function getReviews(filter, filterMode) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_7__services_ReviewsService_js__["a" /* default */].getAll(filter, filterMode, null, 'createdAt DESC').then(function (res) {
        _this2.reviews = res.data;

        for (var i in _this2.reviews) {
          // Get filtered issues for service provider
          if (localStorage.getItem('userGroup') == 'service-providers') {
            var issueFilters = {
              review: _this2.reviews[i].id,
              serviceProvider: localStorage.getItem('parentId'),
              status: ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied']
            };

            // IssuesService.getAll(issueFilters)
            // .then((res) => {
            //   this.reviews[i].issues = res.data;
            // });
          }
        }
      });
    },

    filterWashrooms: function filterWashrooms(review) {
      var washroomId = review.washroom;

      if (review.retailer && review.retailer.washrooms) {
        var filteredWashrooms = review.retailer.washrooms.filter(function (item) {
          return item.id == washroomId;
        });

        if (filteredWashrooms.length == 1) {
          return filteredWashrooms[0];
        }

        return {
          humanId: ''
        };
      }

      return {
        humanId: ''
      };
    },

    goToReview: function goToReview(id) {
      this.$router.push('/reviews/' + id);
    },

    openSearch: function openSearch() {
      var _this3 = this;

      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(function () {
        _this3.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function closeSearch() {
      this.searchTerm = null;
      this.showSearch = false;
    },

    filterServiceProviderIssues: function filterServiceProviderIssues(issues) {
      var serviceProviderId = localStorage.getItem('parentId');

      return issues.filter(function (i) {
        if (i.serviceProvider == serviceProviderId || i.serviceProvider == null) {
          return true;
        }

        return false;
      });
    }
  },

  computed: {
    search: function search() {
      var _this4 = this;

      // Filter by search criteria
      if (this.searchTerm && this.searchTerm.trim().length > 0 || this.onlyOpen && this.onlyOpen === true) {
        var results = null;

        if (this.searchTerm && this.searchTerm.trim().length > 0) {
          results = this.reviews.filter(function (r) {
            if (r.retailer.name.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || _this4.filterWashrooms(r).humanId.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || r.retailer.address.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || r.retailer.city.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || r.retailer.postcode.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || r.washroom.humanId.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || __WEBPACK_IMPORTED_MODULE_13_moment___default()(r.createdAt).format('D.M.Y').indexOf(_this4.searchTerm.toLowerCase().trim()) > -1) {
              return true;
            }

            return false;
          });
        }

        var issueFilter = function issueFilter(r) {
          var openIssues = r.issues.filter(function (i) {
            if (localStorage.getItem('userGroup') == 'service-providers') {
              // If we are logged in as a service provider
              var serviceProviderId = localStorage.getItem('parentId');

              var _openIssueStatus = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];

              if ((i.serviceProvider == serviceProviderId || i.serviceProvider == null) && _openIssueStatus.indexOf(i.status) > -1) {
                return true;
              }
            } else {
              if (openIssueStatus.indexOf(i.status) > -1) {
                return true;
              }
            }

            return false;
          });

          if (openIssues.length > 0) {
            return true;
          }

          return false;
        };

        // Filter by open issues
        if (this.onlyOpen && this.onlyOpen === true) {
          // Filter issues on review search results
          if (this.searchTerm && this.searchTerm.trim().length > 0) {
            results = results.filter(issueFilter);
          }
          // Filter issues on all reviews
          else {
              results = this.reviews.filter(issueFilter);
            }
        }

        return results;
      } else {
        return this.reviews;
      }
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.init();
    }
  }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_Splitter_Splitter_vue__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_Splitter_Splitter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_Splitter_Splitter_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_IssueBadge_IssueBadge_vue__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_IssueBadge_IssueBadge_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_IssueBadge_IssueBadge_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewMood_ReviewMood_vue__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewMood_ReviewMood_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewMood_ReviewMood_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_ReviewStars_ReviewStars_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_ReviewStars_ReviewStars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_ReviewStars_ReviewStars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_WashroomIcon_WashroomIcon_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ui_WashroomIcon_WashroomIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ui_WashroomIcon_WashroomIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_Scroller_Scroller_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ui_Scroller_Scroller_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ui_Scroller_Scroller_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_ReviewsService_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_WashroomsService_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EventBus_js__ = __webpack_require__(3);
// Components - UI







// Services




// EventBus


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'reviews-detail',

  components: {
    IssueBadge: __WEBPACK_IMPORTED_MODULE_1__components_ui_IssueBadge_IssueBadge_vue___default.a,
    ReviewStars: __WEBPACK_IMPORTED_MODULE_3__components_ui_ReviewStars_ReviewStars_vue___default.a,
    ReviewMood: __WEBPACK_IMPORTED_MODULE_2__components_ui_ReviewMood_ReviewMood_vue___default.a,
    WashroomIcon: __WEBPACK_IMPORTED_MODULE_4__components_ui_WashroomIcon_WashroomIcon_vue___default.a,
    Splitter: __WEBPACK_IMPORTED_MODULE_0__components_ui_Splitter_Splitter_vue___default.a,
    Scroller: __WEBPACK_IMPORTED_MODULE_5__components_ui_Scroller_Scroller_vue___default.a
  },

  data: function data() {
    return {
      review: null,
      retailer: null,
      washroom: null,
      reviews: []
    };
  },

  created: function created() {
    var _this = this;

    var id = this.$route.params.id;

    __WEBPACK_IMPORTED_MODULE_6__services_ReviewsService_js__["a" /* default */].getById(id).then(function (res) {
      _this.review = res.data;

      // Get Retailer Info
      __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__["a" /* default */].getById(_this.review.retailer).then(function (res) {
        _this.retailer = res.data;
      }).catch(function (err) {
        console.error('RetailersService(err)', err);
      });

      // Get Washroom Info
      __WEBPACK_IMPORTED_MODULE_8__services_WashroomsService_js__["a" /* default */].getById(_this.review.washroom).then(function (res) {
        _this.washroom = res.data;
      }).catch(function (err) {
        console.error('WashroomsService(err)', err);
      });

      // Get Reviews for Retailer
      __WEBPACK_IMPORTED_MODULE_6__services_ReviewsService_js__["a" /* default */].getAll({ retailer: _this.review.retailer }).then(function (res) {
        _this.reviews = res.data;
      }).catch(function (err) {
        console.error('ReviewsService(err)', err);
      });
    }).catch(function (err) {
      console.error('ReviewsService(err)', err);
    });
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {
    intToDecimal: function intToDecimal(integer) {
      return integer + '.0';
    }
  },

  computed: {
    filteredIssues: function filteredIssues() {
      if (localStorage.getItem('userGroup') == 'service-providers') {
        var serviceProviderId = localStorage.getItem('parentId');

        var openIssueStatus = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];

        return this.review.issues.filter(function (i) {
          return i.serviceProvider == serviceProviderId && openIssueStatus.indexOf(i.status) > -1 || i.serviceProvider == null;
        });
      }
      return this.review.issues;
    },

    images: function images() {
      var images = [];

      for (var i in this.filteredIssues) {
        if (this.filteredIssues[i].s3ImageUrl) {
          images.push("https://s3.amazonaws.com/cleen-data" + '/img/issues/' + this.filteredIssues[i].s3ImageUrl);
        }
      }

      return images;
    },

    numericalRating: function numericalRating() {
      return Math.round(this.review.overallRating * 10) / 10;
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_PercentageCardContents_PercentageCardContents_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_PercentageCardContents_PercentageCardContents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_PercentageCardContents_PercentageCardContents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_Scroller_Scroller_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ui_Scroller_Scroller_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ui_Scroller_Scroller_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ServiceProvidersService_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventBus_js__ = __webpack_require__(3);
// Components - UI





// Services



// EventBus


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ServiceProviderDetail',

  components: {
    UserIcon: __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue___default.a,
    ReviewStars: __WEBPACK_IMPORTED_MODULE_1__components_ui_ReviewStars_ReviewStars_vue___default.a,
    Scroller: __WEBPACK_IMPORTED_MODULE_3__components_ui_Scroller_Scroller_vue___default.a
  },

  data: function data() {
    return {
      userGroup: localStorage.getItem('userGroup'),
      serviceProvider: null,
      serviceRelationships: null,
      selectedServiceRelationship: null,
      serviceAreas: __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__["a" /* default */].serviceAreas
    };
  },

  created: function created() {},

  mounted: function mounted() {
    this.init();
  },

  beforeDestroy: function beforeDestroy() {},

  methods: {
    /**
      * @private
      */
    init: function init() {
      this.loadServiceProvider();
      this.loadRelationships();
    },
    /**
      * @private
      */
    loadRelationships: function loadRelationships() {
      var _this = this;

      // Get the id from the params
      var id = this.$route.params.id;
      // Use the id to load the current service provider's relationships
      __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__["a" /* default */].getAll({ 'serviceProvider': id }).then(function (res) {
        console.log(res.data);
        _this.serviceRelationships = res.data;
      });
    },

    /**
      * @private
      */
    loadServiceProvider: function loadServiceProvider() {
      var _this2 = this;

      // Get the id from the params
      var id = this.$route.params.id;
      // Use the id to load the current service provider
      __WEBPACK_IMPORTED_MODULE_4__services_ServiceProvidersService_js__["a" /* default */].getById(id).then(function (res) {
        _this2.serviceProvider = res.data;
      });
    },

    getServiceArea: function getServiceArea(serviceAreaName) {
      return this.serviceAreas.find(function (item) {
        return item.name == serviceAreaName;
      });
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.init();
    }
  }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_PercentageCardContents_PercentageCardContents_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_PercentageCardContents_PercentageCardContents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_PercentageCardContents_PercentageCardContents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_ServiceProvidersService_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventBus_js__ = __webpack_require__(3);
// Components - UI



// Services


// Mixins


// EventBus


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ServiceProviders',

  mixins: [__WEBPACK_IMPORTED_MODULE_3__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default.a],

  components: {
    UserIcon: __WEBPACK_IMPORTED_MODULE_0__components_ui_UserIcon_UserIcon_vue___default.a
  },

  data: function data() {
    return {
      serviceProviders: [],
      searchTerm: null,
      showSearch: false
    };
  },

  created: function created() {},

  mounted: function mounted() {
    this.init();
  },

  beforeDestroy: function beforeDestroy() {},

  methods: {
    /**
      * @private
      */
    init: function init() {
      var _this = this;

      // If we are logged in as a multi-site retailer
      if (localStorage.getItem('userGroup') == 'multi-site-retailers') {
        __WEBPACK_IMPORTED_MODULE_2__services_ServiceProvidersService_js__["a" /* default */].getAllByMultisite(localStorage.getItem('parentId')) // In this case 'parentID' is the logged in multi-site-retailer's id
        .then(function (res) {
          _this.serviceProviders = res.data;
        }).catch(function (err) {
          console.log('err', err);
          alert('err, check console logs');
        });
      } else {
        this.loadAllServiceProviders();
      }
    },
    /**
      * @private
      */
    loadAllServiceProviders: function loadAllServiceProviders() {
      var _this2 = this;

      // Load all service providers
      __WEBPACK_IMPORTED_MODULE_2__services_ServiceProvidersService_js__["a" /* default */].getAll(null, null, null, 'name ASC').then(function (res) {
        _this2.serviceProviders = res.data;
      });
    },

    openSearch: function openSearch() {
      var _this3 = this;

      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(function () {
        _this3.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function closeSearch() {
      this.searchTerm = null;
      this.showSearch = false;
    }
  },

  computed: {
    search: function search() {
      var _this4 = this;

      if (this.searchTerm && this.searchTerm.trim().length > 0) {
        return this.serviceProviders.filter(function (s) {
          if (s.name.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || s.adminContactEmail.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1 || s.adminContactTelephone.toLowerCase().trim().indexOf(_this4.searchTerm.toLowerCase().trim()) > -1) {
            return true;
          }

          return false;
        });
      } else {
        return this.serviceProviders;
      }
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.init();
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_Scroller_Scroller_vue__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_Scroller_Scroller_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_Scroller_Scroller_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_UserIcon_UserIcon_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_UserIcon_UserIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_UserIcon_UserIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_PercentageCardContents_PercentageCardContents_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_PercentageCardContents_PercentageCardContents_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_PercentageCardContents_PercentageCardContents_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_RetailersService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_ServiceProvidersService_js__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventBus_js__ = __webpack_require__(3);
// Components - UI




// Services




// EventBus


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ServiceRelationships',

  components: {
    Scroller: __WEBPACK_IMPORTED_MODULE_0__components_ui_Scroller_Scroller_vue___default.a,
    UserIcon: __WEBPACK_IMPORTED_MODULE_1__components_ui_UserIcon_UserIcon_vue___default.a
  },

  data: function data() {
    return {
      userMode: null,
      viewMode: null,

      // Existing Connection Data
      selectedServiceRelationship: null,
      selectedServiceProviderName: null,
      serviceRelationships: [],
      serviceAreas: __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__["a" /* default */].serviceAreas,
      serviceAreaOn: [],

      // New Connection Data
      serviceProviders: [],
      selectedServiceProvider: null,
      newRelationship: this.initNewRelationship(),

      // Service Provider Add retailer
      retailerHumanId: null,
      retailers: null,
      selectedRetailer: null
    };
  },

  created: function created() {
    this.bindEvents();

    this.init();

    // Fill an array of default area states (all off)
    for (var i = 0; i < this.serviceAreas.length; i++) {
      this.serviceAreaOn[i] = false;
    }
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {
    // View Mode methods
    // ---------------------------------------------------------------------------
    bindEvents: function bindEvents() {
      var _this = this;

      // Listen for File Delete Events
      __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].$on('connectionDeleteYesClicked', function (data) {
        __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__["a" /* default */].deleteById(data.serviceRelationshipId).then(function (res) {
          // Refresh folder
          _this.init();
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Something went wrong whilst deleting the connection, please check and try again...');
          // Refresh folder
          _this.init();
        });
      });
    },

    init: function init() {
      if (localStorage.getItem('userGroup') && localStorage.getItem('userGroup') == 'service-providers') {
        this.userMode = 'service-providers';
      } else {
        this.userMode = 'normal';
      }

      // Reset component data
      this.selectedServiceRelationship = null;
      this.selectedServiceProviderName = null;
      this.selectedRetailer = null;
      this.retailerHumanId = null;
      this.retailers = null;
      this.serviceRelationships = [];
      this.serviceAreaOn = [];
      this.serviceProviders = [];
      this.selectedServiceProvider = null;

      this.loadRelationships();
    },

    loadRelationships: function loadRelationships() {
      var _this2 = this;

      var id = null;

      if (this.$route.params.id) {
        // Get the retailer id from the url
        id = this.$route.params.id;
      } else if (localStorage.getItem('parentId')) {
        id = localStorage.getItem('parentId');
      }

      var filter = null;
      if (this.userMode == 'service-providers') {
        filter = {
          serviceProvider: id,
          status: 'pending'
        };
      } else {
        filter = {
          retailer: id
        };
      }

      if (id) {
        // Load service relationships for this retailer
        __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__["a" /* default */].getAll(filter).then(function (res) {
          var filteredData = res.data.filter(function (item) {
            return item.status != 'declined';
          });
          _this2.serviceRelationships = filteredData;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
      }
    },

    onViewRelationshipClick: function onViewRelationshipClick(index) {
      this.selectedServiceRelationship = this.serviceRelationships[index];
      this.selectedServiceProviderName = this.serviceRelationships[index].serviceProvider.name;

      for (var i = 0; i < this.serviceAreas.length; i++) {
        this.serviceAreaOn[i] = this.selectedServiceRelationship[this.serviceAreas[i].name];
      }
    },

    deleteCurrentServiceRelationship: function deleteCurrentServiceRelationship() {
      var serviceRelationshipId = this.selectedServiceRelationship.id;

      var message = 'Are you sure you want to delete this connection?';

      var options = [{
        optionText: 'Yes',
        optionEvent: 'connectionDeleteYesClicked',
        optionData: {
          serviceRelationshipId: serviceRelationshipId
        }
      }, {
        optionText: 'No',
        optionEvent: 'connectionDeleteNoClicked',
        optionData: null
      }];

      __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].dispatchDialogEvent(message, options);
    },

    approveCurrentServiceRelationship: function approveCurrentServiceRelationship() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__["a" /* default */].replace(this.selectedServiceRelationship.id, { status: 'approved' }).then(function (res) {
        _this3.init();
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
      });
    },

    declineCurrentServiceRelationship: function declineCurrentServiceRelationship() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__["a" /* default */].replace(this.selectedServiceRelationship.id, { status: 'declined' }).then(function (res) {
        _this4.init();
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
      });
    },

    // Add Mode Methods
    // ---------------------------------------------------------------------------
    getServiceProviders: function getServiceProviders() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4__services_ServiceProvidersService_js__["a" /* default */].getAll().then(function (res) {
        _this5.serviceProviders = res.data;
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
      });
    },

    initNewRelationship: function initNewRelationship() {
      var newRelationship = {
        accessibility: false,
        baby: false,
        bins: false,
        doors: false,
        driers: false,
        heating: false,
        lighting: false,
        mirror: false,
        paint: false,
        toiletpaper: false,
        sanitarybins: false,
        sinks: false,
        smell: false,
        soap: false,
        suggestions: false,
        toilet: false,
        towels: false,
        urinals: false,
        vending: false,
        walls: false
      };

      return newRelationship;
    },

    onViewServiceProviderClick: function onViewServiceProviderClick(index) {
      this.selectedServiceProvider = this.serviceProviders[index];
      this.newRelationship = this.initNewRelationship();
    },

    setAllRelationshipAreasTrue: function setAllRelationshipAreasTrue() {
      for (var i in this.serviceAreas) {
        if (!this.unavailableServiceAreas[this.serviceAreas[i].name]) {
          this.setNewRelationshipArea(this.serviceAreas[i], true);
        }
      }
    },

    setNewRelationshipArea: function setNewRelationshipArea(serviceArea, state) {
      this.newRelationship[serviceArea.name] = state;
    },

    sendConnectionRequest: function sendConnectionRequest() {
      var _this6 = this;

      this.newRelationship.status = 'pending';

      if (localStorage.getItem('userGroup') == 'service-providers') {
        this.newRelationship.serviceProvider = localStorage.getItem('parentId');
        this.newRelationship.retailer = this.selectedRetailer.id;
        this.newRelationship.origin = 'service-provider';
      } else {
        this.newRelationship.serviceProvider = this.selectedServiceProvider.id;
        this.newRelationship.retailer = localStorage.getItem('parentId');
        this.newRelationship.origin = 'retailer';
      }

      __WEBPACK_IMPORTED_MODULE_5__services_ServiceRelationshipsService_js__["a" /* default */].createOne(this.newRelationship).then(function (res) {
        _this6.viewMode = null;
        _this6.selectedServiceProvider = null;
        _this6.newRelationship = _this6.initNewRelationship();
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
      });
    },

    cancelConnectionRequest: function cancelConnectionRequest() {
      this.viewMode = null;
      this.selectedServiceProvider = null;
      this.newRelationship = this.initNewRelationship();
    },

    searchRetailerHumanId: function searchRetailerHumanId() {
      var _this7 = this;

      console.log('this.retailerHumanId', this.retailerHumanId);

      __WEBPACK_IMPORTED_MODULE_3__services_RetailersService_js__["a" /* default */].getAll({ humanId: this.retailerHumanId }).then(function (res) {
        if (res.data && res.data.length > 0) {
          _this7.retailers = res.data;
        } else {
          __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].dispatchDialogEvent('The ID provided didn\'t match any retailer, please check the ID and try again.');
        }
      }).catch(function (err) {
        __WEBPACK_IMPORTED_MODULE_6__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong whilst looking up the retailer, please try again...');
      });
    },

    onViewRetailerClick: function onViewRetailerClick(index) {
      this.selectedRetailer = this.retailers[index];
      this.newRelationship = this.initNewRelationship();
    }
  },

  computed: {
    isNewConnectionDirty: function isNewConnectionDirty() {
      var result = false;

      for (var area in this.newRelationship) {
        if (this.newRelationship[area] == true) {
          result = true;
        }
      }

      return result;
    },

    pendingServiceRelationships: function pendingServiceRelationships() {
      return this.serviceRelationships.filter(function (sr) {
        return sr.status === 'pending';
      });
    },

    existingServiceProviders: function existingServiceProviders() {
      var existingServiceProvderIds = [];

      for (var i in this.serviceRelationships) {
        existingServiceProvderIds.push(this.serviceRelationships[i].serviceProvider.id);
      }

      return existingServiceProvderIds;
    },

    unavailableServiceAreas: function unavailableServiceAreas() {
      var combinedRelationship = {
        accessibility: false,
        baby: false,
        bins: false,
        doors: false,
        driers: false,
        heating: false,
        lighting: false,
        mirror: false,
        paint: false,
        toiletpaper: false,
        sanitarybins: false,
        sinks: false,
        smell: false,
        soap: false,
        suggestions: false,
        toilet: false,
        towels: false,
        urinals: false,
        vending: false,
        walls: false
      };

      for (var i in this.serviceRelationships) {
        for (var j in combinedRelationship) {
          if (this.serviceRelationships[i][j] === true) {
            combinedRelationship[j] = true;
          }
        }
      }

      return combinedRelationship;
    },

    incomingConnectionsCount: function incomingConnectionsCount() {
      var incomingConnections = null;

      if (this.userMode == 'service-providers') {
        incomingConnections = this.serviceRelationships.filter(function (item) {
          if (item.status == 'pending' && item.origin == 'retailer') {
            return true;
          }

          return false;
        });
      } else {
        incomingConnections = this.serviceRelationships.filter(function (item) {
          if (item.status == 'pending' && item.origin == 'service-provider') {
            return true;
          }

          return false;
        });
      }

      return incomingConnections.length;
    },

    connectionsCount: function connectionsCount() {
      var incomingConnections = null;

      if (this.userMode == 'service-providers') {
        incomingConnections = this.serviceRelationships.filter(function (item) {
          if (item.status == 'pending' && item.origin == 'service-provider') {
            return true;
          }

          return false;
        });
      } else {
        incomingConnections = this.serviceRelationships.filter(function (item) {
          if (item.status == 'pending' && item.origin != 'service-provider' || item.status == 'approved' || item.status == 'declined') {
            return true;
          }

          return false;
        });
      }

      return incomingConnections.length;
    }
  },

  watch: {
    'viewMode': function viewMode(to, from) {
      if (to === 'add') {
        this.getServiceProviders();
      } else if (to === null) {
        this.init();
      }
    },
    '$route': function $route(to, from) {
      this.init();
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_ReviewStars_ReviewStars_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ui_ReviewStars_ReviewStars_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ui_ReviewStars_ReviewStars_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_IssueCount_IssueCount_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_IssueCount_IssueCount_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_IssueCount_IssueCount_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_WashroomIcon_WashroomIcon_vue__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ui_WashroomIcon_WashroomIcon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ui_WashroomIcon_WashroomIcon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ServiceRelationshipsService_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_SubscriptionsService_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_MultiSitesService_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_WashroomsService_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_ReviewsService_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_IssuesService_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__EventBus_js__ = __webpack_require__(3);
// Components - UI




// Services








// Mixins


// EventBus


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Washrooms',

  mixins: [__WEBPACK_IMPORTED_MODULE_10__components_mixins_StaggerEntranceTransition_StaggerEntranceTransition_vue___default.a],

  components: {
    ReviewStars: __WEBPACK_IMPORTED_MODULE_0__components_ui_ReviewStars_ReviewStars_vue___default.a,
    IssueCount: __WEBPACK_IMPORTED_MODULE_1__components_ui_IssueCount_IssueCount_vue___default.a,
    WashroomIcon: __WEBPACK_IMPORTED_MODULE_2__components_ui_WashroomIcon_WashroomIcon_vue___default.a
  },

  data: function data() {
    return {
      userGroup: localStorage.getItem('userGroup'),
      pageTitle: null,
      washrooms: [],
      retailer: null,
      searchTerm: null,
      showSearch: false,

      // Add washroom
      addMode: false,
      newWashroom: {
        name: null,
        facilityType: 'select'
      }
    };
  },

  created: function created() {
    this.init();
  },

  mounted: function mounted() {},

  beforeDestroy: function beforeDestroy() {},

  methods: {
    init: function init() {
      var _this = this;

      // Reset component data
      this.washrooms = [];
      this.retailer = null;

      var filter = {};

      if (this.$route.params.retailerId) {
        // Get Multisite name as page title
        __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__["a" /* default */].getById(this.$route.params.retailerId).then(function (res) {
          _this.pageTitle = res.data.name;
        }).catch(function (err) {});

        filter = {
          retailer: this.$route.params.retailerId
        };

        this.getWashrooms(filter);
      }
      // If we are logged in as a retailer
      else if (localStorage.getItem('userGroup') == 'retailers') {
          filter = {
            retailer: localStorage.getItem('parentId') // In this case 'parentID' is the logged in retailer's id
          };

          this.getWashrooms(filter);
        }
        // If we are logged in as a multi-site retailer
        else if (localStorage.getItem('userGroup') == 'multi-site-retailers') {
            __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__["a" /* default */].getAll({ multiSite: localStorage.getItem('parentId') }) // In this case 'parentID' is the logged in multi-site-retailer's id
            .then(function (res) {
              filter = [];

              for (var i in res.data) {
                filter.push({ retailer: res.data[i].id });
              }

              _this.getWashrooms(filter, 'or');
            }).catch(function (err) {
              __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
            });
          }
          // If we are logged in as a service provider
          else if (localStorage.getItem('userGroup') == 'service-providers') {
              // If we are logged in as a service provider
              __WEBPACK_IMPORTED_MODULE_3__services_ServiceRelationshipsService_js__["a" /* default */].getAll({ serviceProvider: localStorage.getItem('parentId') }).then(function (res) {
                var retailerIds = [];
                var filter = [];
                var filterMode = 'or';

                // Get DISTINCT ids of retailers that this SP services
                for (var i in res.data) {
                  if (res.data[i].retailer && res.data[i].retailer.id) {
                    if (retailerIds.indexOf(res.data[i].retailer.id) == -1) {
                      retailerIds.push(res.data[i].retailer.id);
                      filter.push({ retailer: res.data[i].retailer.id });
                    }
                  }
                }

                if (filter.length > 0) {
                  _this.getWashrooms(filter, filterMode);
                }
              }).catch(function (err) {
                __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
              });
            } else {
              this.getWashrooms();
            }

      // If we have a retailer ID, fetch the retailer for populating the header
      if (filter.retailer) {
        __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__["a" /* default */].getById(filter.retailer).then(function (res) {
          _this.retailer = res.data;
        });
      }
    },

    getWashrooms: function getWashrooms(filter, filterMode) {
      var _this2 = this;

      if (this.$route.params.multisiteId) {
        // Get Multisite name as page title
        __WEBPACK_IMPORTED_MODULE_5__services_MultiSitesService_js__["a" /* default */].getById(this.$route.params.multisiteId).then(function (res) {
          _this2.pageTitle = res.data.name;
        }).catch(function (err) {});

        // Load washrooms for the multisite id
        __WEBPACK_IMPORTED_MODULE_6__services_WashroomsService_js__["a" /* default */].getByMultisiteId(this.$route.params.multisiteId, filter, filterMode).then(function (res) {
          _this2.populateWashroomData(res);
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
      } else {
        // Load all the washrooms
        __WEBPACK_IMPORTED_MODULE_6__services_WashroomsService_js__["a" /* default */].getAll(filter, filterMode).then(function (res) {
          _this2.populateWashroomData(res);
        }).catch(function (err) {
          __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
      }
    },

    populateWashroomData: function populateWashroomData(res) {
      var _this3 = this;

      for (var _i in res.data) {
        res.data[_i].issues = [];
      }

      // Store washroom data
      this.washrooms = res.data;

      // Loop through washrooms adding additional data

      var _loop = function _loop() {

        // Create a variable storing the washroom to be used in promises
        var washroom = _this3.washrooms[i];

        // Get Retailer
        __WEBPACK_IMPORTED_MODULE_7__services_RetailersService_js__["a" /* default */].getById(washroom.retailer).then(function (res) {
          // Add retailerData onto the washroom
          _this3.$set(washroom, 'retailerData', res.data);
        });

        var issuesFilter = { washroom: washroom.id };

        if (localStorage.getItem('userGroup') == 'service-providers') {
          issuesFilter.serviceProvider = localStorage.getItem('parentId');

          issuesFilter.status = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];
        }

        // Get Issues for Washroom
        __WEBPACK_IMPORTED_MODULE_9__services_IssuesService_js__["a" /* default */].getAll(issuesFilter).then(function (res) {
          // Add retailerData onto the washroom
          _this3.$set(washroom, 'issues', res.data);
        });

        // Get Review Stats for Washroom
        __WEBPACK_IMPORTED_MODULE_6__services_WashroomsService_js__["a" /* default */].getReviewStats(washroom.id).then(function (res) {
          // Add reviewStats onto the washroom
          _this3.$set(washroom, 'reviewStats', res.data);
        });
      };

      for (var i = 0; i < this.washrooms.length; i++) {
        _loop();
      }
    },

    openSearch: function openSearch() {
      var _this4 = this;

      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(function () {
        _this4.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function closeSearch() {
      this.searchTerm = null;
      this.showSearch = false;
    },

    cancelNewWashroom: function cancelNewWashroom() {
      this.addMode = false;
      this.newWashroom = {
        name: null,
        facilityType: 'select'
      };
    },

    saveNewWashroom: function saveNewWashroom() {
      var _this5 = this;

      // Validate input
      if (this.newWashroom.name == null || this.newWashroom.name.trim() == '' || this.newWashroom.facilityType == 'select') {
        __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Please provide both a washroom name and type before attempting to save.');
      }
      // Save new Washroom
      else {
          __WEBPACK_IMPORTED_MODULE_4__services_SubscriptionsService_js__["a" /* default */].getAll({ retailer: localStorage.getItem('parentId') }).then(function (res) {
            if (res.data.length > 0) {
              var subscriptionPackage = res.data[0].package;
              var maxWashrooms = __WEBPACK_IMPORTED_MODULE_4__services_SubscriptionsService_js__["a" /* default */].packages[subscriptionPackage].maxWashrooms;

              if (_this5.search.length < maxWashrooms) {
                var newWashroom = {
                  name: _this5.newWashroom.name,
                  facilityType: _this5.newWashroom.facilityType,
                  retailer: localStorage.getItem('parentId')
                };

                __WEBPACK_IMPORTED_MODULE_6__services_WashroomsService_js__["a" /* default */].createOne(newWashroom).then(function (res) {
                  _this5.addMode = false;
                  _this5.newWashroom = {
                    name: null,
                    facilityType: 'select'
                  };
                  _this5.init();
                }).catch(function (err) {
                  __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! Something went wrong adding the washroom, please try again.');
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Washroom limit reached, to increase your limit please upgrade your package.');
              }
            } else {
              __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('We couldn\'t find a valid subscription for this account, please try again.');
            }
          }).catch(function (err) {
            __WEBPACK_IMPORTED_MODULE_11__EventBus_js__["a" /* EventBus */].dispatchErrorEvent('Whoops! There was a problem communicating with the server, please try again.');
          });
        }
    }
  },

  computed: {
    search: function search() {
      var _this6 = this;

      if (this.searchTerm && this.searchTerm.trim().length > 0) {
        return this.washrooms.filter(function (w) {
          if (w.name.toLowerCase().trim().indexOf(_this6.searchTerm.toLowerCase().trim()) > -1 || w.retailerData.address.toLowerCase().trim().indexOf(_this6.searchTerm.toLowerCase().trim()) > -1 || w.retailerData.city.toLowerCase().trim().indexOf(_this6.searchTerm.toLowerCase().trim()) > -1 || w.retailerData.postcode.toLowerCase().trim().indexOf(_this6.searchTerm.toLowerCase().trim()) > -1) {
            return true;
          }

          return false;
        });
      } else {
        return this.washrooms;
      }
    }
  },

  watch: {
    '$route': function $route(to, from) {
      this.init();
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventBus_js__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dialog-panel',

  data: function data() {
    return {
      key: "pair",
      message: null,
      options: null,
      timeout: null,
      panelOpen: false
    };
  },

  mounted: function mounted() {
    // Listen for global events
    __WEBPACK_IMPORTED_MODULE_0__EventBus_js__["a" /* EventBus */].$on('dialogEvent', this.onDialogEvent);
    __WEBPACK_IMPORTED_MODULE_0__EventBus_js__["a" /* EventBus */].$on('errorEvent', this.onDialogEvent);
  },

  beforeDestroy: function beforeDestroy() {
    // Release event listeners
    __WEBPACK_IMPORTED_MODULE_0__EventBus_js__["a" /* EventBus */].$off('dialogEvent');
    __WEBPACK_IMPORTED_MODULE_0__EventBus_js__["a" /* EventBus */].$off('errorEvent');
  },

  methods: {
    /**
      * An event which requires a dialog panel has been recieved
      *
      * @param { string } The message we want to display in the dialog panel
      * @param { array } Options for the user to select from in the of the form { optionText:optionText , optionEvent:optionEvent }
      */
    onDialogEvent: function onDialogEvent(message, options) {
      var _this = this;

      this.panelOpen = true;
      this.message = message;
      this.options = [];

      if (options) this.options = options;

      // Clear old timeout
      if (this.timeout) clearTimeout(this.timeout);

      // If we have no options clese panel after a period
      if (this.options.length == 0) {
        this.timeout = setTimeout(function () {
          _this.closePanel();
        }, 4000);
      }
    },

    /**
      * One of the options in the current dialog has been clicked
      * We look up the optionEvent for that option e.g. "delteConfirmed" then emit that event.
      * If the option has and optionData this will also be emitted.
      *
      * @param { int } The index of the clicked option
      */
    onOptionClick: function onOptionClick(optionIndex) {

      var clickedOptionEventName = this.options[optionIndex].optionEvent;

      // If we have a clickedOptionEventName then we fire an event
      if (clickedOptionEventName) {
        var data = this.options[optionIndex].optionData;
        __WEBPACK_IMPORTED_MODULE_0__EventBus_js__["a" /* EventBus */].$emit(clickedOptionEventName, data);
      }

      // Close the panel
      this.closePanel();
    },

    /**
      * Close the panel
      */
    closePanel: function closePanel() {

      this.panelOpen = false;
    }
  },

  computed: {}
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'line-chart',

  props: ['plots', 'labels', 'yStepsSize', 'yMax'],

  data: function data() {
    return {
      ctx: null,
      chart: null,
      yTicksConfig: {
        beginAtZero: true,
        fontSize: 10
      }
    };
  },

  mounted: function mounted() {
    if (this.yStepsSize) {
      this.yTicksConfig.stepSize = this.yStepsSize;
    }

    if (this.yMax) {
      this.yTicksConfig.max = this.yMax;
    }

    if (this.plots && this.labels && !this.chart) {
      this.init();
    }
  },

  beforeDestroy: function beforeDestroy() {},

  methods: {
    init: function init() {
      this.ctx = this.$refs.canvas;
      // defaults
      __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults.global.defaultFontColor = '#48c5db';

      // Options for the chart
      var options = {
        // Make chart flexible
        maintainAspectRatio: false,
        // Straight lines
        elements: {
          line: {
            tension: 0 // disables bezier curves
          }
        },
        // Hide legend
        legend: {
          display: false
        },
        tooltips: {
          backgroundColor: '#fff',
          titleFontFamily: "'PlutoSansRegular', 'Helvetica', 'Arial', sans-serif",
          titleFontSize: 12,
          titleFontStyle: 'bold',
          titleFontColor: '#a5a5a5',
          titleSpacing: 2,
          titleMarginBottom: 6,
          bodyFontColor: '#a5a5a5',
          bodyFontFamily: "'PlutoSansRegularCond', 'Helvetica', 'Arial', sans-serif",
          borderColor: '#ebebeb',
          borderWidth: 1,
          xPadding: 20,
          yPadding: 10,
          displayColors: true,
          caretPadding: 4,
          caretSize: 8
        },
        // Axes and grid lines
        scales: {
          xAxes: [{
            gridLines: {
              display: false
            },
            ticks: {
              beginAtZero: true,
              min: 0,
              fontSize: 10
            }
          }],
          yAxes: [{
            ticks: this.yTicksConfig
          }]
        }

        // Data object we will style
      };var styledData = {
        'labels': this.labels,
        'datasets': [{
          'data': this.plots
        }]

        // Set the color of each dataset's lines and points
      };for (var i = 0; i < styledData.datasets.length; i++) {
        styledData.datasets[i].borderColor = '#48c5db', styledData.datasets[i].borderWidth = 1.5, styledData.datasets[i].backgroundColor = 'transparent', styledData.datasets[i].pointBackgroundColor = "#48c5db", styledData.datasets[i].pointRadius = 3, styledData.datasets[i].pointHoverRadius = 3;
      }

      this.chart = new __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a(this.ctx, { 'type': 'line', 'data': styledData, 'options': options });
    }
  },

  computed: {},

  watch: {
    labels: function labels(newVal, oldVal) {
      // watch it
      if (this.plots && this.labels && !this.chart) {
        this.init();
      }
    },

    plots: function plots(newVal, oldVal) {
      if (this.plots && this.labels && !this.chart) {
        this.init();
      }
    }
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventBus_js__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__);
// Uses vue2-google-maps see documentation
// https://github.com/xkjyeah/vue-google-maps/blob/HEAD/API.md#icon--object

// Services



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'list-view-map',

  props: ['items'],

  data: function data() {
    return {
      center: { lat: 52.9244856, lng: -1.4797866 },
      selectedItem: null,
      selectedItemPosition: null,
      infoWinOpen: true,
      styles: [{
        "elementType": "geometry",
        "stylers": [{
          "color": "#f5f5f5"
        }]
      }, {
        "elementType": "labels.icon",
        "stylers": [{
          "visibility": "off"
        }]
      }, {
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#616161"
        }]
      }, {
        "elementType": "labels.text.stroke",
        "stylers": [{
          "color": "#f5f5f5"
        }]
      }, {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#bdbdbd"
        }]
      }, {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [{
          "color": "#eeeeee"
        }]
      }, {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#757575"
        }]
      }, {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [{
          "color": "#e5e5e5"
        }]
      }, {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#9e9e9e"
        }]
      }, {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [{
          "color": "#ffffff"
        }]
      }, {
        "featureType": "road",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#fdfffc"
        }]
      }, {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#757575"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [{
          "color": "#dadada"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#fdfffc"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [{
          "color": "#fdfffc"
        }]
      }, {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#616161"
        }]
      }, {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#9e9e9e"
        }]
      }, {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [{
          "color": "#e5e5e5"
        }]
      }, {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [{
          "color": "#eeeeee"
        }]
      }, {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [{
          "color": "#c9c9c9"
        }]
      }, {
        "featureType": "water",
        "elementType": "geometry.fill",
        "stylers": [{
          "color": "#3abbed"
        }]
      }, {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [{
          "color": "#ffffff"
        }]
      }]
    };
  },

  mounted: function mounted() {
    var mapElement = this.$refs.mapCanvas;
    if (!window.google || !window.google.maps) {
      //handle script not loaded
    }
  },

  beforeDestroy: function beforeDestroy() {},

  methods: {
    onMarkerClick: function onMarkerClick(position, index) {
      this.selectedItem = this.items[index];
      this.selectedItemPosition = position;
      this.infoWinOpen = true;
    }
  },

  computed: {

    /**
      * @private
      */
    markers: function markers() {
      // Create position objects from the item info we have
      var positions = [];
      var item = null;
      for (var i = 0; i < this.items.length; i++) {
        item = this.items[i];
        positions.push({ 'position': { 'lat': item.lat, 'lng': item.lng } });
      }

      return positions;
    }

  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_AuthenticationService__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventBus_js__ = __webpack_require__(3);
// Services



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',

  data: function data() {
    return {
      userGroup: null,
      homeRoute: null,
      user: null,

      navItems: {
        'hsg-admins': [{ route: '/retailers', name: 'Retailers' }, { route: '/retailers-multi', name: 'Multi-Site Retailers' }, { route: '/reviews', name: 'Reviews' }, { route: '/washrooms', name: 'Washrooms' }, { route: '/service-providers', name: 'Service Providers' }, { route: '/account', name: 'Manage Account' }, { route: '/admin', name: 'Admin' }],
        'service-providers': [{ route: '/service-relationships', name: 'Connections' }, { route: '/retailers', name: 'Retailers' }, { route: '/retailers-multi', name: 'Multi-Site Retailers' }, { route: '/reviews', name: 'Reviews' }, { route: '/washrooms', name: 'Washrooms' }, { route: '/account', name: 'Manage Account' }],
        'multi-site-retailers': [{ route: '/retailers', name: 'Retailers' }, { route: '/reviews', name: 'Reviews' }, { route: '/washrooms', name: 'Washrooms' }, { route: '/service-providers', name: 'Service Providers' }, { route: '/account', name: 'Manage Account' }],
        'retailers': [{ route: '/retailers/' + localStorage.getItem('parentId'), name: 'Site Info' }, { route: '/service-relationships', name: 'Connections' }, { route: '/reviews', name: 'Reviews' }, { route: '/washrooms', name: 'Washrooms' }, { route: '/account', name: 'Manage Account' }]
      }
    };
  },

  created: function created() {
    this.userGroup = localStorage.getItem('userGroup');
    this.homeRoute = localStorage.getItem('homeRoute');
    this.user = JSON.parse(localStorage.getItem('userObject'));
  },

  beforeDestroy: function beforeDestroy() {},

  methods: {
    doLogout: function doLogout() {
      __WEBPACK_IMPORTED_MODULE_0__services_AuthenticationService__["a" /* default */].logout(this.$router);
    }
  },

  computed: {
    userRole: function userRole() {
      switch (this.userGroup) {
        case 'hsg-admins':
          return 'HSG Admin';

        case 'service-providers':
          return 'Service Provider';

        case 'multi-site-retailers':
          return 'Multi-Site Retailer';

        case 'retailers':
          return 'Retailer';
      }

      return 'Unknown Role';
    },

    userInitials: function userInitials() {
      var names = this.user.fullName.split(' ');

      var firstLetters = '';

      // If name consists of a single word
      if (names.length == 1) {
        firstLetters = names[0].substring(0, 2);
      }
      // If name consists of more than one word
      else {
          while (names.length > 0 && firstLetters.length <= 2) {
            firstLetters += names.shift()[0];
          }
        }

      return firstLetters;
    }
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
  * Radial Progress Bar
  * ===================
  * A circluar loading bar
  *
  * @prop progressPercentage {number} The percentage loaded
  */

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'radial-progress-bar',

  props: ['progressPercentage'],

  mounted: function mounted() {
    window.requestAnimationFrame(this.onAnimationFrame);
  },

  beforeDestroy: function beforeDestroy() {
    if (this.animationFrameRequest) window.cancelAnimationFrame(this.animationFrameRequest);
  },

  data: function data() {
    return {
      barPosition: 0,
      lastAnimationFrameTime: 0,
      displayedPercentage: 0,
      animationFrameRequest: null
    };
  },

  methods: {

    /**
      * The browser is ready to render another frame so  animate the progress bar
      *
      * @param currentTime {int} Timestamp of the current time now
      */
    onAnimationFrame: function onAnimationFrame(currentTime) {

      // Time since last frame
      var deltaTime = (currentTime - this.lastAnimationFrameTime) / 1000;
      this.lastAnimationFrameTime = currentTime;

      // Which direction should the bar travel
      var direction = 1;
      if (this.progressPercentage < this.displayedPercentage) {
        direction = -1;
      } else if (this.progressPercentage == this.displayedPercentage) {
        direction = 0;
      }

      // Will the bar reach it's target this frame
      var changeInPosition = direction * 100 * deltaTime;
      if (direction < 0 && this.displayedPercentage + changeInPosition < this.progressPercentage || direction > 0 && this.displayedPercentage + changeInPosition > this.progressPercentage) {
        changeInPosition = 0;
        this.displayedPercentage = this.progressPercentage;
      }

      // Move barPosition
      this.displayedPercentage += changeInPosition;

      // Clamp bar between 360 and 0
      if (this.displayedPercentage > 100) {
        this.displayedPercentage = 100;
      } else if (this.displayedPercentage < 0) {
        this.displayedPercentage = 0;
      }

      this.barPosition = this.displayedPercentage / 100 * 360;

      // Rotate the left half circle up until 180 degrees
      if (this.barPosition < 180) {
        this.$refs.leftHalfCircle.style.transform = 'rotate(' + this.barPosition + 'deg)';
        this.$refs.rightHalfCircle.style.transform = 'rotate(180deg)';
      }
      // Then rotate the right half circle up to 360 degrees
      else {
          this.$refs.leftHalfCircle.style.transform = 'rotate(180deg)';
          this.$refs.rightHalfCircle.style.transform = 'rotate(' + this.barPosition + 'deg)';
        }

      // Keep upadting until the bar has rotated 360 degrees
      //if( this.barPosition < 360 )
      this.animationFrameRequest = window.requestAnimationFrame(this.onAnimationFrame);
    }

  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuebar__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_filter__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








// Promise polyfill for IE11
__WEBPACK_IMPORTED_MODULE_3_es6_promise___default.a.polyfill();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vuebar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_filter___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__, {
  load: {
    key: 'AIzaSyBYZaHIGxf8gHHBjycxCilYSi_OAffeaYY'
    //libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue___default.a }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

var address_components = null;

function get(type) {
  var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(address_components), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var component = _step.value;

      if (component.types.includes(type)) {
        return short ? component.short_name : component.long_name;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return null;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  parsePlace: function parsePlace(place) {
    address_components = place.address_components;

    var result = {
      street_number: get('street_number'),
      street_name: get('route'),
      city: get('locality'),
      county: get('administrative_area_level_2'),
      state_short: get('administrative_area_level_1', true),
      state_long: get('administrative_area_level_1'),
      country_short: get('country', true),
      country_long: get('country'),
      zip_code: get('postal_code')
    };

    if (result.street_number && result.street_name) {
      result.address = result.street_number + ' ' + result.street_name;
    } else if (result.street_name) {
      result.address = result.street_name;
    } else {
      result.address = '';
    }

    return result;
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



var restModel = 'googleplaces';
var baseUrl = "https://cleen-backend.herokuapp.com/api/v1";
var httpConfig = function httpConfig() {
  return { headers: { 'x-auth-token': localStorage.getItem('accessToken') } };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  textSearch: function textSearch(searchTerm, lat, lng) {
    var data = { searchTerm: searchTerm };

    if (lat && lng) {
      data.lat = lat;
      data.lng = lng;
    }

    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/textsearch', data, httpConfig());
  },
  nearbySearch: function nearbySearch(searchTerm, lat, lng) {
    var data = { searchTerm: searchTerm, lat: lat, lng: lng };
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/nearbysearch', data, httpConfig());
  },
  getPlaceDetails: function getPlaceDetails(placeId) {
    return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(baseUrl + '/' + restModel + '/getplacedetails', { placeId: placeId }, httpConfig());
  }
});

/***/ }),
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 103,
	"./af.js": 103,
	"./ar": 110,
	"./ar-dz": 104,
	"./ar-dz.js": 104,
	"./ar-kw": 105,
	"./ar-kw.js": 105,
	"./ar-ly": 106,
	"./ar-ly.js": 106,
	"./ar-ma": 107,
	"./ar-ma.js": 107,
	"./ar-sa": 108,
	"./ar-sa.js": 108,
	"./ar-tn": 109,
	"./ar-tn.js": 109,
	"./ar.js": 110,
	"./az": 111,
	"./az.js": 111,
	"./be": 112,
	"./be.js": 112,
	"./bg": 113,
	"./bg.js": 113,
	"./bm": 114,
	"./bm.js": 114,
	"./bn": 115,
	"./bn.js": 115,
	"./bo": 116,
	"./bo.js": 116,
	"./br": 117,
	"./br.js": 117,
	"./bs": 118,
	"./bs.js": 118,
	"./ca": 119,
	"./ca.js": 119,
	"./cs": 120,
	"./cs.js": 120,
	"./cv": 121,
	"./cv.js": 121,
	"./cy": 122,
	"./cy.js": 122,
	"./da": 123,
	"./da.js": 123,
	"./de": 126,
	"./de-at": 124,
	"./de-at.js": 124,
	"./de-ch": 125,
	"./de-ch.js": 125,
	"./de.js": 126,
	"./dv": 127,
	"./dv.js": 127,
	"./el": 128,
	"./el.js": 128,
	"./en-au": 129,
	"./en-au.js": 129,
	"./en-ca": 130,
	"./en-ca.js": 130,
	"./en-gb": 131,
	"./en-gb.js": 131,
	"./en-ie": 132,
	"./en-ie.js": 132,
	"./en-nz": 133,
	"./en-nz.js": 133,
	"./eo": 134,
	"./eo.js": 134,
	"./es": 137,
	"./es-do": 135,
	"./es-do.js": 135,
	"./es-us": 136,
	"./es-us.js": 136,
	"./es.js": 137,
	"./et": 138,
	"./et.js": 138,
	"./eu": 139,
	"./eu.js": 139,
	"./fa": 140,
	"./fa.js": 140,
	"./fi": 141,
	"./fi.js": 141,
	"./fo": 142,
	"./fo.js": 142,
	"./fr": 145,
	"./fr-ca": 143,
	"./fr-ca.js": 143,
	"./fr-ch": 144,
	"./fr-ch.js": 144,
	"./fr.js": 145,
	"./fy": 146,
	"./fy.js": 146,
	"./gd": 147,
	"./gd.js": 147,
	"./gl": 148,
	"./gl.js": 148,
	"./gom-latn": 149,
	"./gom-latn.js": 149,
	"./gu": 150,
	"./gu.js": 150,
	"./he": 151,
	"./he.js": 151,
	"./hi": 152,
	"./hi.js": 152,
	"./hr": 153,
	"./hr.js": 153,
	"./hu": 154,
	"./hu.js": 154,
	"./hy-am": 155,
	"./hy-am.js": 155,
	"./id": 156,
	"./id.js": 156,
	"./is": 157,
	"./is.js": 157,
	"./it": 158,
	"./it.js": 158,
	"./ja": 159,
	"./ja.js": 159,
	"./jv": 160,
	"./jv.js": 160,
	"./ka": 161,
	"./ka.js": 161,
	"./kk": 162,
	"./kk.js": 162,
	"./km": 163,
	"./km.js": 163,
	"./kn": 164,
	"./kn.js": 164,
	"./ko": 165,
	"./ko.js": 165,
	"./ky": 166,
	"./ky.js": 166,
	"./lb": 167,
	"./lb.js": 167,
	"./lo": 168,
	"./lo.js": 168,
	"./lt": 169,
	"./lt.js": 169,
	"./lv": 170,
	"./lv.js": 170,
	"./me": 171,
	"./me.js": 171,
	"./mi": 172,
	"./mi.js": 172,
	"./mk": 173,
	"./mk.js": 173,
	"./ml": 174,
	"./ml.js": 174,
	"./mr": 175,
	"./mr.js": 175,
	"./ms": 177,
	"./ms-my": 176,
	"./ms-my.js": 176,
	"./ms.js": 177,
	"./my": 178,
	"./my.js": 178,
	"./nb": 179,
	"./nb.js": 179,
	"./ne": 180,
	"./ne.js": 180,
	"./nl": 182,
	"./nl-be": 181,
	"./nl-be.js": 181,
	"./nl.js": 182,
	"./nn": 183,
	"./nn.js": 183,
	"./pa-in": 184,
	"./pa-in.js": 184,
	"./pl": 185,
	"./pl.js": 185,
	"./pt": 187,
	"./pt-br": 186,
	"./pt-br.js": 186,
	"./pt.js": 187,
	"./ro": 188,
	"./ro.js": 188,
	"./ru": 189,
	"./ru.js": 189,
	"./sd": 190,
	"./sd.js": 190,
	"./se": 191,
	"./se.js": 191,
	"./si": 192,
	"./si.js": 192,
	"./sk": 193,
	"./sk.js": 193,
	"./sl": 194,
	"./sl.js": 194,
	"./sq": 195,
	"./sq.js": 195,
	"./sr": 197,
	"./sr-cyrl": 196,
	"./sr-cyrl.js": 196,
	"./sr.js": 197,
	"./ss": 198,
	"./ss.js": 198,
	"./sv": 199,
	"./sv.js": 199,
	"./sw": 200,
	"./sw.js": 200,
	"./ta": 201,
	"./ta.js": 201,
	"./te": 202,
	"./te.js": 202,
	"./tet": 203,
	"./tet.js": 203,
	"./th": 204,
	"./th.js": 204,
	"./tl-ph": 205,
	"./tl-ph.js": 205,
	"./tlh": 206,
	"./tlh.js": 206,
	"./tr": 207,
	"./tr.js": 207,
	"./tzl": 208,
	"./tzl.js": 208,
	"./tzm": 210,
	"./tzm-latn": 209,
	"./tzm-latn.js": 209,
	"./tzm.js": 210,
	"./uk": 211,
	"./uk.js": 211,
	"./ur": 212,
	"./ur.js": 212,
	"./uz": 214,
	"./uz-latn": 213,
	"./uz-latn.js": 213,
	"./uz.js": 214,
	"./vi": 215,
	"./vi.js": 215,
	"./x-pseudo": 216,
	"./x-pseudo.js": 216,
	"./yo": 217,
	"./yo.js": 217,
	"./zh-cn": 218,
	"./zh-cn.js": 218,
	"./zh-hk": 219,
	"./zh-hk.js": 219,
	"./zh-tw": 220,
	"./zh-tw.js": 220
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 438;

/***/ }),
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(286),
  /* template */
  __webpack_require__(530),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(287),
  /* template */
  __webpack_require__(538),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(396)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(288),
  /* template */
  __webpack_require__(526),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(289),
  /* template */
  __webpack_require__(556),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(413)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(545),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(416)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(292),
  /* template */
  __webpack_require__(548),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d475145",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(293),
  /* template */
  __webpack_require__(551),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a445889",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(294),
  /* template */
  __webpack_require__(552),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c6cadd3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(400)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(295),
  /* template */
  __webpack_require__(531),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(432)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(565),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(411)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(297),
  /* template */
  __webpack_require__(543),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f51b41e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(298),
  /* template */
  __webpack_require__(532),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c2a655a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(403)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(534),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-10a1fae9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(429)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(562),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-960fedbe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(541),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3baf9a7a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(433)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(566),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ec87294e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(402)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(533),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0e7e1489",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(425)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(558),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-877fa9ae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(408)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(540),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3a1ffe46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(431)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(564),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bf202f82",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(537),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1638dfef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(428)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(561),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-901ed88e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(430)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(563),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-97da5702",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(426)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(559),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8d3d8142",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(308),
  /* template */
  __webpack_require__(567),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-eef1e81a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(410)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(309),
  /* template */
  __webpack_require__(542),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ea4123f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(417)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(549),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6342ed0f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(424)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(557),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-825ea1c2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(550),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-64e82cd1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(399)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(529),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0614ea5f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(282),
  /* template */
  __webpack_require__(560),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8d9a329e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(435)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(283),
  /* template */
  __webpack_require__(568),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fc81f88a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-icon"
  }, [_c('span', {
    staticClass: "user-icon__initials font-primary--bold"
  }, [_vm._v(_vm._s(_vm.initials))])])
},staticRenderFns: []}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review-mood"
  }, [(_vm.mood == 'positive') ? _c('img', {
    staticClass: "mood-icon",
    attrs: {
      "src": "/static/img/mood--positive.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mood == 'negative') ? _c('img', {
    staticClass: "mood-icon",
    attrs: {
      "src": "/static/img/mood--negative.svg"
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "splitter"
  })
},staticRenderFns: []}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.mode == 'login') ? _c('div', {
    key: "login",
    staticClass: "login padding--large text--center",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.doLogin()
      }
    }
  }, [_c('div', {
    staticClass: "form login__form"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo-light.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "inputEmail",
    staticClass: "login__username",
    attrs: {
      "placeholder": "Email Address",
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "login__password",
    attrs: {
      "placeholder": "Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.loginActive) ? _c('div', [_c('p', [_vm._v("Loading")])]) : _c('div', [_c('input', {
    staticClass: "login__submit",
    attrs: {
      "type": "submit",
      "value": "Log In"
    },
    on: {
      "click": function($event) {
        _vm.doLogin()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "login__forgotten-password",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.mode = 'forgot-password'
      }
    }
  }, [_vm._v("Forgotten Password?")])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.mode == 'forgot-password') ? _c('div', {
    key: "forgot",
    staticClass: "login padding--large text--center",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.doResetPassword()
      }
    }
  }, [_c('div', {
    staticClass: "form login__form"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo-light.svg"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.passwordResetSent) ? _c('div', {
    key: "notsent"
  }, [_c('p', {
    staticClass: "message text--center"
  }, [_vm._v("Enter your email address to be sent a password reset link")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailReset),
      expression: "emailReset"
    }],
    ref: "inputEmailReset",
    staticClass: "login__username reset",
    attrs: {
      "placeholder": "Email Address",
      "type": "email"
    },
    domProps: {
      "value": (_vm.emailReset)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailReset = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "login__submit",
    attrs: {
      "type": "submit",
      "value": "Go"
    },
    on: {
      "click": function($event) {
        _vm.doResetPassword()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "login__forgotten-password",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.mode = 'login'
      }
    }
  }, [_vm._v("Cancel")])])]) : _c('div', {
    key: "sent"
  }, [_c('p', {
    staticClass: "message text--center"
  }, [_vm._v("An email has been sent to '" + _vm._s(_vm.emailReset) + "'. Please follow the instructions contained within to reset your password...")]), _vm._v(" "), _c('a', {
    staticClass: "login__forgotten-password",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Go back to Login")])])])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.retailer) ? _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('div', {
    staticClass: "panel panel--header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.retailer.name) + " | Retailer")])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "60%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Contact Info")]), _vm._v(" "), _c('div', {
    staticClass: "card__content contact-info"
  }, [_c('p', {
    staticClass: "contact-info__name"
  }, [_vm._v(_vm._s(_vm.retailer.contactName))]), _vm._v(" "), _c('p', {
    staticClass: "contact-info__address"
  }, [_vm._v(_vm._s(_vm.retailer.address) + ","), _c('br'), _vm._v(_vm._s(_vm.retailer.city) + ", " + _vm._s(_vm.retailer.postcode))]), _vm._v(" "), _c('p', {
    staticClass: "contact-info__methods"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.retailer.contactTelephone
    }
  }, [_vm._v(_vm._s(_vm.retailer.contactTelephone))]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.retailer.contactEmail
    }
  }, [_vm._v(_vm._s(_vm.retailer.contactEmail))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "40%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Washrooms")]), _vm._v(" "), _c('router-link', {
    staticClass: "card__more-link",
    attrs: {
      "to": '/washrooms/retailer/' + _vm.retailer.id
    }
  }, [_vm._v("See All")]), _vm._v(" "), _c('div', {
    staticClass: "card__content washrooms"
  }, [_c('washrooms-count', {
    attrs: {
      "washrooms": _vm.washrooms,
      "large": true
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading tabs__heading"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      active: _vm.activeChart === 1
    },
    on: {
      "click": function($event) {
        _vm.activeChart = 1
      }
    }
  }, [_vm._v("Reviews Over Time")]), _c('span', {
    staticClass: "tab",
    class: {
      active: _vm.activeChart === 2
    },
    on: {
      "click": function($event) {
        _vm.activeChart = 2
      }
    }
  }, [_vm._v("Rating Over Time")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.activeChart === 1) ? _c('line-chart', {
    key: "1",
    attrs: {
      "y-steps-size": 1,
      "plots": _vm.reviewsPerDayPlots(_vm.recentReviewsPerDay),
      "labels": _vm.reviewsPerDayLabels(_vm.recentReviewsPerDay)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeChart === 2) ? _c('line-chart', {
    key: "2",
    attrs: {
      "y-steps-size": 1,
      "y-max": 5,
      "plots": _vm.averageRatingPerDayPlots(_vm.recentAverageRatingPerDay),
      "labels": _vm.averageRatingPerDayLabels(_vm.recentAverageRatingPerDay)
    }
  }) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "40%"
    }
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Team")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('scroller', [_c('ul', {
    staticClass: "list-bare list-hover card-list card-list--4cards"
  }, _vm._l((_vm.retailer.team), function(t) {
    return _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": t.fullName
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\n                              " + _vm._s(t.fullName) + "\n                            ")]), _vm._v(" "), (_vm.userGroup == 'retailers') ? _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "30%"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/account',
          params: {}
        }
      }
    }, [_vm._v("Edit")])], 1) : _vm._e()])])])
  }))])], 1)])]), _vm._v(" "), (_vm.userMode == 'normal') ? _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Service Providers")]), _vm._v(" "), _c('router-link', {
    staticClass: "card__more-link",
    attrs: {
      "to": {
        name: 'ServiceRelationships',
        params: {}
      }
    }
  }, [_vm._v("See All")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('ul', {
    staticClass: "list-bare list-hover card-list card-list--4cards  "
  }, _vm._l((_vm.serviceRelationships), function(s, index) {
    return (index < 4) ? _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": s.serviceProvider.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\n                            " + _vm._s(s.serviceProvider.name) + "\n                          ")]), _vm._v(" "), (_vm.userGroup == 'retailers') ? _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "30%"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/service-relationships',
          params: {}
        }
      }
    }, [_vm._v("Edit")])], 1) : _vm._e()])])]) : _vm._e()
  }))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.userMode == 'service-providers') ? _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Responsibilities")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('scroller', [_c('service-icons', {
    attrs: {
      "service-relationship": _vm.serviceRelationships[0]
    }
  })], 1)], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "35%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Recent Reviews")]), _vm._v(" "), _c('router-link', {
    staticClass: "card__more-link",
    attrs: {
      "to": '/reviews/retailer/' + _vm.retailer.id
    }
  }, [_vm._v("See All")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('ul', {
    staticClass: "list-bare list-hover card-list card-list--4cards"
  }, _vm._l((_vm.reviews), function(r, index) {
    return (index < 4) ? _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "35%"
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": r.overallRating
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "15%"
      }
    }, [_c('washroom-icon', {
      attrs: {
        "washroom": _vm.filterWashrooms(r.washroom)
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [(_vm.filterWashrooms(r.washroom)) ? _c('span', [_vm._v(_vm._s(_vm.filterWashrooms(r.washroom).humanId))]) : _c('span', [_vm._v("Unsubscribed Washroom")])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("\n                            " + _vm._s(_vm._f("date")(r.createdAt, '%d.%m.%Y')) + "\n                          ")])])])]) : _vm._e()
  }))])], 1)])])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('div', {
    staticClass: "panel panel--header"
  }, [_c('div', {
    staticClass: "layout"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('div', {
    staticClass: "panel__actions text--right"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search__icon",
    on: {
      "click": function($event) {
        _vm.openSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__search.svg"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "searchInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__close",
    on: {
      "click": function($event) {
        _vm.closeSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__close--dark.svg"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "row row--top"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("All Service Providers")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scrollable__wrapper"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('transition-group', {
    staticClass: "list-bare list-hover card-list card-list--11cards",
    attrs: {
      "name": "staggered-fade",
      "tag": "ul",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.search), function(serviceProvider, index) {
    return _c('li', {
      key: index,
      staticClass: "card-list__item",
      attrs: {
        "data-index": index
      }
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item service-provider__name",
      staticStyle: {
        "width": "35%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": serviceProvider.name
      }
    }), _c('h3', {
      staticClass: "font-size--small"
    }, [_vm._v(_vm._s(serviceProvider.name))])], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "35%"
      }
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + serviceProvider.adminContactEmail
      }
    }, [_vm._v(_vm._s(serviceProvider.adminContactEmail))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + serviceProvider.adminContactTelephone
      }
    }, [_vm._v(_vm._s(serviceProvider.adminContactTelephone))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "10%"
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/service-providers/' + serviceProvider.id
      }
    }, [_vm._v("View Detail")])], 1)])])])
  }))], 1)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('h1', [_vm._v("Service Providers")])])
}]}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('div', {
    staticClass: "panel panel--header"
  }, [_c('div', {
    staticClass: "layout"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('div', {
    staticClass: "panel__actions text--right"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search__icon",
    on: {
      "click": function($event) {
        _vm.openSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__search.svg"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "searchInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__close",
    on: {
      "click": function($event) {
        _vm.closeSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__close--dark.svg"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "row row--top"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("All Multisite Retailers")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scrollable__wrapper"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('transition-group', {
    staticClass: "list-bare list-hover card-list card-list--11cards",
    attrs: {
      "name": "staggered-fade",
      "tag": "ul",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.search), function(r, index) {
    return _c('li', {
      key: index,
      staticClass: "card-list__item",
      attrs: {
        "data-index": index
      }
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "26%"
      }
    }, [_c('p', {
      staticClass: "font-size--small"
    }, [_vm._v(_vm._s(r.name))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "8%"
      }
    }, [_c('subscription-level', {
      attrs: {
        "subscriptions": r.subscriptions
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "8%"
      }
    }, [_c('router-link', {
      staticClass: "no-decoration",
      attrs: {
        "to": {
          path: '/retailers/multisite/' + r.id,
          params: {}
        }
      }
    }, [_c('site-count', {
      attrs: {
        "count": r.retailers.length
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "12%"
      }
    }, [_c('router-link', {
      staticClass: "no-decoration",
      attrs: {
        "to": {
          path: '/washrooms/multisite/' + r.id,
          params: {}
        }
      }
    }, [(r.washrooms) ? _c('washroom-count-single', {
      attrs: {
        "count": r.washrooms.length
      }
    }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "23%"
      }
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + r.contactEmail
      }
    }, [_vm._v(_vm._s(r.contactEmail))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "10%"
      }
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + r.contactTelephone
      }
    }, [_vm._v(_vm._s(r.contactTelephone))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "13%",
        "white-space": "nowrap"
      }
    }, [_c('router-link', {
      staticStyle: {
        "text-decoration": "none !important"
      },
      attrs: {
        "to": {
          path: '/retailers/multisite/' + r.id,
          params: {}
        }
      }
    }, [_c('review-stars', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "stars": 5,
        "active": r.averageReviewScore
      }
    }), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(r.totalReviews || 0) + ")")])], 1)], 1)])])])
  }))], 1)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('h1', [_vm._v("Multi-Site Retailers")])])
}]}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "percentage-card-contents"
  }, [_c('div', {
    staticClass: "heading__container"
  }, [_c('h3', [_vm._v(_vm._s(_vm.heading))])]), _vm._v(" "), _c('div', {
    staticClass: "radial__container"
  }, [_c('radial-progress-bar', {
    staticClass: "centered",
    attrs: {
      "progressPercentage": _vm.percentage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "count__container"
  }, [_c('p', {
    staticClass: "callout-text--medium text--center font-condensed"
  }, [_vm._v(_vm._s(_vm.count))])])])
},staticRenderFns: []}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line-chart"
  }, [_c('canvas', {
    ref: "canvas",
    staticClass: "chart",
    attrs: {
      "width": "400",
      "height": "100%"
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-stat"
  }, [_c('h3', {
    staticClass: "change-stat__heading text--center"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('div', {
    staticClass: "change-stat__value"
  }, [_c('div', {
    staticClass: "text--center font-condensed"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.direction == 'up') ? _c('div', {
    staticClass: "change-stat__direction--up"
  }) : _vm._e(), _vm._v(" "), (_vm.direction == 'down') ? _c('div', {
    staticClass: "change-stat__direction--down"
  }) : _vm._e()]), _vm._v(" "), _c('h3', {
    staticClass: "change-stat__comment text--center"
  }, [_vm._v(_vm._s(_vm.comment))])])
},staticRenderFns: []}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issue-count"
  }, [_c('div', {
    staticClass: "issue-count__circle"
  }, [_c('span', {
    staticClass: "issue-count__number font-primary--bold"
  }, [_vm._v(_vm._s(_vm.issueCount))])]), _c('span', {
    staticClass: "issue-count__supporting-text"
  }, [_vm._v("Issues")])])
},staticRenderFns: []}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('div', {
    staticClass: "panel panel--header"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('h1', [(_vm.pageTitle !== null) ? _c('span', [_vm._v(_vm._s(_vm.pageTitle) + " | ")]) : _vm._e(), _vm._v("Washrooms")])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('div', {
    staticClass: "panel__actions text--right"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search__icon",
    on: {
      "click": function($event) {
        _vm.openSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__search.svg"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "searchInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__close",
    on: {
      "click": function($event) {
        _vm.closeSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__close--dark.svg"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "row row--top"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.retailer && _vm.retailer.name) ? _c('h2', {
    staticClass: "card__heading"
  }, [_vm._v(_vm._s(_vm.retailer.name))]) : _c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("All Clients")]), _vm._v(" "), (_vm.userGroup == 'retailers') ? _c('div', {
    staticClass: "card__heading-actions"
  }, [_c('div', {
    staticClass: "button--add",
    on: {
      "click": function($event) {
        _vm.addMode = true
      }
    }
  }, [_vm._v("+")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scrollable__wrapper"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('transition-group', {
    staticClass: "list-bare list-hover card-list card-list--11cards",
    attrs: {
      "name": "staggered-fade",
      "tag": "ul",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [(_vm.addMode == true) ? _c('li', {
    key: "add-washroom",
    staticClass: "card-list__item row-add-washroom"
  }, [_c('div', {
    staticClass: "centered--vertical"
  }, [_c('div', {
    staticClass: "layout layout--middle"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "47.5%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWashroom.name),
      expression: "newWashroom.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Enter washroom description..."
    },
    domProps: {
      "value": (_vm.newWashroom.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newWashroom.name = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "25%"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWashroom.facilityType),
      expression: "newWashroom.facilityType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newWashroom.facilityType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "select"
    }
  }, [_vm._v("Select washroom type...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Female"
    }
  }, [_vm._v("Female")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Disabled"
    }
  }, [_vm._v("Disabled")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BabyChanging"
    }
  }, [_vm._v("Baby Changing")])])]), _c('div', {
    staticClass: "layout__item text--right",
    staticStyle: {
      "width": "27.5%"
    }
  }, [_c('button', {
    staticClass: "button save-button",
    on: {
      "click": function($event) {
        _vm.cancelNewWashroom()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "button save-button",
    on: {
      "click": function($event) {
        _vm.saveNewWashroom()
      }
    }
  }, [_vm._v("Save")])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.search), function(washroom, index) {
    return _c('li', {
      key: index,
      staticClass: "card-list__item",
      attrs: {
        "data-index": index
      }
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item service-provider__name",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('h3', {
      staticClass: "font-size--small"
    }, [_vm._v(_vm._s(washroom.name))])]), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "10%"
      }
    }, [_c('p', [_vm._v(_vm._s(washroom.humanId))])]), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "22.5%"
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(washroom.retailerData) ? _c('p', {
      staticClass: "text--truncate"
    }, [_c('img', {
      staticClass: "address-icon",
      attrs: {
        "src": "/static/img/pin.svg"
      }
    }), _vm._v("\n                                  " + _vm._s(washroom.retailerData.address) + ",\n                                  " + _vm._s(washroom.retailerData.city) + ",\n                                  " + _vm._s(washroom.retailerData.postcode) + "\n                                ")]) : _vm._e()])], 1), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "7.5%"
      }
    }, [_c('washroom-icon', {
      attrs: {
        "washroom": washroom
      }
    })], 1), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "12.25%"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/reviews/washroom/' + washroom.id,
          params: {}
        }
      }
    }, [_c('issue-count', {
      attrs: {
        "issues": washroom.issues
      }
    })], 1)], 1), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "10%"
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(washroom.reviewStats) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/reviews/washroom/' + washroom.id,
          params: {}
        }
      }
    }, [_vm._v(_vm._s(washroom.reviewStats.reviewCount) + " Reviews")]) : _vm._e()], 1)], 1), _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "17.5%"
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(washroom.reviewStats) ? _c('router-link', {
      attrs: {
        "to": {
          path: '/reviews/washroom/' + washroom.id,
          params: {}
        }
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": washroom.reviewStats.averageScore
      }
    })], 1) : _vm._e()], 1)], 1)])])])
  })], 2)], 1)])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.review && _vm.retailer) ? _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('div', {
    staticClass: "panel panel--header"
  }, [_c('h1', [_vm._v("Review | ID: " + _vm._s(_vm.review.id))])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card__content contact-info",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "20%"
    }
  }, [_c('div', {
    staticClass: "layout header"
  }, [_c('div', {
    staticClass: "layout__item header__left",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "review-rating--numerical"
  }, [_vm._v(_vm._s(_vm.numericalRating))]), _vm._v(" "), _c('review-stars', {
    attrs: {
      "active": _vm.review.overallRating,
      "large": true
    }
  }), _vm._v(" "), (_vm.washroom) ? _c('span', {
    staticClass: "washroom-info"
  }, [_vm._v("\n                        " + _vm._s(_vm.washroom.humanId)), _c('br'), _vm._v("\n                        " + _vm._s(_vm.washroom.name) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.washroom) ? _c('washroom-icon', {
    attrs: {
      "washroom": _vm.washroom,
      "large": true
    }
  }) : _c('washroom-icon', {
    attrs: {
      "washroom-type": _vm.review.washroomType,
      "large": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "retailer-info"
  }, [_c('h3', {
    staticClass: "retailer-info__name"
  }, [_vm._v(_vm._s(_vm.retailer.name))]), _vm._v(" "), _c('p', {
    staticClass: "retailer-info__address"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/pin.svg"
    }
  }), _vm._v(" " + _vm._s(_vm.retailer.address) + ", " + _vm._s(_vm.retailer.city) + ", " + _vm._s(_vm.retailer.postcode))])])], 1)]), _vm._v(" "), _c('splitter')], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "80%"
    }
  }, [_c('div', {
    staticClass: "layout review-main",
    staticStyle: {
      "height": "100%",
      "padding-top": "3rem"
    }
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%",
      "height": "100%"
    }
  }, [_c('scroller', _vm._l((_vm.filteredIssues), function(i, index) {
    return _c('issue-badge', {
      key: index,
      attrs: {
        "issue": i
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%",
      "height": "100%"
    }
  }, [_c('scroller', [_c('div', [_c('h2', {
    staticClass: "section--heading"
  }, [_vm._v("Review breakdown")])]), _vm._v(" "), _c('div', {
    staticClass: "layout sub-rating"
  }, [_c('div', {
    staticClass: "layout__item title",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_vm._v("\n                            Cleanliness\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--icons",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_c('review-stars', {
    attrs: {
      "active": _vm.review.cleanlinessRating
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--numerical text--right",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.intToDecimal(_vm.review.cleanlinessRating)) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "layout sub-rating"
  }, [_c('div', {
    staticClass: "layout__item title",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_vm._v("\n                            Facilities\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--icons",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_c('review-stars', {
    attrs: {
      "active": _vm.review.environmentRating
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--numerical text--right",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.intToDecimal(_vm.review.environmentRating)) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "layout sub-rating"
  }, [_c('div', {
    staticClass: "layout__item title",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_vm._v("\n                            Overall Experience\n                          ")]), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--icons",
    staticStyle: {
      "width": "33.333333333%"
    }
  }, [_c('review-stars', {
    attrs: {
      "active": _vm.review.facilitiesRating
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item rating--numerical text--right",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.intToDecimal(_vm.review.facilitiesRating)) + "\n                          ")])]), _vm._v(" "), _c('splitter'), _vm._v(" "), _c('div', {
    staticClass: "review-body"
  }, [_c('span', {
    staticClass: "review-date"
  }, [_vm._v(_vm._s(_vm._f("date")(_vm.review.createdAt, '%d.%m.%Y')))]), _vm._v(" "), _c('review-mood', {
    attrs: {
      "mood": _vm.review.rating
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "review-comment"
  }, [_vm._v("\n                            " + _vm._s(_vm.review.comment) + "\n                          ")])], 1)], 1)], 1)])])])])])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigation"
    }
  }, [_c('div', {
    staticClass: "navigation__head"
  }, [_c('img', {
    staticClass: "navigation__logo",
    attrs: {
      "src": "/static/img/logo.svg"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "navigation__profile-image"
  }, [_c('span', {
    staticClass: "font-primary--bold"
  }, [_vm._v(_vm._s(_vm.userInitials))])]), _vm._v(" "), _c('p', {
    staticClass: "navigation__username"
  }, [_vm._v(_vm._s(_vm.user.fullName))]), _vm._v(" "), _c('p', {
    staticClass: "navigation__user-role"
  }, [_vm._v(_vm._s(_vm.userRole))])]), _vm._v(" "), _c('ul', {
    staticClass: "list-bare"
  }, [_c('li', [_c('router-link', {
    staticClass: "button font-secondary",
    attrs: {
      "to": '/' + _vm.homeRoute
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _vm._l((_vm.navItems[_vm.userGroup]), function(item) {
    return (item.route != '/account') ? _c('li', [_c('router-link', {
      staticClass: "button font-secondary",
      attrs: {
        "to": item.route
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.navItems[_vm.userGroup]), function(item) {
    return (item.route == '/account' && _vm.user.permissionsGroup == 'admin') ? _c('li', [_c('router-link', {
      staticClass: "button font-secondary",
      attrs: {
        "to": item.route
      }
    }, [_vm._v(_vm._s(item.name))])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "navigation__sub-menu"
  }, [_c('p', [_c('a', {
    on: {
      "click": function($event) {
        _vm.doLogout()
      }
    }
  }, [_vm._v("Logout")])])])], 2)])
},staticRenderFns: []}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('div', {
    staticClass: "panel panel--header"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('h1', [(_vm.pageTitle != null) ? _c('span', [_vm._v(_vm._s(_vm.pageTitle) + " | ")]) : _vm._e(), _vm._v("Retailers")])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('div', {
    staticClass: "panel__actions text--right"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search__icon",
    on: {
      "click": function($event) {
        _vm.openSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__search.svg"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "searchInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__close",
    on: {
      "click": function($event) {
        _vm.closeSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__close--dark.svg"
    }
  })])]), _vm._v(" "), (_vm.mode != 'list') ? _c('img', {
    attrs: {
      "src": "/static/img/icon__list--off.svg"
    },
    on: {
      "click": function($event) {
        _vm.viewList()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode == 'list') ? _c('img', {
    attrs: {
      "src": "/static/img/icon__list--on.svg"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode != 'map') ? _c('img', {
    attrs: {
      "src": "/static/img/icon__map--off.svg"
    },
    on: {
      "click": function($event) {
        _vm.viewMap()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mode == 'map') ? _c('img', {
    attrs: {
      "src": "/static/img/icon__map--on.svg"
    }
  }) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "row row--top"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("All Retailers")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('list-view-map', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'map'),
      expression: "mode == 'map'"
    }],
    attrs: {
      "items": _vm.retailers
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }, {
      name: "show",
      rawName: "v-show",
      value: (_vm.mode == 'list'),
      expression: "mode == 'list'"
    }],
    staticClass: "scrollable__wrapper"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('transition-group', {
    staticClass: "list-bare list-hover card-list card-list--11cards",
    attrs: {
      "name": "staggered-fade",
      "tag": "ul",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.search), function(r, index) {
    return _c('li', {
      key: index,
      staticClass: "card-list__item",
      attrs: {
        "data-index": index
      }
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "20%"
      },
      on: {
        "click": function($event) {
          _vm.goToRetailersDetail(r.id)
        }
      }
    }, [_c('p', {
      staticClass: "font-size--small"
    }, [_vm._v(_vm._s(r.name))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "5%"
      },
      on: {
        "click": function($event) {
          _vm.goToRetailersDetail(r.id)
        }
      }
    }, [_c('subscription-level', {
      attrs: {
        "subscriptions": r.subscriptions
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "27.5%"
      },
      on: {
        "click": function($event) {
          _vm.goToRetailersDetail(r.id)
        }
      }
    }, [_c('p', {
      staticClass: "text--truncate"
    }, [_c('img', {
      staticClass: "address-icon",
      attrs: {
        "src": "/static/img/pin.svg"
      }
    }), _vm._v(" "), (r.address.length > 0) ? _c('span', [_vm._v(_vm._s(r.address) + ",")]) : _vm._e(), _vm._v(" " + _vm._s(r.city) + ", " + _vm._s(r.postcode))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "17.5%"
      }
    }, [_c('router-link', {
      staticClass: "washrooms-count-link",
      attrs: {
        "to": {
          path: '/washrooms/retailer/' + r.id,
          params: {}
        }
      }
    }, [_c('washrooms-count', {
      attrs: {
        "washrooms": r.washrooms || null
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "15%"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/reviews/retailer/' + r.id,
          params: {}
        }
      }
    }, [_c('issue-count', {
      attrs: {
        "issues": r.issues
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "15%",
        "white-space": "nowrap"
      }
    }, [_c('router-link', {
      staticStyle: {
        "text-decoration": "none !important"
      },
      attrs: {
        "to": {
          path: '/reviews/retailer/' + r.id,
          params: {}
        }
      }
    }, [_c('review-stars', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "stars": 5,
        "active": r.averageReviewScore
      }
    }), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(r.totalReviews || 0) + ")")])], 1)], 1)])])])
  }))], 1)])], 1)])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "background-gradient"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName,
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('dialog-panel')], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showNavigation) ? _c('navigation') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scrollable__wrapper"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "washrooms-count",
    class: {
      'washrooms-count--large': _vm.large && _vm.large == true
    }
  }, [_c('div', {
    staticClass: "washroom-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/washroom--male.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "washroom-badge font-primary--bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.countWashrooms('Male')))])])]), _vm._v(" "), _c('div', {
    staticClass: "washroom-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/washroom--female.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "washroom-badge font-primary--bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.countWashrooms('Female')))])])]), _vm._v(" "), _c('div', {
    staticClass: "washroom-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/washroom--disabled.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "washroom-badge font-primary--bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.countWashrooms('Disabled')))])])]), _vm._v(" "), _c('div', {
    staticClass: "washroom-icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/washroom--baby-changing.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "washroom-badge font-primary--bold"
  }, [_c('span', [_vm._v(_vm._s(_vm.countWashrooms('BabyChanging')))])])])])
},staticRenderFns: []}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [(_vm.retailer) ? _c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Contact Info")]), _vm._v(" "), _c('span', {
    staticClass: "card__heading-actions"
  }, [(!_vm.editCompanyModeActive) ? _c('a', {
    key: "activate",
    staticClass: "contact-info__edit",
    on: {
      "click": function($event) {
        _vm.activateEditCompanyMode()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editCompanyModeActive) ? _c('span', {
    key: "close",
    staticClass: "contact-info__edit"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.cancelEditCompanyMode()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" /\n                        "), _c('a', {
    on: {
      "click": function($event) {
        _vm.saveEditCompanyMode()
      }
    }
  }, [_vm._v("Done")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card__content contact-info"
  }, [(!_vm.editCompanyModeActive) ? _c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%",
      "position": "relative"
    }
  }, [_c('p', {
    staticClass: "contact-info__name"
  }, [_vm._v(_vm._s(_vm.retailer.name))])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__contact-name"
  }, [_vm._v(_vm._s(_vm.retailer.contactName))])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__address"
  }, [_vm._v(_vm._s(_vm.retailer.address) + ","), _c('br'), _vm._v(_vm._s(_vm.retailer.city) + ", " + _vm._s(_vm.retailer.postcode))])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__methods"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.retailer.contactTelephone
    }
  }, [_vm._v(_vm._s(_vm.retailer.contactTelephone))]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.retailer.contactEmail
    }
  }, [_vm._v(_vm._s(_vm.retailer.contactEmail))])])])]) : _vm._e(), _vm._v(" "), (_vm.editCompanyModeActive) ? _c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%",
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.name),
      expression: "editCompanyRecord.name"
    }],
    staticClass: "contact-info__name",
    attrs: {
      "type": "text",
      "placeholder": "Company Name"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactName),
      expression: "editCompanyRecord.contactName"
    }],
    staticClass: "contact-info__contact-name",
    attrs: {
      "type": "text",
      "placeholder": "Contact Name"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('div', {
    staticClass: "contact-info__address"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.address),
      expression: "editCompanyRecord.address"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.address = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.city),
      expression: "editCompanyRecord.city"
    }],
    attrs: {
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.city = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.postcode),
      expression: "editCompanyRecord.postcode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.postcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.postcode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__methods"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactTelephone),
      expression: "editCompanyRecord.contactTelephone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Contact Telephone"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactTelephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactTelephone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactEmail),
      expression: "editCompanyRecord.contactEmail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Contact Email"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactEmail = $event.target.value
      }
    }
  })])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.multisiteRetailer) ? _c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Contact Info")]), _vm._v(" "), _c('span', {
    staticClass: "card__heading-actions"
  }, [(!_vm.editCompanyModeActive) ? _c('a', {
    key: "activate",
    staticClass: "contact-info__edit",
    on: {
      "click": function($event) {
        _vm.activateEditCompanyMode()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editCompanyModeActive) ? _c('span', {
    key: "close",
    staticClass: "contact-info__edit"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.cancelEditCompanyMode()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" /\n                        "), _c('a', {
    on: {
      "click": function($event) {
        _vm.saveEditCompanyMode()
      }
    }
  }, [_vm._v("Done")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card__content contact-info"
  }, [(!_vm.editCompanyModeActive) ? _c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%",
      "position": "relative"
    }
  }, [_c('p', {
    staticClass: "contact-info__name"
  }, [_vm._v(_vm._s(_vm.multisiteRetailer.name))])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__contact-name"
  }, [_vm._v(_vm._s(_vm.multisiteRetailer.contactName))])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__address"
  }, [_vm._v(_vm._s(_vm.multisiteRetailer.contactAddress) + ","), _c('br'), _vm._v(_vm._s(_vm.multisiteRetailer.contactCity) + ", " + _vm._s(_vm.multisiteRetailer.contactPostcode))])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__methods"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.multisiteRetailer.contactTelephone
    }
  }, [_vm._v(_vm._s(_vm.multisiteRetailer.contactTelephone))]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.multisiteRetailer.contactEmail
    }
  }, [_vm._v(_vm._s(_vm.multisiteRetailer.contactEmail))])])])]) : _vm._e(), _vm._v(" "), (_vm.editCompanyModeActive) ? _c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%",
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.name),
      expression: "editCompanyRecord.name"
    }],
    staticClass: "contact-info__name",
    attrs: {
      "type": "text",
      "placeholder": "Company Name"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactName),
      expression: "editCompanyRecord.contactName"
    }],
    staticClass: "contact-info__contact-name",
    attrs: {
      "type": "text",
      "placeholder": "Contact Name"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('div', {
    staticClass: "contact-info__address"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactAddress),
      expression: "editCompanyRecord.contactAddress"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactCity),
      expression: "editCompanyRecord.contactCity"
    }],
    attrs: {
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactCity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactPostcode),
      expression: "editCompanyRecord.contactPostcode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactPostcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactPostcode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__methods"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactTelephone),
      expression: "editCompanyRecord.contactTelephone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Contact Telephone"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactTelephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactTelephone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactEmail),
      expression: "editCompanyRecord.contactEmail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Contact Email"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactEmail = $event.target.value
      }
    }
  })])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.serviceProvider) ? _c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Contact Info")]), _vm._v(" "), _c('span', {
    staticClass: "card__heading-actions"
  }, [(!_vm.editCompanyModeActive) ? _c('a', {
    key: "activate",
    staticClass: "contact-info__edit",
    on: {
      "click": function($event) {
        _vm.activateEditCompanyMode()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.editCompanyModeActive) ? _c('span', {
    key: "close",
    staticClass: "contact-info__edit"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.cancelEditCompanyMode()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" /\n                        "), _c('a', {
    on: {
      "click": function($event) {
        _vm.saveEditCompanyMode()
      }
    }
  }, [_vm._v("Done")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card__content contact-info"
  }, [(!_vm.editCompanyModeActive) ? _c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%",
      "position": "relative"
    }
  }, [_c('p', {
    staticClass: "contact-info__name"
  }, [_vm._v(_vm._s(_vm.serviceProvider.name))])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__contact-name"
  }, [_vm._v(_vm._s(_vm.serviceProvider.contactName))])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__address"
  }, [_vm._v(_vm._s(_vm.serviceProvider.adminAddress) + ","), _c('br'), _vm._v(_vm._s(_vm.serviceProvider.adminCity) + ", " + _vm._s(_vm.serviceProvider.adminPostcode))])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__methods"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.serviceProvider.adminContactTelephone
    }
  }, [_vm._v(_vm._s(_vm.serviceProvider.adminContactTelephone))]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": 'mailto:' + _vm.serviceProvider.adminContactEmail
    }
  }, [_vm._v(_vm._s(_vm.serviceProvider.adminContactEmail))])])])]) : _vm._e(), _vm._v(" "), (_vm.editCompanyModeActive) ? _c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%",
      "position": "relative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.name),
      expression: "editCompanyRecord.name"
    }],
    staticClass: "contact-info__name",
    attrs: {
      "type": "text",
      "placeholder": "Company Name"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.contactName),
      expression: "editCompanyRecord.contactName"
    }],
    staticClass: "contact-info__contact-name",
    attrs: {
      "type": "text",
      "placeholder": "Contact Name"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.contactName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.contactName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('div', {
    staticClass: "contact-info__address"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.adminAddress),
      expression: "editCompanyRecord.adminAddress"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Address"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.adminAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.adminAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.adminCity),
      expression: "editCompanyRecord.adminCity"
    }],
    attrs: {
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.adminCity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.adminCity = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.adminPostcode),
      expression: "editCompanyRecord.adminPostcode"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Postcode"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.adminPostcode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.adminPostcode = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "25%"
    }
  }, [_c('p', {
    staticClass: "contact-info__methods"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.adminContactTelephone),
      expression: "editCompanyRecord.adminContactTelephone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Contact Telephone"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.adminContactTelephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.adminContactTelephone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editCompanyRecord.adminContactEmail),
      expression: "editCompanyRecord.adminContactEmail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Contact Email"
    },
    domProps: {
      "value": (_vm.editCompanyRecord.adminContactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editCompanyRecord.adminContactEmail = $event.target.value
      }
    }
  })])])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card package-upgrades"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Your Package and Upgrades")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "current-package"
  }, [(_vm.retailer) ? _c('div', [(_vm.getActiveSubscriptionRetailer) ? _c('div', [_c('h3', {
    staticClass: "text--center"
  }, [_vm._v("You are currently subscribed to the"), _c('br'), _c('span', {
    staticClass: "package-title"
  }, [_vm._v("`" + _vm._s(_vm.getActiveSubscriptionRetailer.package) + " Retailer`")]), _c('br'), _vm._v("package.")])]) : _c('div', [_c('h3', {
    staticClass: "text--center"
  }, [_vm._v("You are not currently subscribed to a package.")])])]) : _vm._e(), _vm._v(" "), (_vm.multisiteRetailer) ? _c('div', [_c('h3', {
    staticClass: "text--center"
  }, [_vm._v("Packages are associated with individual retailer accounts.")])]) : _vm._e(), _vm._v(" "), (_vm.serviceProvider) ? _c('div', [(_vm.getActiveSubscriptionServiceProvider) ? _c('div', [_c('h3', {
    staticClass: "text--center"
  }, [_vm._v("You are currently subscribed to the"), _c('br'), _c('span', {
    staticClass: "package-title"
  }, [_vm._v("`" + _vm._s(_vm.getActiveSubscriptionServiceProvider.package) + " Service Provider`")]), _c('br'), _vm._v("package.")])]) : _c('div', [_c('h3', {
    staticClass: "text--center"
  }, [_vm._v("You are not currently subscribed to a package.")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "upgrade-instructions"
  }, [(_vm.multisiteRetailer) ? _c('div', [_vm._m(1)]) : _c('div', [_vm._m(2)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Team")]), _vm._v(" "), _c('div', {
    staticClass: "card__heading-actions"
  }, [_c('div', {
    staticClass: "button--add",
    on: {
      "click": function($event) {
        _vm.activateAddUserMode()
      }
    }
  }, [_vm._v("+")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('scroller', [_c('ul', {
    staticStyle: {
      "list-style-type": "none",
      "padding": "0",
      "margin": "0",
      "width": "100%"
    }
  }, [(_vm.addUserModeActive) ? _c('li', {
    staticClass: "user-line add-user"
  }, [_c('div', {
    staticClass: "user-fullname",
    staticStyle: {
      "display": "inline-block",
      "width": "32.5%"
    }
  }, [_c('user-icon', {
    attrs: {
      "fullname": _vm.addUserRecord.fullName
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserRecord.fullName),
      expression: "addUserRecord.fullName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Full Name"
    },
    domProps: {
      "value": (_vm.addUserRecord.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserRecord.fullName = $event.target.value
      }
    }
  })], 1), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "20%",
      "position": "relative"
    }
  }, [_c('user-level-selector', {
    attrs: {
      "user": _vm.addUserRecord,
      "save": false
    }
  })], 1), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "32.5%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserRecord.emailAddress),
      expression: "addUserRecord.emailAddress"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.addUserRecord.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserRecord.emailAddress = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "text--right",
    staticStyle: {
      "display": "inline-block",
      "width": "15%"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.cancelAddUserMode()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" / "), _c('a', {
    on: {
      "click": function($event) {
        _vm.saveAddUserMode()
      }
    }
  }, [_vm._v("Done")])])]) : _vm._e(), _vm._v(" "), (_vm.retailer && _vm.retailer.team) ? _vm._l((_vm.retailer.team), function(t) {
    return _c('li', {
      staticClass: "user-line edit-user"
    }, [(!_vm.editUserRecord || (_vm.editUserRecord && _vm.editUserRecord.id != t.id)) ? _c('div', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": t.fullName
      }
    }), _vm._v("\n                                  " + _vm._s(t.fullName) + "\n                                ")], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "20%",
        "position": "relative"
      }
    }, [_c('user-level-selector', {
      attrs: {
        "user": t
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('a', {
      attrs: {
        "href": 'mailto:t.emailAddress'
      }
    }, [_vm._v(_vm._s(t.emailAddress))])]), _c('div', {
      staticClass: "text--right",
      staticStyle: {
        "display": "inline-block",
        "width": "15%"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.activateEditUserMode(t)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" / "), _c('a', {
      on: {
        "click": function($event) {
          _vm.deleteExistingUser(t.id)
        }
      }
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (_vm.editUserModeActive && _vm.editUserRecord.id == t.id) ? _c('div', [_c('div', {
      staticClass: "user-fullname",
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": _vm.editUserRecord.fullName
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editUserRecord.fullName),
        expression: "editUserRecord.fullName"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Full Name"
      },
      domProps: {
        "value": (_vm.editUserRecord.fullName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editUserRecord.fullName = $event.target.value
        }
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "20%",
        "position": "relative"
      }
    }, [_c('user-level-selector', {
      attrs: {
        "user": _vm.editUserRecord,
        "save": false
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editUserRecord.emailAddress),
        expression: "editUserRecord.emailAddress"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Email address"
      },
      domProps: {
        "value": (_vm.editUserRecord.emailAddress)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editUserRecord.emailAddress = $event.target.value
        }
      }
    })]), _c('div', {
      staticClass: "text--right",
      staticStyle: {
        "display": "inline-block",
        "width": "15%"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.cancelEditUserMode()
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" / "), _c('a', {
      on: {
        "click": function($event) {
          _vm.saveEditUserMode()
        }
      }
    }, [_vm._v("Done")])])]) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), (_vm.multisiteRetailer && _vm.multisiteRetailer.team) ? _vm._l((_vm.multisiteRetailer.team), function(t) {
    return _c('li', {
      staticClass: "user-line edit-user"
    }, [(!_vm.editUserRecord || (_vm.editUserRecord && _vm.editUserRecord.id != t.id)) ? _c('div', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": t.fullName
      }
    }), _vm._v("\n                                  " + _vm._s(t.fullName) + "\n                                ")], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "20%",
        "position": "relative"
      }
    }, [_c('user-level-selector', {
      attrs: {
        "user": t
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('a', {
      attrs: {
        "href": 'mailto:t.emailAddress'
      }
    }, [_vm._v(_vm._s(t.emailAddress))])]), _c('div', {
      staticClass: "text--right",
      staticStyle: {
        "display": "inline-block",
        "width": "15%"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.activateEditUserMode(t)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" / "), _c('a', {
      on: {
        "click": function($event) {
          _vm.deleteExistingUser(t.id)
        }
      }
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (_vm.editUserModeActive && _vm.editUserRecord.id == t.id) ? _c('div', [_c('div', {
      staticClass: "user-fullname",
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": _vm.editUserRecord.fullName
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editUserRecord.fullName),
        expression: "editUserRecord.fullName"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Full Name"
      },
      domProps: {
        "value": (_vm.editUserRecord.fullName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editUserRecord.fullName = $event.target.value
        }
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "20%",
        "position": "relative"
      }
    }, [_c('user-level-selector', {
      attrs: {
        "user": _vm.editUserRecord,
        "save": false
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editUserRecord.emailAddress),
        expression: "editUserRecord.emailAddress"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Email address"
      },
      domProps: {
        "value": (_vm.editUserRecord.emailAddress)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editUserRecord.emailAddress = $event.target.value
        }
      }
    })]), _c('div', {
      staticClass: "text--right",
      staticStyle: {
        "display": "inline-block",
        "width": "15%"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.cancelEditUserMode()
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" / "), _c('a', {
      on: {
        "click": function($event) {
          _vm.saveEditUserMode()
        }
      }
    }, [_vm._v("Done")])])]) : _vm._e()])
  }) : _vm._e(), _vm._v(" "), (_vm.serviceProvider && _vm.serviceProvider.team) ? _vm._l((_vm.serviceProvider.team), function(t) {
    return _c('li', {
      staticClass: "user-line edit-user"
    }, [(!_vm.editUserRecord || (_vm.editUserRecord && _vm.editUserRecord.id != t.id)) ? _c('div', [_c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": t.fullName
      }
    }), _vm._v("\n                                  " + _vm._s(t.fullName) + "\n                                ")], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "20%",
        "position": "relative"
      }
    }, [_c('user-level-selector', {
      attrs: {
        "user": t
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('a', {
      attrs: {
        "href": 'mailto:t.emailAddress'
      }
    }, [_vm._v(_vm._s(t.emailAddress))])]), _c('div', {
      staticClass: "text--right",
      staticStyle: {
        "display": "inline-block",
        "width": "15%"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.activateEditUserMode(t)
        }
      }
    }, [_vm._v("Edit")]), _vm._v(" / "), _c('a', {
      on: {
        "click": function($event) {
          _vm.deleteExistingUser(t.id)
        }
      }
    }, [_vm._v("Delete")])])]) : _vm._e(), _vm._v(" "), (_vm.editUserModeActive && _vm.editUserRecord.id == t.id) ? _c('div', [_c('div', {
      staticClass: "user-fullname",
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": _vm.editUserRecord.fullName
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editUserRecord.fullName),
        expression: "editUserRecord.fullName"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Full Name"
      },
      domProps: {
        "value": (_vm.editUserRecord.fullName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editUserRecord.fullName = $event.target.value
        }
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "20%",
        "position": "relative"
      }
    }, [_c('user-level-selector', {
      attrs: {
        "user": _vm.editUserRecord,
        "save": false
      }
    })], 1), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "width": "32.5%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editUserRecord.emailAddress),
        expression: "editUserRecord.emailAddress"
      }],
      attrs: {
        "type": "text",
        "placeholder": "Email address"
      },
      domProps: {
        "value": (_vm.editUserRecord.emailAddress)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editUserRecord.emailAddress = $event.target.value
        }
      }
    })]), _c('div', {
      staticClass: "text--right",
      staticStyle: {
        "display": "inline-block",
        "width": "15%"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.cancelEditUserMode()
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" / "), _c('a', {
      on: {
        "click": function($event) {
          _vm.saveEditUserMode()
        }
      }
    }, [_vm._v("Done")])])]) : _vm._e()])
  }) : _vm._e()], 2)])], 1)])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel--header"
  }, [_c('h1', [_vm._v("My Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text--center"
  }, [_vm._v("To discuss retailer packages,"), _c('br'), _vm._v("please contact us:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "text--center"
  }, [_vm._v("To upgrade your package"), _c('br'), _vm._v("please contact us:")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text--center"
  }, [_c('a', {
    attrs: {
      "href": "mailto:hello@cleen.world"
    }
  }, [_vm._v("hello@cleen.world")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text--center"
  }, [_c('a', {
    attrs: {
      "href": "tel:01332123456"
    }
  }, [_vm._v("(01332) 123456")])])
}]}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "radial-progress-bar"
  }, [_c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "half-circle__outer-container left"
  }, [_c('div', {
    ref: "leftHalfCircle",
    staticClass: "half-circle__container"
  }, [_c('div', {
    staticClass: "half-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "half-circle__outer-container right"
  }, [_c('div', {
    ref: "rightHalfCircle",
    staticClass: "half-circle__container right"
  }, [_c('div', {
    staticClass: "half-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-text font-condensed"
  }, [_vm._v(_vm._s(Math.round(_vm.displayedPercentage)) + "%")])])
},staticRenderFns: []}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-count"
  }, [_c('div', {
    staticClass: "site-count__circle"
  }, [_c('span', {
    staticClass: "site-count__number font-primary--bold"
  }, [_vm._v(_vm._s(_vm.count))])]), _vm._v(" "), _c('span', {
    staticClass: "site-count__supporting-text"
  }, [_vm._v("Sites")])])
},staticRenderFns: []}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "card package-upgrades"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Actions")]), _vm._v(" "), _c('div', {
    staticClass: "card__content admin-actions"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.openCreateAccount('retailer')
      }
    }
  }, [_vm._v("Create Retailer")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.openCreateAccount('multisite')
      }
    }
  }, [_vm._v("Create Multisite Retailer")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.openCreateAccount('serviceprovider')
      }
    }
  }, [_vm._v("Create Service Provider")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.accountType == 'retailer') ? [(_vm.viewMode == 'createAccount' && !_vm.saving) ? _c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Create Account")]), _vm._v(" "), _c('div', {
    staticClass: "card__content create-form"
  }, [_c('h2', [_vm._v("Create a new Retailer")]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Set login details")]), _vm._v(" "), _c('p', [_vm._v("Enter the email address that will be used to log in to the account for this retailer.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fullName),
      expression: "user.fullName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Full name"
    },
    domProps: {
      "value": (_vm.user.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.fullName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.emailAddress),
      expression: "user.emailAddress"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.user.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.emailAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Search for a place to add")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    attrs: {
      "type": "text",
      "placeholder": "e.g. `Pizza Hut, Derby` or `Pizza Hut, DE1`"
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }, function($event) {
        _vm.search()
      }]
    }
  }), _vm._v(" "), (_vm.placeResults.length == 0) ? _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Select the matching place")]), _vm._v(" "), _c('p', [_vm._v("No places found...")])]) : _vm._e(), _vm._v(" "), (_vm.placeResults && _vm.placeResults.length > 0) ? _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Select the matching place")]), _vm._v(" "), _c('scroller', {
    staticClass: "scroller"
  }, _vm._l((_vm.placeResults), function(p) {
    return _c('div', {
      staticClass: "place",
      on: {
        "click": function($event) {
          _vm.doCreateRetailer(p)
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(p.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(p.formatted_address))])])
  }))], 1) : _vm._e()])])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.accountType == 'multisite') ? [(_vm.viewMode == 'createAccount' && !_vm.saving) ? _c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Create Account")]), _vm._v(" "), _c('div', {
    staticClass: "card__content create-form"
  }, [_c('h2', [_vm._v("Create a new Multisite Retailer")]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Set login details")]), _vm._v(" "), _c('p', [_vm._v("Enter the email address that will be used to log in to the account for this service provider.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fullName),
      expression: "user.fullName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Full name"
    },
    domProps: {
      "value": (_vm.user.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.fullName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.emailAddress),
      expression: "user.emailAddress"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.user.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.emailAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Set multisite retailer details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.multisite.name),
      expression: "multisite.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Multisite retailer name"
    },
    domProps: {
      "value": (_vm.multisite.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.multisite.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Add retailers to this multisite")]), _vm._v(" "), _c('div', {
    staticClass: "retailers-list"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('h5', {
    staticClass: "title small"
  }, [_vm._v("Available Retailers")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchStringRetailers),
      expression: "searchStringRetailers"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Filter retailers..."
    },
    domProps: {
      "value": (_vm.searchStringRetailers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchStringRetailers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('scroller', {
    staticClass: "scroller"
  }, _vm._l((_vm.retailerResultsFiltered), function(r) {
    return _c('div', {
      staticClass: "retailer-item",
      on: {
        "click": function($event) {
          _vm.addRetailerToMultisite(r)
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(r.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(r.address))])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('h5', {
    staticClass: "title small"
  }, [_vm._v("Added Retailers")]), _vm._v(" "), _c('scroller', {
    staticClass: "scroller",
    staticStyle: {
      "margin-top": "8.85rem"
    }
  }, _vm._l((_vm.multisite.retailers), function(r, index) {
    return _c('div', {
      staticClass: "retailer-item",
      on: {
        "click": function($event) {
          _vm.removeRetailerFromMultisite(index)
        }
      }
    }, [_c('h3', [_vm._v(_vm._s(r.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(r.address))])])
  }))], 1)])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.doCreateMultisite()
      }
    }
  }, [_vm._v("Create Multisite Retailer")])])])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.accountType == 'serviceprovider') ? [(_vm.viewMode == 'createAccount' && !_vm.saving) ? _c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Create Account")]), _vm._v(" "), _c('div', {
    staticClass: "card__content create-form"
  }, [_c('h2', [_vm._v("Create a new Service Provider")]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Set login details")]), _vm._v(" "), _c('p', [_vm._v("Enter the email address that will be used to log in to the account for this service provider.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.fullName),
      expression: "user.fullName"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Full name"
    },
    domProps: {
      "value": (_vm.user.fullName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.fullName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.emailAddress),
      expression: "user.emailAddress"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Email address"
    },
    domProps: {
      "value": (_vm.user.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.emailAddress = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Set service provider details")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serviceProvider.name),
      expression: "serviceProvider.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Service provider name"
    },
    domProps: {
      "value": (_vm.serviceProvider.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.serviceProvider.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.doCreateServiceProvider()
      }
    }
  }, [_vm._v("Create Service Provider")])])])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.viewMode == 'createAccount' && _vm.saving) ? _c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Create Account")]), _vm._v(" "), _c('div', {
    staticClass: "card__content create-form"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "cube1"
  }), _vm._v(" "), _c('div', {
    staticClass: "cube2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "loading-message"
  }, [_c('h3', [_vm._v("Saving, please wait...")])])])]) : _vm._e()], 2)], 1)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel--header"
  }, [_c('h1', [_vm._v("Admin")])])
}]}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [(_vm.userGroup == 'retailers') ? _c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading tabs__heading"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      active: _vm.retailer.activeChart === 1
    },
    on: {
      "click": function($event) {
        _vm.retailer.activeChart = 1
      }
    }
  }, [_vm._v("Reviews Over Time")]), _c('span', {
    staticClass: "tab",
    class: {
      active: _vm.retailer.activeChart === 2
    },
    on: {
      "click": function($event) {
        _vm.retailer.activeChart = 2
      }
    }
  }, [_vm._v("Rating Over Time")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.retailer.activeChart === 1) ? _c('line-chart', {
    key: "1",
    attrs: {
      "y-steps-size": 1,
      "plots": _vm.reviewsPerDayPlots(_vm.retailer.recentReviewsPerDay),
      "labels": _vm.reviewsPerDayLabels(_vm.retailer.recentReviewsPerDay)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.retailer.activeChart === 2) ? _c('line-chart', {
    key: "2",
    attrs: {
      "y-steps-size": 1,
      "y-max": 5,
      "plots": _vm.averageRatingPerDayPlots(_vm.retailer.recentAverageRatingPerDay),
      "labels": _vm.averageRatingPerDayLabels(_vm.retailer.recentAverageRatingPerDay)
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "33.333333%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Recent Reviews")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('ul', {
    staticClass: "list-bare list-hover card-list card-list--4cards  "
  }, _vm._l((_vm.retailer.recentReviewsData), function(r) {
    return _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": r.overallRating
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(r.washroom.humanId))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.timestampToDateShort(r.createdAt)))])])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total 1 Star Ratings',
      "value": '#'
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'New 1 Star Ratings',
      "value": '#'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total 5 Star Ratings',
      "value": '#'
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'New 5 Star Ratings',
      "value": '#'
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "33%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Reviews',
      "value": _vm.retailer.totalReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Recent Reviews',
      "value": _vm.retailer.recentReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Issues',
      "value": _vm.retailer.totalIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Recent Issues',
      "value": _vm.retailer.recentIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Open Issues',
      "percentage": _vm.retailerTotalOpenIssuesPercentage,
      "count": _vm.retailer.totalOpenIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Closed Issues',
      "percentage": _vm.retailerTotalClosedIssuesPercentage,
      "count": _vm.retailer.totalClosedIssues
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'multi-site-retailers') ? _c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading tabs__heading"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      active: _vm.multisite.activeChart === 1
    },
    on: {
      "click": function($event) {
        _vm.multisite.activeChart = 1
      }
    }
  }, [_vm._v("Reviews Over Time")]), _c('span', {
    staticClass: "tab",
    class: {
      active: _vm.multisite.activeChart === 2
    },
    on: {
      "click": function($event) {
        _vm.multisite.activeChart = 2
      }
    }
  }, [_vm._v("Rating Over Time")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.multisite.activeChart === 1) ? _c('line-chart', {
    key: "1",
    attrs: {
      "y-steps-size": 1,
      "plots": _vm.reviewsPerDayPlots(_vm.multisite.recentReviewsPerDay),
      "labels": _vm.reviewsPerDayLabels(_vm.multisite.recentReviewsPerDay)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.multisite.activeChart === 2) ? _c('line-chart', {
    key: "2",
    attrs: {
      "y-steps-size": 1,
      "y-max": 5,
      "plots": _vm.averageRatingPerDayPlots(_vm.multisite.recentAverageRatingPerDay),
      "labels": _vm.averageRatingPerDayLabels(_vm.multisite.recentAverageRatingPerDay)
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "33.333333%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Recent Reviews")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('ul', {
    staticClass: "list-bare list-hover card-list card-list--4cards  "
  }, _vm._l((_vm.multisite.recentReviewsData), function(r) {
    return _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": r.overallRating
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(r.washroom.humanId))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.timestampToDateShort(r.createdAt)))])])])])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total 1 Star Ratings',
      "value": '#'
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'New 1 Star Ratings',
      "value": '#'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total 5 Star Ratings',
      "value": '#'
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'New 5 Star Ratings',
      "value": '#'
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "33%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Retailers',
      "comment": "All time",
      "value": _vm.multisite.totalRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New Retailers',
      "comment": "Last 7 days",
      "value": _vm.multisite.newRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Reviews',
      "value": _vm.multisite.totalReviews
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Reviews',
      "value": _vm.multisite.recentReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Issues',
      "value": _vm.multisite.totalIssues
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Issues',
      "value": _vm.multisite.recentIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Open Issues',
      "percentage": _vm.multisiteTotalOpenIssuesPercentage,
      "count": _vm.multisite.totalOpenIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Closed Issues',
      "percentage": _vm.multisiteTotalClosedIssuesPercentage,
      "count": _vm.multisite.totalClosedIssues
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'service-providers') ? _c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading tabs__heading"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      active: _vm.serviceProvider.activeChart === 1
    },
    on: {
      "click": function($event) {
        _vm.serviceProvider.activeChart = 1
      }
    }
  }, [_vm._v("Reviews Over Time")]), _c('span', {
    staticClass: "tab",
    class: {
      active: _vm.serviceProvider.activeChart === 2
    },
    on: {
      "click": function($event) {
        _vm.serviceProvider.activeChart = 2
      }
    }
  }, [_vm._v("Rating Over Time")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.serviceProvider.activeChart === 1) ? _c('line-chart', {
    key: "1",
    attrs: {
      "y-steps-size": 1,
      "plots": _vm.reviewsPerDayPlots(_vm.serviceProvider.recentReviewsPerDay),
      "labels": _vm.reviewsPerDayLabels(_vm.serviceProvider.recentReviewsPerDay)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.serviceProvider.activeChart === 2) ? _c('line-chart', {
    key: "2",
    attrs: {
      "y-steps-size": 1,
      "y-max": 5,
      "plots": _vm.averageRatingPerDayPlots(_vm.serviceProvider.recentAverageRatingPerDay),
      "labels": _vm.averageRatingPerDayLabels(_vm.serviceProvider.recentAverageRatingPerDay)
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "33.333333%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card reviews-list-small"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Recent Reviews")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('ul', {
    staticClass: "list-bare list-hover card-list card-list--4cards  "
  }, _vm._l((_vm.serviceProvider.recentReviewsData), function(r, index) {
    return (index < 4) ? _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "50%"
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": r.overallRating
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(r.washroom.humanId))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "25%"
      }
    }, [_c('p', [_vm._v(_vm._s(_vm.timestampToDateShort(r.createdAt)))])])])])]) : _vm._e()
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New 1 Star Ratings',
      "value": '#'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New 5 Star Ratings',
      "value": '#'
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "33%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Retailers',
      "value": _vm.serviceProvider.totalRetailers
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Retailers',
      "value": _vm.serviceProvider.recentRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Multisite Retailers',
      "value": _vm.serviceProvider.totalMultisiteRetailers
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Multisite Retailers',
      "value": _vm.serviceProvider.recentMultisiteRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat', {
    attrs: {
      "heading": 'Total Reviews',
      "value": _vm.serviceProvider.totalReviews
    }
  }), _vm._v(" "), _c('change-stat', {
    attrs: {
      "heading": 'Recent Reviews',
      "value": _vm.serviceProvider.recentReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Issues',
      "value": _vm.serviceProvider.totalIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Open Issues',
      "percentage": _vm.serviceProviderTotalOpenIssuesPercentage,
      "count": _vm.serviceProvider.totalOpenIssues
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('percentage-card-contents', {
    attrs: {
      "heading": 'Total Closed Issues',
      "percentage": _vm.serviceProviderTotalClosedIssuesPercentage,
      "count": _vm.serviceProvider.totalClosedIssues
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins') ? _c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "66.666666%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading tabs__heading"
  }, [_c('span', {
    staticClass: "tab",
    class: {
      active: _vm.hsgadmin.activeChart === 1
    },
    on: {
      "click": function($event) {
        _vm.hsgadmin.activeChart = 1
      }
    }
  }, [_vm._v("Reviews Over Time")]), _c('span', {
    staticClass: "tab",
    class: {
      active: _vm.hsgadmin.activeChart === 2
    },
    on: {
      "click": function($event) {
        _vm.hsgadmin.activeChart = 2
      }
    }
  }, [_vm._v("Daily App Downloads")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.hsgadmin.activeChart === 1) ? _c('line-chart', {
    key: "1",
    attrs: {
      "y-steps-size": 1,
      "plots": _vm.reviewsPerDayPlots(_vm.hsgadmin.recentReviewsPerDay),
      "labels": _vm.reviewsPerDayLabels(_vm.hsgadmin.recentReviewsPerDay)
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "33.333333%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total App Downloads',
      "comment": "",
      "value": '#'
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New App Downloads',
      "comment": "",
      "value": '#'
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Reviews',
      "comment": "",
      "value": _vm.hsgadmin.totalReviews
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Issues',
      "comment": "",
      "value": _vm.hsgadmin.totalIssues
    }
  })], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "33%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Retailers',
      "comment": "All time",
      "value": _vm.hsgadmin.totalRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New Retailers',
      "comment": "Last 7 days",
      "value": _vm.hsgadmin.newRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Multisites',
      "comment": "All time",
      "value": _vm.hsgadmin.totalMultisiteRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New Multisites',
      "comment": "Last 7 days",
      "value": _vm.hsgadmin.newMultisiteRetailers
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'Total Service Providers',
      "comment": "All time",
      "value": _vm.hsgadmin.totalServiceProviders
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "16.6666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('change-stat-large', {
    attrs: {
      "heading": 'New Service Providers',
      "comment": "Last 7 days",
      "value": _vm.hsgadmin.newServiceProviders
    }
  })], 1)])])])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel--header"
  }, [_c('h1', [_vm._v("Dashboard")])])
}]}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "washrooms-count"
  }, [_c('div', {
    staticClass: "washroom-icon",
    class: {
      'washroom-icon--large': _vm.large
    }
  }, [((_vm.washroom && _vm.washroom.facilityType == 'Male') || _vm.washroomType == 'Male') ? _c('img', {
    attrs: {
      "src": "/static/img/washroom--male.svg"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.washroom && _vm.washroom.facilityType == 'Female') || _vm.washroomType == 'Female') ? _c('img', {
    attrs: {
      "src": "/static/img/washroom--female.svg"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.washroom && _vm.washroom.facilityType == 'Disabled') || _vm.washroomType == 'Disabled') ? _c('img', {
    attrs: {
      "src": "/static/img/washroom--disabled.svg"
    }
  }) : _vm._e(), _vm._v(" "), ((_vm.washroom && _vm.washroom.facilityType == 'BabyChanging') || _vm.washroomType == 'BabyChanging') ? _c('img', {
    attrs: {
      "src": "/static/img/washroom--baby-changing.svg"
    }
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscription-level"
  }, [(_vm.active === true) ? _c('img', {
    staticClass: "subscription-icon",
    attrs: {
      "src": "/static/img/bookmark.svg"
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review-stars",
    class: {
      'review-stars--large': _vm.large
    }
  }, _vm._l((_vm.starsToShow), function(star, index) {
    return _c('div', {
      staticClass: "review-star",
      class: {
        'review-star--active': index < _vm.active && _vm.active > 1, 'review-star--low': index < _vm.active && _vm.active == 1
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "service-icons"
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, _vm._l((_vm.serviceAreas), function(serviceArea, index) {
    return (_vm.serviceRelationship[serviceArea.name]) ? _c('div', {
      staticClass: "layout__item desktop--fifth service-area",
      staticStyle: {
        "height": "25%"
      }
    }, [_c('div', {
      staticClass: "text--center"
    }, [_c('img', {
      staticClass: "service-icons__icon",
      attrs: {
        "src": serviceArea.imageOff
      }
    })])]) : _vm._e()
  }))])
},staticRenderFns: []}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item ",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.userMode === 'normal' && _vm.viewMode === null) ? _c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Service Providers")]) : _vm._e(), _vm._v(" "), (_vm.userMode === 'normal' && _vm.viewMode === 'add') ? _c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Available Service Providers")]) : _vm._e(), _vm._v(" "), (_vm.userMode === 'service-providers') ? _c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Retailers")]) : _vm._e(), _vm._v(" "), (_vm.viewMode === null) ? _c('div', {
    staticClass: "card__heading-actions"
  }, [_c('div', {
    staticClass: "button--add",
    on: {
      "click": function($event) {
        _vm.viewMode = 'add'
      }
    }
  }, [_vm._v("+")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('scroller', [(_vm.viewMode == null) ? _c('div', [_c('h3', {
    staticClass: "incoming-connections subtitle"
  }, [_vm._v("Incoming Connections")])]) : _vm._e(), _vm._v(" "), (_vm.viewMode === null) ? _c('ul', {
    staticClass: "list-bare card-list"
  }, [(_vm.incomingConnectionsCount == 0) ? _c('li', {
    staticClass: "card-list__item"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("There are currently no incoming connections")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.serviceRelationships), function(serviceRelationship, index) {
    return (_vm.userMode == 'service-providers' && serviceRelationship.origin == 'retailer') ? _c('li', {
      staticClass: "card-list__item",
      class: {
        'active': (_vm.selectedServiceRelationship && serviceRelationship) && _vm.selectedServiceRelationship.id == serviceRelationship.id
      }
    }, [_c('div', [_c('div', {
      staticClass: "layout layout--top layout--fill-container"
    }, [_c('div', {
      staticClass: "layout__item service-provider__icon"
    }, [_c('user-icon', {
      attrs: {
        "fullname": serviceRelationship.retailer.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item service-provider__info desktop--three-quarters"
    }, [_c('h3', {
      staticClass: "in pointer text--truncate",
      on: {
        "click": function($event) {
          _vm.onViewRelationshipClick(index)
        }
      }
    }, [_vm._v(_vm._s(serviceRelationship.retailer.name))]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + serviceRelationship.retailer.contactEmail
      }
    }, [_vm._v(_vm._s(serviceRelationship.retailer.contactEmail))])]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + serviceRelationship.retailer.contactTelephone
      }
    }, [_vm._v(_vm._s(serviceRelationship.retailer.contactTelephone))])]), _vm._v(" "), _c('span', {
      staticClass: "view-item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.onViewRelationshipClick(index)
        }
      }
    }, [_vm._v("view")])])])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.serviceRelationships), function(serviceRelationship, index) {
    return (_vm.userMode == 'normal' && serviceRelationship.origin == 'service-provider' && serviceRelationship.status === 'pending') ? _c('li', {
      staticClass: "card-list__item",
      class: {
        'active': (_vm.selectedServiceRelationship && serviceRelationship) && _vm.selectedServiceRelationship.id == serviceRelationship.id
      }
    }, [_c('div', [_c('div', {
      staticClass: "layout layout--top layout--fill-container"
    }, [_c('div', {
      staticClass: "layout__item service-provider__icon"
    }, [_c('user-icon', {
      attrs: {
        "fullname": serviceRelationship.serviceProvider.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item service-provider__info desktop--three-quarters"
    }, [_c('h3', {
      staticClass: "in pointer text--truncate",
      on: {
        "click": function($event) {
          _vm.onViewRelationshipClick(index)
        }
      }
    }, [_vm._v(_vm._s(serviceRelationship.serviceProvider.name))]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + serviceRelationship.serviceProvider.adminContactEmail
      }
    }, [_vm._v(_vm._s(serviceRelationship.serviceProvider.adminContactEmail))])]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + serviceRelationship.serviceProvider.adminContactTelephone
      }
    }, [_vm._v(_vm._s(serviceRelationship.serviceProvider.adminContactTelephone))])]), _vm._v(" "), _c('span', {
      staticClass: "view-item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.onViewRelationshipClick(index)
        }
      }
    }, [_vm._v("view")])])])])])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.viewMode == null) ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "subtitle"
  }, [_vm._v("Connections")])]) : _vm._e(), _vm._v(" "), (_vm.viewMode === null) ? _c('ul', {
    staticClass: "list-bare card-list"
  }, [(_vm.connectionsCount == 0 && _vm.userMode == 'service-providers') ? _c('li', {
    staticClass: "card-list__item"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("There are currently no pending connections")])])]) : _vm._e(), _vm._v(" "), (_vm.connectionsCount == 0 && _vm.userMode != 'service-providers') ? _c('li', {
    staticClass: "card-list__item"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("There are currently no existing connections")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.serviceRelationships), function(serviceRelationship, index) {
    return (_vm.userMode == 'service-providers' && serviceRelationship.origin == 'service-provider') ? _c('li', {
      staticClass: "card-list__item",
      class: {
        'active': (_vm.selectedServiceRelationship && serviceRelationship) && _vm.selectedServiceRelationship.id == serviceRelationship.id
      }
    }, [_c('div', [_c('div', {
      staticClass: "layout layout--top layout--fill-container"
    }, [_c('div', {
      staticClass: "layout__item service-provider__icon"
    }, [_c('user-icon', {
      attrs: {
        "fullname": serviceRelationship.retailer.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item service-provider__info desktop--three-quarters"
    }, [_c('h3', {
      staticClass: "in pointer text--truncate",
      on: {
        "click": function($event) {
          _vm.onViewRelationshipClick(index)
        }
      }
    }, [_vm._v(_vm._s(serviceRelationship.retailer.name))]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + serviceRelationship.retailer.contactEmail
      }
    }, [_vm._v(_vm._s(serviceRelationship.retailer.contactEmail))])]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + serviceRelationship.retailer.contactTelephone
      }
    }, [_vm._v(_vm._s(serviceRelationship.retailer.contactTelephone))])]), _vm._v(" "), _c('span', {
      staticClass: "view-item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.onViewRelationshipClick(index)
        }
      }
    }, [_vm._v("view")]), _c('br'), _vm._v(_vm._s(serviceRelationship.status))])])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.serviceRelationships), function(serviceRelationship, index) {
    return (_vm.userMode == 'normal' && (serviceRelationship.origin == 'retailer' || serviceRelationship.origin == 'service-provider' && serviceRelationship.status != 'pending')) ? _c('li', {
      staticClass: "card-list__item",
      class: {
        'active': (_vm.selectedServiceRelationship && serviceRelationship) && _vm.selectedServiceRelationship.id == serviceRelationship.id
      }
    }, [_c('div', [_c('div', {
      staticClass: "layout layout--top layout--fill-container"
    }, [_c('div', {
      staticClass: "layout__item service-provider__icon"
    }, [_c('user-icon', {
      attrs: {
        "fullname": serviceRelationship.serviceProvider.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item service-provider__info desktop--three-quarters"
    }, [_c('h3', {
      staticClass: "in pointer text--truncate",
      on: {
        "click": function($event) {
          _vm.onViewRelationshipClick(index)
        }
      }
    }, [_vm._v(_vm._s(serviceRelationship.serviceProvider.name))]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + serviceRelationship.serviceProvider.adminContactEmail
      }
    }, [_vm._v(_vm._s(serviceRelationship.serviceProvider.adminContactEmail))])]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + serviceRelationship.serviceProvider.adminContactTelephone
      }
    }, [_vm._v(_vm._s(serviceRelationship.serviceProvider.adminContactTelephone))])]), _vm._v(" "), _c('span', {
      staticClass: "view-item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.onViewRelationshipClick(index)
        }
      }
    }, [_vm._v("view")]), _c('br'), _vm._v(_vm._s(serviceRelationship.status))])])])])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.viewMode === 'add') ? _c('ul', {
    staticClass: "list-bare card-list"
  }, [(_vm.existingServiceProviders.length == _vm.serviceProviders.length) ? _c('li', {
    staticClass: "card-list__item"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("There are currently no available service providers")])])]) : _vm._e(), _vm._v(" "), (_vm.userMode == 'service-providers' && _vm.retailers === null) ? _c('li', {
    staticClass: "card-list__item"
  }, [_c('div', [_c('div', {
    staticClass: "layout layout--top layout--fill-container"
  }, [_c('div', {
    staticClass: "retailer-id"
  }, [_c('p', {
    staticClass: "instructions"
  }, [_vm._v("\n                              Please enter the id of the retailer you wish to connect to:"), _c('br'), _c('br'), _vm._v(" "), _c('small', [_vm._v("if you do not have the ID you may request it from the retailer directly...")])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retailerHumanId),
      expression: "retailerHumanId"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Retailer ID"
    },
    domProps: {
      "value": (_vm.retailerHumanId)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchRetailerHumanId()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.retailerHumanId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/img/icon__search.svg"
    },
    on: {
      "click": function($event) {
        _vm.searchRetailerHumanId()
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.retailers), function(r, index) {
    return (_vm.userMode == 'service-providers' && _vm.retailers !== null) ? _c('li', {
      staticClass: "card-list__item",
      class: {
        'active': (_vm.selectedRetailer && r) && _vm.selectedRetailer.id == r.id
      }
    }, [_c('div', [_c('div', {
      staticClass: "layout layout--top layout--fill-container"
    }, [_c('div', {
      staticClass: "layout__item service-provider__icon"
    }, [_c('user-icon', {
      attrs: {
        "fullname": r.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item service-provider__info desktop--three-quarters"
    }, [_c('h3', {
      staticClass: "in pointer text--truncate",
      on: {
        "click": function($event) {
          _vm.onViewRetailerClick(index)
        }
      }
    }, [_vm._v(_vm._s(r.name))]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_vm._v(_vm._s(r.address) + ", " + _vm._s(r.city) + ", " + _vm._s(r.postcode))]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + r.contactEmail
      }
    }, [_vm._v(_vm._s(r.contactEmail))])]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + r.contactTelephone
      }
    }, [_vm._v(_vm._s(r.contactTelephone))])]), _vm._v(" "), _c('span', {
      staticClass: "view-item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.onViewRetailerClick(index)
        }
      }
    }, [_vm._v("choose")])])])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.serviceProviders), function(sp, index) {
    return (_vm.userMode == 'normal' && _vm.existingServiceProviders.indexOf(sp.id) == -1) ? _c('li', {
      staticClass: "card-list__item",
      class: {
        'active': (_vm.selectedServiceProvider && sp) && _vm.selectedServiceProvider.id == sp.id
      }
    }, [_c('div', [_c('div', {
      staticClass: "layout layout--top layout--fill-container"
    }, [_c('div', {
      staticClass: "layout__item service-provider__icon"
    }, [_c('user-icon', {
      attrs: {
        "fullname": sp.name
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item service-provider__info desktop--three-quarters"
    }, [_c('h3', {
      staticClass: "in pointer text--truncate",
      on: {
        "click": function($event) {
          _vm.onViewServiceProviderClick(index)
        }
      }
    }, [_vm._v(_vm._s(sp.name))]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + sp.contactEmail
      }
    }, [_vm._v(_vm._s(sp.contactEmail))])]), _vm._v(" "), _c('p', {
      staticClass: "text--truncate"
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + sp.contactTelephone
      }
    }, [_vm._v(_vm._s(sp.contactTelephone))])]), _vm._v(" "), _c('span', {
      staticClass: "view-item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.onViewServiceProviderClick(index)
        }
      }
    }, [_vm._v("choose")])])])])])]) : _vm._e()
  })], 2) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "70%"
    }
  }, [(_vm.viewMode == null) ? _c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Responsibilities"), (_vm.selectedServiceProviderName) ? _c('span', [_vm._v(" - " + _vm._s(_vm.selectedServiceProviderName))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card__heading-actions"
  }, [((_vm.selectedServiceRelationship && _vm.selectedServiceRelationship.status == 'approved') ||
    (
      _vm.userMode === 'normal' &&
      _vm.selectedServiceRelationship !== null &&
      _vm.selectedServiceRelationship.origin == 'retailer'
    ) ||
    (
      _vm.userMode === 'service-providers' &&
      _vm.selectedServiceRelationship !== null &&
      _vm.selectedServiceRelationship.origin == 'service-provider'
    )) ? _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.deleteCurrentServiceRelationship()
      }
    }
  }, [_vm._v("Delete Connection")]) : _vm._e(), _vm._v(" "), (
    ((
        _vm.userMode === 'normal' &&
        _vm.selectedServiceRelationship &&
        _vm.selectedServiceRelationship.origin === 'service-provider'
      ) ||
      (
        _vm.userMode === 'service-providers' &&
        _vm.selectedServiceRelationship &&
        _vm.selectedServiceRelationship.origin === 'retailer'
      )) &&
    (
      _vm.selectedServiceRelationship &&
      _vm.selectedServiceRelationship.status != 'approved'
    )) ? _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.approveCurrentServiceRelationship()
      }
    }
  }, [_vm._v("Approve Connection")]) : _vm._e(), _vm._v(" "), (
    ((
        _vm.userMode === 'normal' &&
        _vm.selectedServiceRelationship &&
        _vm.selectedServiceRelationship.origin === 'service-provider'
      ) ||
      (
        _vm.userMode === 'service-providers' &&
        _vm.selectedServiceRelationship &&
        _vm.selectedServiceRelationship.origin === 'retailer'
      )) &&
    (
      _vm.selectedServiceRelationship &&
      _vm.selectedServiceRelationship.status != 'approved'
    )) ? _c('button', {
    staticClass: "button small",
    on: {
      "click": function($event) {
        _vm.declineCurrentServiceRelationship()
      }
    }
  }, [_vm._v("Decline Connection")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card__content padding"
  }, [(_vm.selectedServiceRelationship) ? _c('div', {
    staticClass: "layout layout--fill-container"
  }, _vm._l((_vm.serviceAreas), function(serviceArea, index) {
    return _c('div', {
      staticClass: "layout__item desktop--fifth service-area",
      staticStyle: {
        "height": "25%"
      }
    }, [_c('div', {
      staticClass: "service-area__info text--center",
      on: {
        "click": function($event) {}
      }
    }, [(!_vm.serviceAreaOn[index]) ? _c('img', {
      staticClass: "service-area__icon",
      attrs: {
        "src": serviceArea.imageOff
      }
    }) : _vm._e(), _vm._v(" "), (_vm.serviceAreaOn[index]) ? _c('img', {
      staticClass: "service-area__icon",
      attrs: {
        "src": serviceArea.imageOn
      }
    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(serviceArea.description))])])])
  })) : _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "height": "6%",
      "position": "relative"
    }
  }, [_vm._m(1)])])]) : _vm._e(), _vm._v(" "), (_vm.viewMode == 'add') ? _c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Add Responsibilities"), (_vm.selectedServiceProvider && _vm.selectedServiceProvider.name) ? _c('span', [_vm._v(" - " + _vm._s(_vm.selectedServiceProvider.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card__heading-actions"
  }, [_c('button', {
    staticClass: "button small",
    attrs: {
      "disabled": !_vm.isNewConnectionDirty
    },
    on: {
      "click": _vm.sendConnectionRequest
    }
  }, [_vm._v("Send Connection Request")]), _vm._v(" "), _c('button', {
    staticClass: "button small",
    on: {
      "click": _vm.cancelConnectionRequest
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "card__content padding"
  }, [(_vm.selectedServiceProvider || _vm.selectedRetailer) ? _c('div', {
    staticClass: "layout text--center",
    staticStyle: {
      "height": "7.5%"
    }
  }, [_c('button', {
    staticClass: "button small",
    staticStyle: {
      "min-width": "150px",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.setAllRelationshipAreasTrue()
      }
    }
  }, [_vm._v("Select All")])]) : _vm._e(), _vm._v(" "), (_vm.selectedServiceProvider || _vm.selectedRetailer) ? _c('div', {
    staticClass: "layout",
    staticStyle: {
      "height": "92.5%"
    }
  }, _vm._l((_vm.serviceAreas), function(serviceArea, index) {
    return _c('div', {
      staticClass: "layout__item desktop--fifth service-area",
      staticStyle: {
        "height": "25%"
      }
    }, [(!_vm.unavailableServiceAreas[serviceArea.name]) ? _c('div', {
      staticClass: "service-area__info text--center"
    }, [(!_vm.newRelationship[serviceArea.name]) ? _c('img', {
      staticClass: "service-area__icon pointer",
      attrs: {
        "src": serviceArea.imageOff
      },
      on: {
        "click": function($event) {
          _vm.setNewRelationshipArea(serviceArea, true)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.newRelationship[serviceArea.name]) ? _c('img', {
      staticClass: "service-area__icon pointer",
      attrs: {
        "src": serviceArea.imageOn
      },
      on: {
        "click": function($event) {
          _vm.setNewRelationshipArea(serviceArea, false)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(serviceArea.description))])]) : _c('div', {
      staticClass: "service-area__info text--center",
      on: {
        "click": function($event) {}
      }
    }, [_c('img', {
      staticClass: "service-area__icon disabled",
      attrs: {
        "src": serviceArea.imageOn
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(serviceArea.description))])])])
  })) : _vm._e()])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel--header"
  }, [_c('h1', [_vm._v("Connections")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Select a connection to view responsibilities...")])])
}]}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issue-status-icons"
  }, [_vm._l((_vm.issues), function(issue, index) {
    return (index < 3) ? _c('span', [_c('img', {
      staticClass: "issue-status-icons__icon",
      attrs: {
        "src": _vm.getIcon(issue.issueType)
      },
      on: {
        "mouseover": function($event) {
          _vm.currentPopover = index
        },
        "mouseleave": function($event) {
          _vm.currentPopover = null
        }
      }
    }), _vm._v(" "), (issue.serviceProvider != null) ? _c('div', {
      staticClass: "issue-status-icons__status-badge",
      class: issue.status
    }) : _vm._e(), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fade",
        "mode": "in-out"
      }
    }, [(_vm.currentPopover == index) ? _c('div', {
      staticClass: "popover"
    }, [_c('div', {
      staticClass: "popover__status-badge",
      class: issue.status
    }), _vm._v(" "), _c('span', {
      staticClass: "popover__status-text"
    }, [_vm._v(_vm._s(_vm.formatStatus(issue.status)))])]) : _vm._e()])], 1) : _vm._e()
  }), _vm._v(" "), ((_vm.issues.length - 1) > 2) ? _c('span', {
    staticClass: "issue-status-icons__more-text font-primary--bold"
  }, [_vm._v(" + " + _vm._s(_vm.issues.length - 3) + " more")]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-level-selector"
  }, [_c('div', {
    staticClass: "user-level-selector__label"
  }, [_c('span', {
    class: {
      'active': _vm.dropdownOpen === true
    },
    on: {
      "click": function($event) {
        _vm.toggleDropdown()
      }
    }
  }, [_vm._v(_vm._s(_vm.userLevel))]), _vm._v(" "), _c('span', {
    class: {
      'chevron': _vm.dropdownOpen === true
    }
  })]), _vm._v(" "), (_vm.dropdownOpen === true) ? _c('div', {
    staticClass: "user-level-selector__dropdown"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        _vm.saveUserLevel('admin')
      }
    }
  }, [_vm._v("Administator")]), _vm._v(" "), _c('p', {
    on: {
      "click": function($event) {
        _vm.saveUserLevel('standard')
      }
    }
  }, [_vm._v("Standard User")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("Select user role "), _c('span', {
    staticClass: "chevron"
  })])
}]}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dialog-panel"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.panelOpen && _vm.options && _vm.options.length > 0) ? _c('div', {
    staticClass: "dialog-panel__click-block"
  }) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.panelOpen) ? _c('div', {
    staticClass: "dialog-panel__container padding--large"
  }, [_c('img', {
    attrs: {
      "src": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "font-secondary"
  }, [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), (_vm.options && _vm.options.length > 0) ? _c('ul', {
    staticClass: "options list-inline"
  }, _vm._l((_vm.options), function(option, index) {
    return _c('li', {
      staticClass: "options__item"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.onOptionClick(index)
        }
      }
    }, [_vm._v(_vm._s(option.optionText))])])
  })) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('div', {
    staticClass: "panel panel--header"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('h1', [(_vm.pageTitle !== null) ? _c('span', [_vm._v(_vm._s(_vm.pageTitle) + " | ")]) : _vm._e(), _vm._v("Reviews")])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item desktop--half"
  }, [_c('div', {
    staticClass: "panel__actions text--right"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "search__icon",
    on: {
      "click": function($event) {
        _vm.openSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__search.svg"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "searchInput",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearch),
      expression: "showSearch"
    }],
    staticClass: "search__close",
    on: {
      "click": function($event) {
        _vm.closeSearch()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icon__close--dark.svg"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "row row--top"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('div', {
    staticClass: "layout__item"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.retailer && _vm.retailer.name) ? _c('h2', {
    staticClass: "card__heading"
  }, [_vm._v(_vm._s(_vm.retailer.name))]) : _c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("All Clients")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar"
    }],
    staticClass: "scrollable__wrapper"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('transition-group', {
    staticClass: "list-bare list-hover card-list card-list--11cards",
    attrs: {
      "name": "staggered-fade",
      "tag": "ul",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.search), function(r, index) {
    return _c('li', {
      key: index,
      staticClass: "card-list__item review-link",
      attrs: {
        "data-index": index
      },
      on: {
        "click": function($event) {
          _vm.goToReview(r.id)
        }
      }
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "15%"
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(r.retailer && r.retailer.name) ? _c('p', {
      staticClass: "font-size--small"
    }, [_vm._v(_vm._s(r.retailer.name))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--center",
      staticStyle: {
        "width": "5%"
      }
    }, [_c('review-mood', {
      attrs: {
        "mood": r.rating
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--center",
      staticStyle: {
        "width": "7.5%"
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(r.washroom) ? _c('p', [_vm._v(_vm._s(r.washroom.humanId))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--center",
      staticStyle: {
        "width": "5%"
      }
    }, [(r.washroom != 0) ? _c('washroom-icon', {
      attrs: {
        "washroom": _vm.filterWashrooms(r)
      }
    }) : _c('washroom-icon', {
      attrs: {
        "washroom-type": r.washroomType
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "22.5%"
      }
    }, [_c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [(r.retailer && r.retailer.address) ? _c('p', {
      staticClass: "text--truncate"
    }, [_c('img', {
      staticClass: "address-icon",
      attrs: {
        "src": "/static/img/pin.svg"
      }
    }), _vm._v(" " + _vm._s(r.retailer.address) + ", " + _vm._s(r.retailer.city) + ", " + _vm._s(r.retailer.postcode))]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "10%"
      }
    }, [_vm._v("\n                              " + _vm._s(_vm._f("date")(r.createdAt, '%d.%m.%Y')) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "20%"
      }
    }, [(_vm.userGroup == 'service-providers') ? [_c('issue-status-icons', {
      attrs: {
        "issues": _vm.filterServiceProviderIssues(r.issues)
      }
    })] : [_c('issue-status-icons', {
      attrs: {
        "issues": r.issues
      }
    })]], 2), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "15%"
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": r.overallRating
      }
    })], 1)])])])
  }))], 1)])])])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issue-badge"
  }, [_c('div', {
    staticClass: "column--left"
  }, [_c('img', {
    staticClass: "issue-badge__icon",
    attrs: {
      "src": _vm.getIcon(_vm.issue.issueType)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "issue-badge__text"
  }, [_c('div', {
    staticClass: "issue-badge__text-type"
  }, [_vm._v(_vm._s(_vm.getType(_vm.issue.issueType)))]), _vm._v(" "), (_vm.issue.serviceProvider != null || _vm.userGroup == 'hsg-admins') ? _c('div', {
    staticClass: "issue-badge__issue-status"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.issueSelectorOpen === true) ? _c('div', {
    staticClass: "issue-badge__issue-status-selector"
  }, [_c('p', {
    staticClass: "title",
    on: {
      "click": function($event) {
        _vm.issueSelectorOpen = false
      }
    }
  }, [_vm._v("Select issue status "), _c('span', {
    staticClass: "chevron"
  })]), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('unread')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge unread"
  }), _vm._v("Unread")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolved-by-retailer')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolved-by-retailer"
  }), _vm._v("Resolved By Retailer")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('confirmed')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge confirmed"
  }), _vm._v("Confirmed")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('denied')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge denied"
  }), _vm._v("Denied")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'service-providers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolution-in-progress')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolution-in-progress"
  }), _vm._v("Resolution In Progress")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'service-providers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolution-awaiting-approval')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolution-awaiting-approval"
  }), _vm._v("Resolution Awaiting Approval")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolution-accepted')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolution-accepted"
  }), _vm._v("Resolution Accepted")]) : _vm._e(), _vm._v(" "), (_vm.userGroup == 'hsg-admins' || _vm.userGroup == 'multi-site-retailers' || _vm.userGroup == 'retailers') ? _c('p', {
    on: {
      "click": function($event) {
        _vm.setIssueStatus('resolution-denied')
      }
    }
  }, [_c('span', {
    staticClass: "status-badge resolution-denied"
  }), _vm._v("Resolution Denied")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "issue-badge__issue-status-text",
    class: {
      'disabled': _vm.userGroup == 'multi-site-retailers'
    },
    on: {
      "click": function($event) {
        _vm.openIssueSelector()
      }
    }
  }, [_vm._v("\n          Status: "), _c('span', {
    staticClass: "capitalise"
  }, [_c('span', {
    staticClass: "status-badge",
    class: _vm.issue.status
  }), _vm._v(_vm._s(_vm.issue.status))]), _vm._v(" "), (_vm.userGroup != 'multi-site-retailers') ? _c('span', {
    staticClass: "chevron"
  }) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.issue.issueType == 'customsuggestion') ? _c('div', {
    staticClass: "issue-badge__text-custom-suggestion"
  }, [_vm._v("\n        " + _vm._s(_vm.issue.customSuggestionText) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column--right"
  }, [(_vm.issue.s3ImageUrl) ? _c('div', {
    staticClass: "review-image",
    style: ({
      backgroundImage: 'url(' + _vm.image + ')'
    }),
    on: {
      "click": function($event) {
        _vm.showOverlay = true
      }
    }
  }) : _c('div', {
    staticClass: "review-image placeholder",
    style: ({
      backgroundImage: 'url(/static/img/image-placeholder.svg)'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "image-link"
  }, [_c('p', {
    class: {
      disabled: !_vm.issue.s3ImageUrl
    },
    on: {
      "click": function($event) {
        _vm.showOverlay = true
      }
    }
  }, [_vm._v("View Image")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [(_vm.showOverlay === true) ? _c('div', {
    staticClass: "image-overlay",
    on: {
      "click": function($event) {
        _vm.showOverlay = false
      }
    }
  }, [_c('div', {
    staticClass: "image-container",
    on: {
      "click": function($event) {
        _vm.preventBubble($event)
      }
    }
  }, [_c('img', {
    staticClass: "close",
    attrs: {
      "src": "/static/img/icon__close--light.svg"
    },
    on: {
      "click": function($event) {
        _vm.showOverlay = false
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.image
    },
    on: {
      "click": function($event) {
        _vm.preventBubble($event)
      }
    }
  })])]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-stat"
  }, [_c('h3', {
    staticClass: "change-stat__heading text--center"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('div', {
    staticClass: "change-stat__value"
  }, [_c('div', {
    staticClass: "font-condensed"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.direction == 'up') ? _c('div', {
    staticClass: "change-stat__direction--up"
  }) : _vm._e(), _vm._v(" "), (_vm.direction == 'down') ? _c('div', {
    staticClass: "change-stat__direction--down"
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('div', {
    key: "forgot",
    staticClass: "login padding--large text--center",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.doSavePassword()
      }
    }
  }, [_c('div', {
    staticClass: "form login__form"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/logo-light.svg"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.tokenValid && !_vm.passwordSaved) ? _c('div', {
    key: "notsaved"
  }, [_c('p', {
    staticClass: "message text--center"
  }, [_vm._v("Enter your new password")]), _vm._v(" "), _c('div', {
    staticClass: "input-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    ref: "newPassword",
    staticClass: "login__username reset",
    attrs: {
      "placeholder": "New Password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticClass: "login__submit",
    attrs: {
      "type": "submit",
      "value": "Go"
    },
    on: {
      "click": function($event) {
        _vm.doSavePassword()
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "login__forgotten-password",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.mode = 'login'
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e(), _vm._v(" "), (_vm.tokenValid && _vm.passwordSaved) ? _c('div', {
    key: "saved"
  }, [_c('p', {
    staticClass: "message text--center"
  }, [_vm._v("Your password has been set, you may now ...")]), _vm._v(" "), _c('a', {
    staticClass: "login__forgotten-password",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Proceed to Login")])]) : _vm._e()])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-page",
    attrs: {
      "id": "service-provider"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel panel--main"
  }, [_c('div', {
    ref: "container",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "layout layout--fill-container"
  }, [_c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "33.333%"
    }
  }, [_c('div', {
    staticClass: "layout--vertical"
  }, [_c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Contact Details")]), _vm._v(" "), (_vm.serviceProvider) ? _c('div', {
    staticClass: "card__content"
  }, [_c('div', {
    staticClass: "contact-info"
  }, [_c('h3', {
    staticClass: "service-provider__name"
  }, [_vm._v(_vm._s(_vm.serviceProvider.name))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.serviceProvider.adminContactName))]), _vm._v(" "), _c('ul', {
    staticClass: "service-provider__address"
  }, [_c('li', [_vm._v(_vm._s(_vm.serviceProvider.adminAddress))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.serviceProvider.adminCity) + "," + _vm._s(_vm.serviceProvider.adminPostcode))])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.serviceProvider.adminContactEmail
    }
  }, [_vm._v(_vm._s(_vm.serviceProvider.adminContactEmail))])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.serviceProvider.adminContactTelephone
    }
  }, [_vm._v(_vm._s(_vm.serviceProvider.adminContactTelephone))])])])]) : _vm._e()])]), _vm._v(" "), (_vm.userGroup !== 'multi-site-retailers') ? _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Team")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('scroller', [(_vm.serviceProvider) ? _c('ul', {
    staticClass: "list-bare card-list card-list--5cards"
  }, _vm._l((_vm.serviceProvider.team), function(teamMember) {
    return _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('user-icon', {
      attrs: {
        "fullname": teamMember.fullName
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "50%"
      }
    }, [_vm._v("\n                              " + _vm._s(teamMember.fullName) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--right",
      staticStyle: {
        "width": "30%"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/account',
          params: {}
        }
      }
    }, [_vm._v("Edit")])], 1)])])])
  })) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.userGroup === 'multi-site-retailers') ? _c('div', {
    staticClass: "layout__item--vertical",
    staticStyle: {
      "height": "50%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Responsibilities")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [(_vm.selectedServiceRelationship) ? _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, _vm._l((_vm.selectedServiceRelationship), function(value, key) {
    return (value === true) ? _c('span', {
      key: key,
      staticClass: "service-area"
    }, [_c('img', {
      staticClass: "service-area__icon",
      attrs: {
        "src": _vm.getServiceArea(key).imageOn
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getServiceArea(key).description))])]) : _vm._e()
  })) : _c('div', [_c('div', {
    staticClass: "center-middle text--center"
  }, [_vm._v("\n                      Select a retailer to view responsibilities for...\n                    ")])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "layout__item",
    staticStyle: {
      "width": "66.666%"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h2', {
    staticClass: "card__heading"
  }, [_vm._v("Retailers")]), _vm._v(" "), _c('div', {
    staticClass: "card__content"
  }, [_c('scroller', [(_vm.serviceRelationships) ? _c('ul', {
    staticClass: "list-bare card-list card-list--11cards"
  }, _vm._l((_vm.serviceRelationships), function(serviceRelationship) {
    return _c('li', {
      staticClass: "card-list__item"
    }, [_c('div', {
      staticClass: "centered--vertical"
    }, [_c('div', {
      staticClass: "layout layout--middle"
    }, [_c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "32.5%"
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/retailers/' + serviceRelationship.retailer.id
      }
    }, [_c('h3', {
      staticClass: "retailer__name"
    }, [_vm._v(_vm._s(serviceRelationship.retailer.name))])])], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "32.55%"
      }
    }, [_c('p', [_c('img', {
      staticClass: "address-icon",
      attrs: {
        "src": "/static/img/pin.svg"
      }
    }), _vm._v(_vm._s(serviceRelationship.retailer.address) + ", " + _vm._s(serviceRelationship.retailer.city) + ", " + _vm._s(serviceRelationship.retailer.postcode))])]), _vm._v(" "), _c('div', {
      staticClass: "layout__item",
      staticStyle: {
        "width": "20%"
      }
    }, [_c('review-stars', {
      attrs: {
        "stars": 5,
        "active": 4
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "layout__item text--center",
      staticStyle: {
        "width": "14%"
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectedServiceRelationship = serviceRelationship
        }
      }
    }, [_vm._v("View Responsibilities")])])])])])
  })) : _vm._e()])], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel--header"
  }, [_c('h1', [_vm._v("Service Providers")])])
}]}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-view-map"
  }, [_c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 15,
      "options": {
        'styles': _vm.styles,
        'disableDefaultUI': true,
        'zoomControl': true
      }
    }
  }, [_vm._l((_vm.markers), function(marker, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": marker.position,
        "clickable": true,
        "draggable": false,
        "icon": {
          url: '/static/img/icon__map-pin.png'
        }
      },
      on: {
        "click": function($event) {
          _vm.onMarkerClick(marker.position, index)
        }
      }
    })
  }), _vm._v(" "), (_vm.infoWinOpen && _vm.selectedItemPosition) ? _c('gmap-info-window', {
    attrs: {
      "position": _vm.selectedItemPosition
    },
    on: {
      "closeclick": function($event) {
        _vm.infoWinOpen = false
      }
    }
  }, [_c('h3', {
    staticClass: "firstHeading",
    attrs: {
      "id": "firstHeading"
    }
  }, [_vm._v(_vm._s(_vm.selectedItem.name))]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        'name': 'Retailers Detail',
        'params': {
          'id': _vm.selectedItem.id
        }
      }
    }
  }, [_vm._v("View")])], 1)]) : _vm._e()], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-count"
  }, [_c('div', {
    staticClass: "site-count__circle"
  }, [_c('span', {
    staticClass: "site-count__number font-primary--bold"
  }, [_vm._v(_vm._s(_vm.count))])]), _vm._v(" "), _c('span', {
    staticClass: "site-count__supporting-text"
  }, [_vm._v("Washrooms")])])
},staticRenderFns: []}

/***/ }),
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[311]);


// WEBPACK FOOTER //
// static/js/app.7960ac04d61ba3b4e4ba.js